import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = { context: { clientName: 'research' } } as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  float8: any;
  jsonb: any;
  timestamp: any;
  timestamptz: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq: InputMaybe<Scalars['Boolean']>;
  _gt: InputMaybe<Scalars['Boolean']>;
  _gte: InputMaybe<Scalars['Boolean']>;
  _in: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['Boolean']>;
  _lte: InputMaybe<Scalars['Boolean']>;
  _neq: InputMaybe<Scalars['Boolean']>;
  _nin: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq: InputMaybe<Scalars['Int']>;
  _gt: InputMaybe<Scalars['Int']>;
  _gte: InputMaybe<Scalars['Int']>;
  _in: InputMaybe<Array<Scalars['Int']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['Int']>;
  _lte: InputMaybe<Scalars['Int']>;
  _neq: InputMaybe<Scalars['Int']>;
  _nin: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq: InputMaybe<Scalars['String']>;
  _gt: InputMaybe<Scalars['String']>;
  _gte: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike: InputMaybe<Scalars['String']>;
  _in: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex: InputMaybe<Scalars['String']>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like: InputMaybe<Scalars['String']>;
  _lt: InputMaybe<Scalars['String']>;
  _lte: InputMaybe<Scalars['String']>;
  _neq: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike: InputMaybe<Scalars['String']>;
  _nin: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar: InputMaybe<Scalars['String']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq: InputMaybe<Scalars['float8']>;
  _gt: InputMaybe<Scalars['float8']>;
  _gte: InputMaybe<Scalars['float8']>;
  _in: InputMaybe<Array<Scalars['float8']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['float8']>;
  _lte: InputMaybe<Scalars['float8']>;
  _neq: InputMaybe<Scalars['float8']>;
  _nin: InputMaybe<Array<Scalars['float8']>>;
};

export type Jsonb_Cast_Exp = {
  String: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains: InputMaybe<Scalars['jsonb']>;
  _eq: InputMaybe<Scalars['jsonb']>;
  _gt: InputMaybe<Scalars['jsonb']>;
  _gte: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any: InputMaybe<Array<Scalars['String']>>;
  _in: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['jsonb']>;
  _lte: InputMaybe<Scalars['jsonb']>;
  _neq: InputMaybe<Scalars['jsonb']>;
  _nin: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "outreach.google_locations" */
  delete_outreach_google_locations: Maybe<Outreach_Google_Locations_Mutation_Response>;
  /** delete data from the table: "outreach.partners" */
  delete_outreach_partners: Maybe<Outreach_Partners_Mutation_Response>;
  /** delete data from the table: "research._airbyte_raw_cannabinoids" */
  delete_research__airbyte_raw_cannabinoids: Maybe<Research__Airbyte_Raw_Cannabinoids_Mutation_Response>;
  /** delete single row from the table: "research._airbyte_raw_cannabinoids" */
  delete_research__airbyte_raw_cannabinoids_by_pk: Maybe<Research__Airbyte_Raw_Cannabinoids>;
  /** delete data from the table: "research._airbyte_raw_medical_conditions" */
  delete_research__airbyte_raw_medical_conditions: Maybe<Research__Airbyte_Raw_Medical_Conditions_Mutation_Response>;
  /** delete single row from the table: "research._airbyte_raw_medical_conditions" */
  delete_research__airbyte_raw_medical_conditions_by_pk: Maybe<Research__Airbyte_Raw_Medical_Conditions>;
  /** delete data from the table: "research._airbyte_raw_organ_systems" */
  delete_research__airbyte_raw_organ_systems: Maybe<Research__Airbyte_Raw_Organ_Systems_Mutation_Response>;
  /** delete single row from the table: "research._airbyte_raw_organ_systems" */
  delete_research__airbyte_raw_organ_systems_by_pk: Maybe<Research__Airbyte_Raw_Organ_Systems>;
  /** delete data from the table: "research._airbyte_raw_studies" */
  delete_research__airbyte_raw_studies: Maybe<Research__Airbyte_Raw_Studies_Mutation_Response>;
  /** delete single row from the table: "research._airbyte_raw_studies" */
  delete_research__airbyte_raw_studies_by_pk: Maybe<Research__Airbyte_Raw_Studies>;
  /** delete data from the table: "research._airbyte_raw_terpenes" */
  delete_research__airbyte_raw_terpenes: Maybe<Research__Airbyte_Raw_Terpenes_Mutation_Response>;
  /** delete single row from the table: "research._airbyte_raw_terpenes" */
  delete_research__airbyte_raw_terpenes_by_pk: Maybe<Research__Airbyte_Raw_Terpenes>;
  /** delete data from the table: "research.administrations" */
  delete_research_administrations: Maybe<Research_Administrations_Mutation_Response>;
  /** delete data from the table: "research.cannabinoids" */
  delete_research_cannabinoids: Maybe<Research_Cannabinoids_Mutation_Response>;
  /** delete data from the table: "research.cannabinoids_studies" */
  delete_research_cannabinoids_studies: Maybe<Research_Cannabinoids_Studies_Mutation_Response>;
  /** delete data from the table: "research.chemotypes" */
  delete_research_chemotypes: Maybe<Research_Chemotypes_Mutation_Response>;
  /** delete data from the table: "research.ligands" */
  delete_research_ligands: Maybe<Research_Ligands_Mutation_Response>;
  /** delete data from the table: "research.locations" */
  delete_research_locations: Maybe<Research_Locations_Mutation_Response>;
  /** delete data from the table: "research.medical_conditions" */
  delete_research_medical_conditions: Maybe<Research_Medical_Conditions_Mutation_Response>;
  /** delete data from the table: "research.medical_conditions_clinicial_dosing" */
  delete_research_medical_conditions_clinicial_dosing: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Mutation_Response>;
  /** delete data from the table: "research.medical_conditions_state_of_science" */
  delete_research_medical_conditions_state_of_science: Maybe<Research_Medical_Conditions_State_Of_Science_Mutation_Response>;
  /** delete data from the table: "research.medical_conditions_studies" */
  delete_research_medical_conditions_studies: Maybe<Research_Medical_Conditions_Studies_Mutation_Response>;
  /** delete data from the table: "research.organ_systems" */
  delete_research_organ_systems: Maybe<Research_Organ_Systems_Mutation_Response>;
  /** delete data from the table: "research.organ_systems_studies" */
  delete_research_organ_systems_studies: Maybe<Research_Organ_Systems_Studies_Mutation_Response>;
  /** delete data from the table: "research.receptors" */
  delete_research_receptors: Maybe<Research_Receptors_Mutation_Response>;
  /** delete data from the table: "research.studies" */
  delete_research_studies: Maybe<Research_Studies_Mutation_Response>;
  /** delete data from the table: "research.studies_administration" */
  delete_research_studies_administration: Maybe<Research_Studies_Administration_Mutation_Response>;
  /** delete data from the table: "research.studies_chemotypes" */
  delete_research_studies_chemotypes: Maybe<Research_Studies_Chemotypes_Mutation_Response>;
  /** delete data from the table: "research.studies_ligands" */
  delete_research_studies_ligands: Maybe<Research_Studies_Ligands_Mutation_Response>;
  /** delete data from the table: "research.studies_locations" */
  delete_research_studies_locations: Maybe<Research_Studies_Locations_Mutation_Response>;
  /** delete data from the table: "research.studies_receptors" */
  delete_research_studies_receptors: Maybe<Research_Studies_Receptors_Mutation_Response>;
  /** delete data from the table: "research.terpenes" */
  delete_research_terpenes: Maybe<Research_Terpenes_Mutation_Response>;
  /** delete data from the table: "research.terpenes_studies" */
  delete_research_terpenes_studies: Maybe<Research_Terpenes_Studies_Mutation_Response>;
  /** insert data into the table: "outreach.google_locations" */
  insert_outreach_google_locations: Maybe<Outreach_Google_Locations_Mutation_Response>;
  /** insert a single row into the table: "outreach.google_locations" */
  insert_outreach_google_locations_one: Maybe<Outreach_Google_Locations>;
  /** insert data into the table: "outreach.partners" */
  insert_outreach_partners: Maybe<Outreach_Partners_Mutation_Response>;
  /** insert a single row into the table: "outreach.partners" */
  insert_outreach_partners_one: Maybe<Outreach_Partners>;
  /** insert data into the table: "research._airbyte_raw_cannabinoids" */
  insert_research__airbyte_raw_cannabinoids: Maybe<Research__Airbyte_Raw_Cannabinoids_Mutation_Response>;
  /** insert a single row into the table: "research._airbyte_raw_cannabinoids" */
  insert_research__airbyte_raw_cannabinoids_one: Maybe<Research__Airbyte_Raw_Cannabinoids>;
  /** insert data into the table: "research._airbyte_raw_medical_conditions" */
  insert_research__airbyte_raw_medical_conditions: Maybe<Research__Airbyte_Raw_Medical_Conditions_Mutation_Response>;
  /** insert a single row into the table: "research._airbyte_raw_medical_conditions" */
  insert_research__airbyte_raw_medical_conditions_one: Maybe<Research__Airbyte_Raw_Medical_Conditions>;
  /** insert data into the table: "research._airbyte_raw_organ_systems" */
  insert_research__airbyte_raw_organ_systems: Maybe<Research__Airbyte_Raw_Organ_Systems_Mutation_Response>;
  /** insert a single row into the table: "research._airbyte_raw_organ_systems" */
  insert_research__airbyte_raw_organ_systems_one: Maybe<Research__Airbyte_Raw_Organ_Systems>;
  /** insert data into the table: "research._airbyte_raw_studies" */
  insert_research__airbyte_raw_studies: Maybe<Research__Airbyte_Raw_Studies_Mutation_Response>;
  /** insert a single row into the table: "research._airbyte_raw_studies" */
  insert_research__airbyte_raw_studies_one: Maybe<Research__Airbyte_Raw_Studies>;
  /** insert data into the table: "research._airbyte_raw_terpenes" */
  insert_research__airbyte_raw_terpenes: Maybe<Research__Airbyte_Raw_Terpenes_Mutation_Response>;
  /** insert a single row into the table: "research._airbyte_raw_terpenes" */
  insert_research__airbyte_raw_terpenes_one: Maybe<Research__Airbyte_Raw_Terpenes>;
  /** insert data into the table: "research.administrations" */
  insert_research_administrations: Maybe<Research_Administrations_Mutation_Response>;
  /** insert a single row into the table: "research.administrations" */
  insert_research_administrations_one: Maybe<Research_Administrations>;
  /** insert data into the table: "research.cannabinoids" */
  insert_research_cannabinoids: Maybe<Research_Cannabinoids_Mutation_Response>;
  /** insert a single row into the table: "research.cannabinoids" */
  insert_research_cannabinoids_one: Maybe<Research_Cannabinoids>;
  /** insert data into the table: "research.cannabinoids_studies" */
  insert_research_cannabinoids_studies: Maybe<Research_Cannabinoids_Studies_Mutation_Response>;
  /** insert a single row into the table: "research.cannabinoids_studies" */
  insert_research_cannabinoids_studies_one: Maybe<Research_Cannabinoids_Studies>;
  /** insert data into the table: "research.chemotypes" */
  insert_research_chemotypes: Maybe<Research_Chemotypes_Mutation_Response>;
  /** insert a single row into the table: "research.chemotypes" */
  insert_research_chemotypes_one: Maybe<Research_Chemotypes>;
  /** insert data into the table: "research.ligands" */
  insert_research_ligands: Maybe<Research_Ligands_Mutation_Response>;
  /** insert a single row into the table: "research.ligands" */
  insert_research_ligands_one: Maybe<Research_Ligands>;
  /** insert data into the table: "research.locations" */
  insert_research_locations: Maybe<Research_Locations_Mutation_Response>;
  /** insert a single row into the table: "research.locations" */
  insert_research_locations_one: Maybe<Research_Locations>;
  /** insert data into the table: "research.medical_conditions" */
  insert_research_medical_conditions: Maybe<Research_Medical_Conditions_Mutation_Response>;
  /** insert data into the table: "research.medical_conditions_clinicial_dosing" */
  insert_research_medical_conditions_clinicial_dosing: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Mutation_Response>;
  /** insert a single row into the table: "research.medical_conditions_clinicial_dosing" */
  insert_research_medical_conditions_clinicial_dosing_one: Maybe<Research_Medical_Conditions_Clinicial_Dosing>;
  /** insert a single row into the table: "research.medical_conditions" */
  insert_research_medical_conditions_one: Maybe<Research_Medical_Conditions>;
  /** insert data into the table: "research.medical_conditions_state_of_science" */
  insert_research_medical_conditions_state_of_science: Maybe<Research_Medical_Conditions_State_Of_Science_Mutation_Response>;
  /** insert a single row into the table: "research.medical_conditions_state_of_science" */
  insert_research_medical_conditions_state_of_science_one: Maybe<Research_Medical_Conditions_State_Of_Science>;
  /** insert data into the table: "research.medical_conditions_studies" */
  insert_research_medical_conditions_studies: Maybe<Research_Medical_Conditions_Studies_Mutation_Response>;
  /** insert a single row into the table: "research.medical_conditions_studies" */
  insert_research_medical_conditions_studies_one: Maybe<Research_Medical_Conditions_Studies>;
  /** insert data into the table: "research.organ_systems" */
  insert_research_organ_systems: Maybe<Research_Organ_Systems_Mutation_Response>;
  /** insert a single row into the table: "research.organ_systems" */
  insert_research_organ_systems_one: Maybe<Research_Organ_Systems>;
  /** insert data into the table: "research.organ_systems_studies" */
  insert_research_organ_systems_studies: Maybe<Research_Organ_Systems_Studies_Mutation_Response>;
  /** insert a single row into the table: "research.organ_systems_studies" */
  insert_research_organ_systems_studies_one: Maybe<Research_Organ_Systems_Studies>;
  /** insert data into the table: "research.receptors" */
  insert_research_receptors: Maybe<Research_Receptors_Mutation_Response>;
  /** insert a single row into the table: "research.receptors" */
  insert_research_receptors_one: Maybe<Research_Receptors>;
  /** insert data into the table: "research.studies" */
  insert_research_studies: Maybe<Research_Studies_Mutation_Response>;
  /** insert data into the table: "research.studies_administration" */
  insert_research_studies_administration: Maybe<Research_Studies_Administration_Mutation_Response>;
  /** insert a single row into the table: "research.studies_administration" */
  insert_research_studies_administration_one: Maybe<Research_Studies_Administration>;
  /** insert data into the table: "research.studies_chemotypes" */
  insert_research_studies_chemotypes: Maybe<Research_Studies_Chemotypes_Mutation_Response>;
  /** insert a single row into the table: "research.studies_chemotypes" */
  insert_research_studies_chemotypes_one: Maybe<Research_Studies_Chemotypes>;
  /** insert data into the table: "research.studies_ligands" */
  insert_research_studies_ligands: Maybe<Research_Studies_Ligands_Mutation_Response>;
  /** insert a single row into the table: "research.studies_ligands" */
  insert_research_studies_ligands_one: Maybe<Research_Studies_Ligands>;
  /** insert data into the table: "research.studies_locations" */
  insert_research_studies_locations: Maybe<Research_Studies_Locations_Mutation_Response>;
  /** insert a single row into the table: "research.studies_locations" */
  insert_research_studies_locations_one: Maybe<Research_Studies_Locations>;
  /** insert a single row into the table: "research.studies" */
  insert_research_studies_one: Maybe<Research_Studies>;
  /** insert data into the table: "research.studies_receptors" */
  insert_research_studies_receptors: Maybe<Research_Studies_Receptors_Mutation_Response>;
  /** insert a single row into the table: "research.studies_receptors" */
  insert_research_studies_receptors_one: Maybe<Research_Studies_Receptors>;
  /** insert data into the table: "research.terpenes" */
  insert_research_terpenes: Maybe<Research_Terpenes_Mutation_Response>;
  /** insert a single row into the table: "research.terpenes" */
  insert_research_terpenes_one: Maybe<Research_Terpenes>;
  /** insert data into the table: "research.terpenes_studies" */
  insert_research_terpenes_studies: Maybe<Research_Terpenes_Studies_Mutation_Response>;
  /** insert a single row into the table: "research.terpenes_studies" */
  insert_research_terpenes_studies_one: Maybe<Research_Terpenes_Studies>;
  /** update data of the table: "outreach.google_locations" */
  update_outreach_google_locations: Maybe<Outreach_Google_Locations_Mutation_Response>;
  /** update multiples rows of table: "outreach.google_locations" */
  update_outreach_google_locations_many: Maybe<
    Array<Maybe<Outreach_Google_Locations_Mutation_Response>>
  >;
  /** update data of the table: "outreach.partners" */
  update_outreach_partners: Maybe<Outreach_Partners_Mutation_Response>;
  /** update multiples rows of table: "outreach.partners" */
  update_outreach_partners_many: Maybe<
    Array<Maybe<Outreach_Partners_Mutation_Response>>
  >;
  /** update data of the table: "research._airbyte_raw_cannabinoids" */
  update_research__airbyte_raw_cannabinoids: Maybe<Research__Airbyte_Raw_Cannabinoids_Mutation_Response>;
  /** update single row of the table: "research._airbyte_raw_cannabinoids" */
  update_research__airbyte_raw_cannabinoids_by_pk: Maybe<Research__Airbyte_Raw_Cannabinoids>;
  /** update multiples rows of table: "research._airbyte_raw_cannabinoids" */
  update_research__airbyte_raw_cannabinoids_many: Maybe<
    Array<Maybe<Research__Airbyte_Raw_Cannabinoids_Mutation_Response>>
  >;
  /** update data of the table: "research._airbyte_raw_medical_conditions" */
  update_research__airbyte_raw_medical_conditions: Maybe<Research__Airbyte_Raw_Medical_Conditions_Mutation_Response>;
  /** update single row of the table: "research._airbyte_raw_medical_conditions" */
  update_research__airbyte_raw_medical_conditions_by_pk: Maybe<Research__Airbyte_Raw_Medical_Conditions>;
  /** update multiples rows of table: "research._airbyte_raw_medical_conditions" */
  update_research__airbyte_raw_medical_conditions_many: Maybe<
    Array<Maybe<Research__Airbyte_Raw_Medical_Conditions_Mutation_Response>>
  >;
  /** update data of the table: "research._airbyte_raw_organ_systems" */
  update_research__airbyte_raw_organ_systems: Maybe<Research__Airbyte_Raw_Organ_Systems_Mutation_Response>;
  /** update single row of the table: "research._airbyte_raw_organ_systems" */
  update_research__airbyte_raw_organ_systems_by_pk: Maybe<Research__Airbyte_Raw_Organ_Systems>;
  /** update multiples rows of table: "research._airbyte_raw_organ_systems" */
  update_research__airbyte_raw_organ_systems_many: Maybe<
    Array<Maybe<Research__Airbyte_Raw_Organ_Systems_Mutation_Response>>
  >;
  /** update data of the table: "research._airbyte_raw_studies" */
  update_research__airbyte_raw_studies: Maybe<Research__Airbyte_Raw_Studies_Mutation_Response>;
  /** update single row of the table: "research._airbyte_raw_studies" */
  update_research__airbyte_raw_studies_by_pk: Maybe<Research__Airbyte_Raw_Studies>;
  /** update multiples rows of table: "research._airbyte_raw_studies" */
  update_research__airbyte_raw_studies_many: Maybe<
    Array<Maybe<Research__Airbyte_Raw_Studies_Mutation_Response>>
  >;
  /** update data of the table: "research._airbyte_raw_terpenes" */
  update_research__airbyte_raw_terpenes: Maybe<Research__Airbyte_Raw_Terpenes_Mutation_Response>;
  /** update single row of the table: "research._airbyte_raw_terpenes" */
  update_research__airbyte_raw_terpenes_by_pk: Maybe<Research__Airbyte_Raw_Terpenes>;
  /** update multiples rows of table: "research._airbyte_raw_terpenes" */
  update_research__airbyte_raw_terpenes_many: Maybe<
    Array<Maybe<Research__Airbyte_Raw_Terpenes_Mutation_Response>>
  >;
  /** update data of the table: "research.administrations" */
  update_research_administrations: Maybe<Research_Administrations_Mutation_Response>;
  /** update multiples rows of table: "research.administrations" */
  update_research_administrations_many: Maybe<
    Array<Maybe<Research_Administrations_Mutation_Response>>
  >;
  /** update data of the table: "research.cannabinoids" */
  update_research_cannabinoids: Maybe<Research_Cannabinoids_Mutation_Response>;
  /** update multiples rows of table: "research.cannabinoids" */
  update_research_cannabinoids_many: Maybe<
    Array<Maybe<Research_Cannabinoids_Mutation_Response>>
  >;
  /** update data of the table: "research.cannabinoids_studies" */
  update_research_cannabinoids_studies: Maybe<Research_Cannabinoids_Studies_Mutation_Response>;
  /** update multiples rows of table: "research.cannabinoids_studies" */
  update_research_cannabinoids_studies_many: Maybe<
    Array<Maybe<Research_Cannabinoids_Studies_Mutation_Response>>
  >;
  /** update data of the table: "research.chemotypes" */
  update_research_chemotypes: Maybe<Research_Chemotypes_Mutation_Response>;
  /** update multiples rows of table: "research.chemotypes" */
  update_research_chemotypes_many: Maybe<
    Array<Maybe<Research_Chemotypes_Mutation_Response>>
  >;
  /** update data of the table: "research.ligands" */
  update_research_ligands: Maybe<Research_Ligands_Mutation_Response>;
  /** update multiples rows of table: "research.ligands" */
  update_research_ligands_many: Maybe<
    Array<Maybe<Research_Ligands_Mutation_Response>>
  >;
  /** update data of the table: "research.locations" */
  update_research_locations: Maybe<Research_Locations_Mutation_Response>;
  /** update multiples rows of table: "research.locations" */
  update_research_locations_many: Maybe<
    Array<Maybe<Research_Locations_Mutation_Response>>
  >;
  /** update data of the table: "research.medical_conditions" */
  update_research_medical_conditions: Maybe<Research_Medical_Conditions_Mutation_Response>;
  /** update data of the table: "research.medical_conditions_clinicial_dosing" */
  update_research_medical_conditions_clinicial_dosing: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Mutation_Response>;
  /** update multiples rows of table: "research.medical_conditions_clinicial_dosing" */
  update_research_medical_conditions_clinicial_dosing_many: Maybe<
    Array<Maybe<Research_Medical_Conditions_Clinicial_Dosing_Mutation_Response>>
  >;
  /** update multiples rows of table: "research.medical_conditions" */
  update_research_medical_conditions_many: Maybe<
    Array<Maybe<Research_Medical_Conditions_Mutation_Response>>
  >;
  /** update data of the table: "research.medical_conditions_state_of_science" */
  update_research_medical_conditions_state_of_science: Maybe<Research_Medical_Conditions_State_Of_Science_Mutation_Response>;
  /** update multiples rows of table: "research.medical_conditions_state_of_science" */
  update_research_medical_conditions_state_of_science_many: Maybe<
    Array<Maybe<Research_Medical_Conditions_State_Of_Science_Mutation_Response>>
  >;
  /** update data of the table: "research.medical_conditions_studies" */
  update_research_medical_conditions_studies: Maybe<Research_Medical_Conditions_Studies_Mutation_Response>;
  /** update multiples rows of table: "research.medical_conditions_studies" */
  update_research_medical_conditions_studies_many: Maybe<
    Array<Maybe<Research_Medical_Conditions_Studies_Mutation_Response>>
  >;
  /** update data of the table: "research.organ_systems" */
  update_research_organ_systems: Maybe<Research_Organ_Systems_Mutation_Response>;
  /** update multiples rows of table: "research.organ_systems" */
  update_research_organ_systems_many: Maybe<
    Array<Maybe<Research_Organ_Systems_Mutation_Response>>
  >;
  /** update data of the table: "research.organ_systems_studies" */
  update_research_organ_systems_studies: Maybe<Research_Organ_Systems_Studies_Mutation_Response>;
  /** update multiples rows of table: "research.organ_systems_studies" */
  update_research_organ_systems_studies_many: Maybe<
    Array<Maybe<Research_Organ_Systems_Studies_Mutation_Response>>
  >;
  /** update data of the table: "research.receptors" */
  update_research_receptors: Maybe<Research_Receptors_Mutation_Response>;
  /** update multiples rows of table: "research.receptors" */
  update_research_receptors_many: Maybe<
    Array<Maybe<Research_Receptors_Mutation_Response>>
  >;
  /** update data of the table: "research.studies" */
  update_research_studies: Maybe<Research_Studies_Mutation_Response>;
  /** update data of the table: "research.studies_administration" */
  update_research_studies_administration: Maybe<Research_Studies_Administration_Mutation_Response>;
  /** update multiples rows of table: "research.studies_administration" */
  update_research_studies_administration_many: Maybe<
    Array<Maybe<Research_Studies_Administration_Mutation_Response>>
  >;
  /** update data of the table: "research.studies_chemotypes" */
  update_research_studies_chemotypes: Maybe<Research_Studies_Chemotypes_Mutation_Response>;
  /** update multiples rows of table: "research.studies_chemotypes" */
  update_research_studies_chemotypes_many: Maybe<
    Array<Maybe<Research_Studies_Chemotypes_Mutation_Response>>
  >;
  /** update data of the table: "research.studies_ligands" */
  update_research_studies_ligands: Maybe<Research_Studies_Ligands_Mutation_Response>;
  /** update multiples rows of table: "research.studies_ligands" */
  update_research_studies_ligands_many: Maybe<
    Array<Maybe<Research_Studies_Ligands_Mutation_Response>>
  >;
  /** update data of the table: "research.studies_locations" */
  update_research_studies_locations: Maybe<Research_Studies_Locations_Mutation_Response>;
  /** update multiples rows of table: "research.studies_locations" */
  update_research_studies_locations_many: Maybe<
    Array<Maybe<Research_Studies_Locations_Mutation_Response>>
  >;
  /** update multiples rows of table: "research.studies" */
  update_research_studies_many: Maybe<
    Array<Maybe<Research_Studies_Mutation_Response>>
  >;
  /** update data of the table: "research.studies_receptors" */
  update_research_studies_receptors: Maybe<Research_Studies_Receptors_Mutation_Response>;
  /** update multiples rows of table: "research.studies_receptors" */
  update_research_studies_receptors_many: Maybe<
    Array<Maybe<Research_Studies_Receptors_Mutation_Response>>
  >;
  /** update data of the table: "research.terpenes" */
  update_research_terpenes: Maybe<Research_Terpenes_Mutation_Response>;
  /** update multiples rows of table: "research.terpenes" */
  update_research_terpenes_many: Maybe<
    Array<Maybe<Research_Terpenes_Mutation_Response>>
  >;
  /** update data of the table: "research.terpenes_studies" */
  update_research_terpenes_studies: Maybe<Research_Terpenes_Studies_Mutation_Response>;
  /** update multiples rows of table: "research.terpenes_studies" */
  update_research_terpenes_studies_many: Maybe<
    Array<Maybe<Research_Terpenes_Studies_Mutation_Response>>
  >;
};

/** mutation root */
export type Mutation_RootDelete_Outreach_Google_LocationsArgs = {
  where: Outreach_Google_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Outreach_PartnersArgs = {
  where: Outreach_Partners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_CannabinoidsArgs = {
  where: Research__Airbyte_Raw_Cannabinoids_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Cannabinoids_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Medical_ConditionsArgs = {
  where: Research__Airbyte_Raw_Medical_Conditions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Medical_Conditions_By_PkArgs =
  {
    _airbyte_ab_id: Scalars['String'];
  };

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Organ_SystemsArgs = {
  where: Research__Airbyte_Raw_Organ_Systems_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Organ_Systems_By_PkArgs =
  {
    _airbyte_ab_id: Scalars['String'];
  };

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_StudiesArgs = {
  where: Research__Airbyte_Raw_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Studies_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_TerpenesArgs = {
  where: Research__Airbyte_Raw_Terpenes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research__Airbyte_Raw_Terpenes_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

/** mutation root */
export type Mutation_RootDelete_Research_AdministrationsArgs = {
  where: Research_Administrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_CannabinoidsArgs = {
  where: Research_Cannabinoids_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Cannabinoids_StudiesArgs = {
  where: Research_Cannabinoids_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_ChemotypesArgs = {
  where: Research_Chemotypes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_LigandsArgs = {
  where: Research_Ligands_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_LocationsArgs = {
  where: Research_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Medical_ConditionsArgs = {
  where: Research_Medical_Conditions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Medical_Conditions_Clinicial_DosingArgs =
  {
    where: Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootDelete_Research_Medical_Conditions_State_Of_ScienceArgs =
  {
    where: Research_Medical_Conditions_State_Of_Science_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootDelete_Research_Medical_Conditions_StudiesArgs = {
  where: Research_Medical_Conditions_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Organ_SystemsArgs = {
  where: Research_Organ_Systems_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Organ_Systems_StudiesArgs = {
  where: Research_Organ_Systems_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_ReceptorsArgs = {
  where: Research_Receptors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_StudiesArgs = {
  where: Research_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Studies_AdministrationArgs = {
  where: Research_Studies_Administration_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Studies_ChemotypesArgs = {
  where: Research_Studies_Chemotypes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Studies_LigandsArgs = {
  where: Research_Studies_Ligands_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Studies_LocationsArgs = {
  where: Research_Studies_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Studies_ReceptorsArgs = {
  where: Research_Studies_Receptors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_TerpenesArgs = {
  where: Research_Terpenes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_Terpenes_StudiesArgs = {
  where: Research_Terpenes_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootInsert_Outreach_Google_LocationsArgs = {
  objects: Array<Outreach_Google_Locations_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Outreach_Google_Locations_OneArgs = {
  object: Outreach_Google_Locations_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Outreach_PartnersArgs = {
  objects: Array<Outreach_Partners_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Outreach_Partners_OneArgs = {
  object: Outreach_Partners_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_CannabinoidsArgs = {
  objects: Array<Research__Airbyte_Raw_Cannabinoids_Insert_Input>;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Cannabinoids_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Cannabinoids_OneArgs = {
  object: Research__Airbyte_Raw_Cannabinoids_Insert_Input;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Cannabinoids_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Medical_ConditionsArgs = {
  objects: Array<Research__Airbyte_Raw_Medical_Conditions_Insert_Input>;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Medical_Conditions_OneArgs =
  {
    object: Research__Airbyte_Raw_Medical_Conditions_Insert_Input;
    on_conflict: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Organ_SystemsArgs = {
  objects: Array<Research__Airbyte_Raw_Organ_Systems_Insert_Input>;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Organ_Systems_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Organ_Systems_OneArgs = {
  object: Research__Airbyte_Raw_Organ_Systems_Insert_Input;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Organ_Systems_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_StudiesArgs = {
  objects: Array<Research__Airbyte_Raw_Studies_Insert_Input>;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Studies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Studies_OneArgs = {
  object: Research__Airbyte_Raw_Studies_Insert_Input;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Studies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_TerpenesArgs = {
  objects: Array<Research__Airbyte_Raw_Terpenes_Insert_Input>;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Terpenes_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research__Airbyte_Raw_Terpenes_OneArgs = {
  object: Research__Airbyte_Raw_Terpenes_Insert_Input;
  on_conflict: InputMaybe<Research__Airbyte_Raw_Terpenes_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research_AdministrationsArgs = {
  objects: Array<Research_Administrations_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Administrations_OneArgs = {
  object: Research_Administrations_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_CannabinoidsArgs = {
  objects: Array<Research_Cannabinoids_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Cannabinoids_OneArgs = {
  object: Research_Cannabinoids_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Cannabinoids_StudiesArgs = {
  objects: Array<Research_Cannabinoids_Studies_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Cannabinoids_Studies_OneArgs = {
  object: Research_Cannabinoids_Studies_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_ChemotypesArgs = {
  objects: Array<Research_Chemotypes_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Chemotypes_OneArgs = {
  object: Research_Chemotypes_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_LigandsArgs = {
  objects: Array<Research_Ligands_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Ligands_OneArgs = {
  object: Research_Ligands_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_LocationsArgs = {
  objects: Array<Research_Locations_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Locations_OneArgs = {
  object: Research_Locations_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Medical_ConditionsArgs = {
  objects: Array<Research_Medical_Conditions_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_Clinicial_DosingArgs =
  {
    objects: Array<Research_Medical_Conditions_Clinicial_Dosing_Insert_Input>;
  };

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_Clinicial_Dosing_OneArgs =
  {
    object: Research_Medical_Conditions_Clinicial_Dosing_Insert_Input;
  };

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_OneArgs = {
  object: Research_Medical_Conditions_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_State_Of_ScienceArgs =
  {
    objects: Array<Research_Medical_Conditions_State_Of_Science_Insert_Input>;
  };

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_State_Of_Science_OneArgs =
  {
    object: Research_Medical_Conditions_State_Of_Science_Insert_Input;
  };

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_StudiesArgs = {
  objects: Array<Research_Medical_Conditions_Studies_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Medical_Conditions_Studies_OneArgs = {
  object: Research_Medical_Conditions_Studies_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Organ_SystemsArgs = {
  objects: Array<Research_Organ_Systems_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Organ_Systems_OneArgs = {
  object: Research_Organ_Systems_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Organ_Systems_StudiesArgs = {
  objects: Array<Research_Organ_Systems_Studies_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Organ_Systems_Studies_OneArgs = {
  object: Research_Organ_Systems_Studies_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_ReceptorsArgs = {
  objects: Array<Research_Receptors_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Receptors_OneArgs = {
  object: Research_Receptors_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_StudiesArgs = {
  objects: Array<Research_Studies_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_AdministrationArgs = {
  objects: Array<Research_Studies_Administration_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_Administration_OneArgs = {
  object: Research_Studies_Administration_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_ChemotypesArgs = {
  objects: Array<Research_Studies_Chemotypes_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_Chemotypes_OneArgs = {
  object: Research_Studies_Chemotypes_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_LigandsArgs = {
  objects: Array<Research_Studies_Ligands_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_Ligands_OneArgs = {
  object: Research_Studies_Ligands_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_LocationsArgs = {
  objects: Array<Research_Studies_Locations_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_Locations_OneArgs = {
  object: Research_Studies_Locations_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_OneArgs = {
  object: Research_Studies_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_ReceptorsArgs = {
  objects: Array<Research_Studies_Receptors_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Studies_Receptors_OneArgs = {
  object: Research_Studies_Receptors_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_TerpenesArgs = {
  objects: Array<Research_Terpenes_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Terpenes_OneArgs = {
  object: Research_Terpenes_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Research_Terpenes_StudiesArgs = {
  objects: Array<Research_Terpenes_Studies_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Research_Terpenes_Studies_OneArgs = {
  object: Research_Terpenes_Studies_Insert_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Outreach_Google_LocationsArgs = {
  _inc: InputMaybe<Outreach_Google_Locations_Inc_Input>;
  _set: InputMaybe<Outreach_Google_Locations_Set_Input>;
  where: Outreach_Google_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Outreach_Google_Locations_ManyArgs = {
  updates: Array<Outreach_Google_Locations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Outreach_PartnersArgs = {
  _inc: InputMaybe<Outreach_Partners_Inc_Input>;
  _set: InputMaybe<Outreach_Partners_Set_Input>;
  where: Outreach_Partners_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Outreach_Partners_ManyArgs = {
  updates: Array<Outreach_Partners_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_CannabinoidsArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Set_Input>;
  where: Research__Airbyte_Raw_Cannabinoids_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Cannabinoids_By_PkArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Set_Input>;
  pk_columns: Research__Airbyte_Raw_Cannabinoids_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Cannabinoids_ManyArgs = {
  updates: Array<Research__Airbyte_Raw_Cannabinoids_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Medical_ConditionsArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Set_Input>;
  where: Research__Airbyte_Raw_Medical_Conditions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Medical_Conditions_By_PkArgs =
  {
    _append: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Append_Input>;
    _delete_at_path: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_At_Path_Input>;
    _delete_elem: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Elem_Input>;
    _delete_key: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Key_Input>;
    _prepend: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Prepend_Input>;
    _set: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Set_Input>;
    pk_columns: Research__Airbyte_Raw_Medical_Conditions_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Medical_Conditions_ManyArgs =
  {
    updates: Array<Research__Airbyte_Raw_Medical_Conditions_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Organ_SystemsArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Set_Input>;
  where: Research__Airbyte_Raw_Organ_Systems_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Organ_Systems_By_PkArgs =
  {
    _append: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Append_Input>;
    _delete_at_path: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_At_Path_Input>;
    _delete_elem: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Elem_Input>;
    _delete_key: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Key_Input>;
    _prepend: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Prepend_Input>;
    _set: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Set_Input>;
    pk_columns: Research__Airbyte_Raw_Organ_Systems_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Organ_Systems_ManyArgs = {
  updates: Array<Research__Airbyte_Raw_Organ_Systems_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_StudiesArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Studies_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Studies_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Studies_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Studies_Set_Input>;
  where: Research__Airbyte_Raw_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Studies_By_PkArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Studies_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Studies_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Studies_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Studies_Set_Input>;
  pk_columns: Research__Airbyte_Raw_Studies_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Studies_ManyArgs = {
  updates: Array<Research__Airbyte_Raw_Studies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_TerpenesArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Terpenes_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Terpenes_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Terpenes_Set_Input>;
  where: Research__Airbyte_Raw_Terpenes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Terpenes_By_PkArgs = {
  _append: InputMaybe<Research__Airbyte_Raw_Terpenes_Append_Input>;
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Elem_Input>;
  _delete_key: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Key_Input>;
  _prepend: InputMaybe<Research__Airbyte_Raw_Terpenes_Prepend_Input>;
  _set: InputMaybe<Research__Airbyte_Raw_Terpenes_Set_Input>;
  pk_columns: Research__Airbyte_Raw_Terpenes_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Research__Airbyte_Raw_Terpenes_ManyArgs = {
  updates: Array<Research__Airbyte_Raw_Terpenes_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_AdministrationsArgs = {
  _inc: InputMaybe<Research_Administrations_Inc_Input>;
  _set: InputMaybe<Research_Administrations_Set_Input>;
  where: Research_Administrations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Administrations_ManyArgs = {
  updates: Array<Research_Administrations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_CannabinoidsArgs = {
  _inc: InputMaybe<Research_Cannabinoids_Inc_Input>;
  _set: InputMaybe<Research_Cannabinoids_Set_Input>;
  where: Research_Cannabinoids_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Cannabinoids_ManyArgs = {
  updates: Array<Research_Cannabinoids_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Cannabinoids_StudiesArgs = {
  _inc: InputMaybe<Research_Cannabinoids_Studies_Inc_Input>;
  _set: InputMaybe<Research_Cannabinoids_Studies_Set_Input>;
  where: Research_Cannabinoids_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Cannabinoids_Studies_ManyArgs = {
  updates: Array<Research_Cannabinoids_Studies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_ChemotypesArgs = {
  _inc: InputMaybe<Research_Chemotypes_Inc_Input>;
  _set: InputMaybe<Research_Chemotypes_Set_Input>;
  where: Research_Chemotypes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Chemotypes_ManyArgs = {
  updates: Array<Research_Chemotypes_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_LigandsArgs = {
  _inc: InputMaybe<Research_Ligands_Inc_Input>;
  _set: InputMaybe<Research_Ligands_Set_Input>;
  where: Research_Ligands_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Ligands_ManyArgs = {
  updates: Array<Research_Ligands_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_LocationsArgs = {
  _inc: InputMaybe<Research_Locations_Inc_Input>;
  _set: InputMaybe<Research_Locations_Set_Input>;
  where: Research_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Locations_ManyArgs = {
  updates: Array<Research_Locations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_ConditionsArgs = {
  _inc: InputMaybe<Research_Medical_Conditions_Inc_Input>;
  _set: InputMaybe<Research_Medical_Conditions_Set_Input>;
  where: Research_Medical_Conditions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_Clinicial_DosingArgs =
  {
    _inc: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Inc_Input>;
    _set: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Set_Input>;
    where: Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_Clinicial_Dosing_ManyArgs =
  {
    updates: Array<Research_Medical_Conditions_Clinicial_Dosing_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_ManyArgs = {
  updates: Array<Research_Medical_Conditions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_State_Of_ScienceArgs =
  {
    _inc: InputMaybe<Research_Medical_Conditions_State_Of_Science_Inc_Input>;
    _set: InputMaybe<Research_Medical_Conditions_State_Of_Science_Set_Input>;
    where: Research_Medical_Conditions_State_Of_Science_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_State_Of_Science_ManyArgs =
  {
    updates: Array<Research_Medical_Conditions_State_Of_Science_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_StudiesArgs = {
  _inc: InputMaybe<Research_Medical_Conditions_Studies_Inc_Input>;
  _set: InputMaybe<Research_Medical_Conditions_Studies_Set_Input>;
  where: Research_Medical_Conditions_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Medical_Conditions_Studies_ManyArgs = {
  updates: Array<Research_Medical_Conditions_Studies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Organ_SystemsArgs = {
  _inc: InputMaybe<Research_Organ_Systems_Inc_Input>;
  _set: InputMaybe<Research_Organ_Systems_Set_Input>;
  where: Research_Organ_Systems_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Organ_Systems_ManyArgs = {
  updates: Array<Research_Organ_Systems_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Organ_Systems_StudiesArgs = {
  _inc: InputMaybe<Research_Organ_Systems_Studies_Inc_Input>;
  _set: InputMaybe<Research_Organ_Systems_Studies_Set_Input>;
  where: Research_Organ_Systems_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Organ_Systems_Studies_ManyArgs = {
  updates: Array<Research_Organ_Systems_Studies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_ReceptorsArgs = {
  _inc: InputMaybe<Research_Receptors_Inc_Input>;
  _set: InputMaybe<Research_Receptors_Set_Input>;
  where: Research_Receptors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Receptors_ManyArgs = {
  updates: Array<Research_Receptors_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_StudiesArgs = {
  _inc: InputMaybe<Research_Studies_Inc_Input>;
  _set: InputMaybe<Research_Studies_Set_Input>;
  where: Research_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_AdministrationArgs = {
  _inc: InputMaybe<Research_Studies_Administration_Inc_Input>;
  _set: InputMaybe<Research_Studies_Administration_Set_Input>;
  where: Research_Studies_Administration_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_Administration_ManyArgs = {
  updates: Array<Research_Studies_Administration_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_ChemotypesArgs = {
  _inc: InputMaybe<Research_Studies_Chemotypes_Inc_Input>;
  _set: InputMaybe<Research_Studies_Chemotypes_Set_Input>;
  where: Research_Studies_Chemotypes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_Chemotypes_ManyArgs = {
  updates: Array<Research_Studies_Chemotypes_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_LigandsArgs = {
  _inc: InputMaybe<Research_Studies_Ligands_Inc_Input>;
  _set: InputMaybe<Research_Studies_Ligands_Set_Input>;
  where: Research_Studies_Ligands_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_Ligands_ManyArgs = {
  updates: Array<Research_Studies_Ligands_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_LocationsArgs = {
  _inc: InputMaybe<Research_Studies_Locations_Inc_Input>;
  _set: InputMaybe<Research_Studies_Locations_Set_Input>;
  where: Research_Studies_Locations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_Locations_ManyArgs = {
  updates: Array<Research_Studies_Locations_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_ManyArgs = {
  updates: Array<Research_Studies_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_ReceptorsArgs = {
  _inc: InputMaybe<Research_Studies_Receptors_Inc_Input>;
  _set: InputMaybe<Research_Studies_Receptors_Set_Input>;
  where: Research_Studies_Receptors_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Studies_Receptors_ManyArgs = {
  updates: Array<Research_Studies_Receptors_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_TerpenesArgs = {
  _inc: InputMaybe<Research_Terpenes_Inc_Input>;
  _set: InputMaybe<Research_Terpenes_Set_Input>;
  where: Research_Terpenes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Terpenes_ManyArgs = {
  updates: Array<Research_Terpenes_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Terpenes_StudiesArgs = {
  _inc: InputMaybe<Research_Terpenes_Studies_Inc_Input>;
  _set: InputMaybe<Research_Terpenes_Studies_Set_Input>;
  where: Research_Terpenes_Studies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_Terpenes_Studies_ManyArgs = {
  updates: Array<Research_Terpenes_Studies_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

/** columns and relationships of "outreach.google_locations" */
export type Outreach_Google_Locations = {
  __typename?: 'outreach_google_locations';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  address_components: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  data: Maybe<Scalars['String']>;
  formatted_address: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  international_phone_number: Maybe<Scalars['String']>;
  lat: Maybe<Scalars['float8']>;
  lng: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  opening_hours: Maybe<Scalars['String']>;
  partner_id: Maybe<Scalars['float8']>;
  place_id: Maybe<Scalars['String']>;
  rating: Maybe<Scalars['float8']>;
  reviews: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamp']>;
  user_ratings_total: Maybe<Scalars['float8']>;
  utc_offset: Maybe<Scalars['String']>;
};

/** aggregated selection of "outreach.google_locations" */
export type Outreach_Google_Locations_Aggregate = {
  __typename?: 'outreach_google_locations_aggregate';
  aggregate: Maybe<Outreach_Google_Locations_Aggregate_Fields>;
  nodes: Array<Outreach_Google_Locations>;
};

/** aggregate fields of "outreach.google_locations" */
export type Outreach_Google_Locations_Aggregate_Fields = {
  __typename?: 'outreach_google_locations_aggregate_fields';
  avg: Maybe<Outreach_Google_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Outreach_Google_Locations_Max_Fields>;
  min: Maybe<Outreach_Google_Locations_Min_Fields>;
  stddev: Maybe<Outreach_Google_Locations_Stddev_Fields>;
  stddev_pop: Maybe<Outreach_Google_Locations_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Outreach_Google_Locations_Stddev_Samp_Fields>;
  sum: Maybe<Outreach_Google_Locations_Sum_Fields>;
  var_pop: Maybe<Outreach_Google_Locations_Var_Pop_Fields>;
  var_samp: Maybe<Outreach_Google_Locations_Var_Samp_Fields>;
  variance: Maybe<Outreach_Google_Locations_Variance_Fields>;
};

/** aggregate fields of "outreach.google_locations" */
export type Outreach_Google_Locations_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Outreach_Google_Locations_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Outreach_Google_Locations_Avg_Fields = {
  __typename?: 'outreach_google_locations_avg_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "outreach.google_locations". All fields are combined with a logical 'AND'. */
export type Outreach_Google_Locations_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_google_locations_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Outreach_Google_Locations_Bool_Exp>>;
  _not: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
  _or: InputMaybe<Array<Outreach_Google_Locations_Bool_Exp>>;
  address_components: InputMaybe<String_Comparison_Exp>;
  created_at: InputMaybe<Timestamp_Comparison_Exp>;
  data: InputMaybe<String_Comparison_Exp>;
  formatted_address: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
  international_phone_number: InputMaybe<String_Comparison_Exp>;
  lat: InputMaybe<Float8_Comparison_Exp>;
  lng: InputMaybe<Float8_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  opening_hours: InputMaybe<String_Comparison_Exp>;
  partner_id: InputMaybe<Float8_Comparison_Exp>;
  place_id: InputMaybe<String_Comparison_Exp>;
  rating: InputMaybe<Float8_Comparison_Exp>;
  reviews: InputMaybe<String_Comparison_Exp>;
  updated_at: InputMaybe<Timestamp_Comparison_Exp>;
  user_ratings_total: InputMaybe<Float8_Comparison_Exp>;
  utc_offset: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "outreach.google_locations" */
export type Outreach_Google_Locations_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
  lat: InputMaybe<Scalars['float8']>;
  lng: InputMaybe<Scalars['float8']>;
  partner_id: InputMaybe<Scalars['float8']>;
  rating: InputMaybe<Scalars['float8']>;
  user_ratings_total: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "outreach.google_locations" */
export type Outreach_Google_Locations_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  address_components: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  data: InputMaybe<Scalars['String']>;
  formatted_address: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  international_phone_number: InputMaybe<Scalars['String']>;
  lat: InputMaybe<Scalars['float8']>;
  lng: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  opening_hours: InputMaybe<Scalars['String']>;
  partner_id: InputMaybe<Scalars['float8']>;
  place_id: InputMaybe<Scalars['String']>;
  rating: InputMaybe<Scalars['float8']>;
  reviews: InputMaybe<Scalars['String']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  user_ratings_total: InputMaybe<Scalars['float8']>;
  utc_offset: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Outreach_Google_Locations_Max_Fields = {
  __typename?: 'outreach_google_locations_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  address_components: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  data: Maybe<Scalars['String']>;
  formatted_address: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  international_phone_number: Maybe<Scalars['String']>;
  lat: Maybe<Scalars['float8']>;
  lng: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  opening_hours: Maybe<Scalars['String']>;
  partner_id: Maybe<Scalars['float8']>;
  place_id: Maybe<Scalars['String']>;
  rating: Maybe<Scalars['float8']>;
  reviews: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamp']>;
  user_ratings_total: Maybe<Scalars['float8']>;
  utc_offset: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Outreach_Google_Locations_Min_Fields = {
  __typename?: 'outreach_google_locations_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  address_components: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  data: Maybe<Scalars['String']>;
  formatted_address: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  international_phone_number: Maybe<Scalars['String']>;
  lat: Maybe<Scalars['float8']>;
  lng: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  opening_hours: Maybe<Scalars['String']>;
  partner_id: Maybe<Scalars['float8']>;
  place_id: Maybe<Scalars['String']>;
  rating: Maybe<Scalars['float8']>;
  reviews: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamp']>;
  user_ratings_total: Maybe<Scalars['float8']>;
  utc_offset: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "outreach.google_locations" */
export type Outreach_Google_Locations_Mutation_Response = {
  __typename?: 'outreach_google_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Outreach_Google_Locations>;
};

/** input type for inserting object relation for remote table "outreach.google_locations" */
export type Outreach_Google_Locations_Obj_Rel_Insert_Input = {
  data: Outreach_Google_Locations_Insert_Input;
};

/** Ordering options when selecting data from "outreach.google_locations". */
export type Outreach_Google_Locations_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_google_locations_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  address_components: InputMaybe<Order_By>;
  created_at: InputMaybe<Order_By>;
  data: InputMaybe<Order_By>;
  formatted_address: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  international_phone_number: InputMaybe<Order_By>;
  lat: InputMaybe<Order_By>;
  lng: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  opening_hours: InputMaybe<Order_By>;
  partner_id: InputMaybe<Order_By>;
  place_id: InputMaybe<Order_By>;
  rating: InputMaybe<Order_By>;
  reviews: InputMaybe<Order_By>;
  updated_at: InputMaybe<Order_By>;
  user_ratings_total: InputMaybe<Order_By>;
  utc_offset: InputMaybe<Order_By>;
};

/** select columns of table "outreach.google_locations" */
export enum Outreach_Google_Locations_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteGoogleLocationsHashid = '_airbyte_google_locations_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AddressComponents = 'address_components',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Id = 'id',
  /** column name */
  InternationalPhoneNumber = 'international_phone_number',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  Reviews = 'reviews',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserRatingsTotal = 'user_ratings_total',
  /** column name */
  UtcOffset = 'utc_offset',
}

/** input type for updating data in table "outreach.google_locations" */
export type Outreach_Google_Locations_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  address_components: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  data: InputMaybe<Scalars['String']>;
  formatted_address: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  international_phone_number: InputMaybe<Scalars['String']>;
  lat: InputMaybe<Scalars['float8']>;
  lng: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  opening_hours: InputMaybe<Scalars['String']>;
  partner_id: InputMaybe<Scalars['float8']>;
  place_id: InputMaybe<Scalars['String']>;
  rating: InputMaybe<Scalars['float8']>;
  reviews: InputMaybe<Scalars['String']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  user_ratings_total: InputMaybe<Scalars['float8']>;
  utc_offset: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Outreach_Google_Locations_Stddev_Fields = {
  __typename?: 'outreach_google_locations_stddev_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Outreach_Google_Locations_Stddev_Pop_Fields = {
  __typename?: 'outreach_google_locations_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Outreach_Google_Locations_Stddev_Samp_Fields = {
  __typename?: 'outreach_google_locations_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "outreach_google_locations" */
export type Outreach_Google_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Outreach_Google_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Outreach_Google_Locations_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_google_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  address_components: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  data: InputMaybe<Scalars['String']>;
  formatted_address: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  international_phone_number: InputMaybe<Scalars['String']>;
  lat: InputMaybe<Scalars['float8']>;
  lng: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  opening_hours: InputMaybe<Scalars['String']>;
  partner_id: InputMaybe<Scalars['float8']>;
  place_id: InputMaybe<Scalars['String']>;
  rating: InputMaybe<Scalars['float8']>;
  reviews: InputMaybe<Scalars['String']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  user_ratings_total: InputMaybe<Scalars['float8']>;
  utc_offset: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Outreach_Google_Locations_Sum_Fields = {
  __typename?: 'outreach_google_locations_sum_fields';
  id: Maybe<Scalars['float8']>;
  lat: Maybe<Scalars['float8']>;
  lng: Maybe<Scalars['float8']>;
  partner_id: Maybe<Scalars['float8']>;
  rating: Maybe<Scalars['float8']>;
  user_ratings_total: Maybe<Scalars['float8']>;
};

export type Outreach_Google_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Outreach_Google_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Outreach_Google_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Outreach_Google_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Outreach_Google_Locations_Var_Pop_Fields = {
  __typename?: 'outreach_google_locations_var_pop_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Outreach_Google_Locations_Var_Samp_Fields = {
  __typename?: 'outreach_google_locations_var_samp_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Outreach_Google_Locations_Variance_Fields = {
  __typename?: 'outreach_google_locations_variance_fields';
  id: Maybe<Scalars['Float']>;
  lat: Maybe<Scalars['Float']>;
  lng: Maybe<Scalars['Float']>;
  partner_id: Maybe<Scalars['Float']>;
  rating: Maybe<Scalars['Float']>;
  user_ratings_total: Maybe<Scalars['Float']>;
};

/** columns and relationships of "outreach.partners" */
export type Outreach_Partners = {
  __typename?: 'outreach_partners';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  deleted_at: Maybe<Scalars['timestamp']>;
  fee_amount: Maybe<Scalars['float8']>;
  fee_type: Maybe<Scalars['float8']>;
  /** An object relationship */
  google_location: Maybe<Outreach_Google_Locations>;
  hubspot_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  is_new: Maybe<Scalars['Boolean']>;
  last_hubspot_sync_at: Maybe<Scalars['timestamp']>;
  name: Maybe<Scalars['String']>;
  organization_id: Maybe<Scalars['float8']>;
  outreach_id: Maybe<Scalars['float8']>;
  parent_id: Maybe<Scalars['float8']>;
  updated_at: Maybe<Scalars['timestamp']>;
  visible_leads: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "outreach.partners" */
export type Outreach_Partners_Aggregate = {
  __typename?: 'outreach_partners_aggregate';
  aggregate: Maybe<Outreach_Partners_Aggregate_Fields>;
  nodes: Array<Outreach_Partners>;
};

/** aggregate fields of "outreach.partners" */
export type Outreach_Partners_Aggregate_Fields = {
  __typename?: 'outreach_partners_aggregate_fields';
  avg: Maybe<Outreach_Partners_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Outreach_Partners_Max_Fields>;
  min: Maybe<Outreach_Partners_Min_Fields>;
  stddev: Maybe<Outreach_Partners_Stddev_Fields>;
  stddev_pop: Maybe<Outreach_Partners_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Outreach_Partners_Stddev_Samp_Fields>;
  sum: Maybe<Outreach_Partners_Sum_Fields>;
  var_pop: Maybe<Outreach_Partners_Var_Pop_Fields>;
  var_samp: Maybe<Outreach_Partners_Var_Samp_Fields>;
  variance: Maybe<Outreach_Partners_Variance_Fields>;
};

/** aggregate fields of "outreach.partners" */
export type Outreach_Partners_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Outreach_Partners_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Outreach_Partners_Avg_Fields = {
  __typename?: 'outreach_partners_avg_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "outreach.partners". All fields are combined with a logical 'AND'. */
export type Outreach_Partners_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_partners_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Outreach_Partners_Bool_Exp>>;
  _not: InputMaybe<Outreach_Partners_Bool_Exp>;
  _or: InputMaybe<Array<Outreach_Partners_Bool_Exp>>;
  created_at: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at: InputMaybe<Timestamp_Comparison_Exp>;
  fee_amount: InputMaybe<Float8_Comparison_Exp>;
  fee_type: InputMaybe<Float8_Comparison_Exp>;
  google_location: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
  hubspot_id: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
  is_new: InputMaybe<Boolean_Comparison_Exp>;
  last_hubspot_sync_at: InputMaybe<Timestamp_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  organization_id: InputMaybe<Float8_Comparison_Exp>;
  outreach_id: InputMaybe<Float8_Comparison_Exp>;
  parent_id: InputMaybe<Float8_Comparison_Exp>;
  updated_at: InputMaybe<Timestamp_Comparison_Exp>;
  visible_leads: InputMaybe<Boolean_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "outreach.partners" */
export type Outreach_Partners_Inc_Input = {
  fee_amount: InputMaybe<Scalars['float8']>;
  fee_type: InputMaybe<Scalars['float8']>;
  id: InputMaybe<Scalars['float8']>;
  organization_id: InputMaybe<Scalars['float8']>;
  outreach_id: InputMaybe<Scalars['float8']>;
  parent_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "outreach.partners" */
export type Outreach_Partners_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  deleted_at: InputMaybe<Scalars['timestamp']>;
  fee_amount: InputMaybe<Scalars['float8']>;
  fee_type: InputMaybe<Scalars['float8']>;
  google_location: InputMaybe<Outreach_Google_Locations_Obj_Rel_Insert_Input>;
  hubspot_id: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  is_new: InputMaybe<Scalars['Boolean']>;
  last_hubspot_sync_at: InputMaybe<Scalars['timestamp']>;
  name: InputMaybe<Scalars['String']>;
  organization_id: InputMaybe<Scalars['float8']>;
  outreach_id: InputMaybe<Scalars['float8']>;
  parent_id: InputMaybe<Scalars['float8']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  visible_leads: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Outreach_Partners_Max_Fields = {
  __typename?: 'outreach_partners_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  deleted_at: Maybe<Scalars['timestamp']>;
  fee_amount: Maybe<Scalars['float8']>;
  fee_type: Maybe<Scalars['float8']>;
  hubspot_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  last_hubspot_sync_at: Maybe<Scalars['timestamp']>;
  name: Maybe<Scalars['String']>;
  organization_id: Maybe<Scalars['float8']>;
  outreach_id: Maybe<Scalars['float8']>;
  parent_id: Maybe<Scalars['float8']>;
  updated_at: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Outreach_Partners_Min_Fields = {
  __typename?: 'outreach_partners_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  deleted_at: Maybe<Scalars['timestamp']>;
  fee_amount: Maybe<Scalars['float8']>;
  fee_type: Maybe<Scalars['float8']>;
  hubspot_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  last_hubspot_sync_at: Maybe<Scalars['timestamp']>;
  name: Maybe<Scalars['String']>;
  organization_id: Maybe<Scalars['float8']>;
  outreach_id: Maybe<Scalars['float8']>;
  parent_id: Maybe<Scalars['float8']>;
  updated_at: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "outreach.partners" */
export type Outreach_Partners_Mutation_Response = {
  __typename?: 'outreach_partners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Outreach_Partners>;
};

/** Ordering options when selecting data from "outreach.partners". */
export type Outreach_Partners_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_partners_hashid: InputMaybe<Order_By>;
  created_at: InputMaybe<Order_By>;
  deleted_at: InputMaybe<Order_By>;
  fee_amount: InputMaybe<Order_By>;
  fee_type: InputMaybe<Order_By>;
  google_location: InputMaybe<Outreach_Google_Locations_Order_By>;
  hubspot_id: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  is_new: InputMaybe<Order_By>;
  last_hubspot_sync_at: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  organization_id: InputMaybe<Order_By>;
  outreach_id: InputMaybe<Order_By>;
  parent_id: InputMaybe<Order_By>;
  updated_at: InputMaybe<Order_By>;
  visible_leads: InputMaybe<Order_By>;
};

/** select columns of table "outreach.partners" */
export enum Outreach_Partners_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbytePartnersHashid = '_airbyte_partners_hashid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FeeAmount = 'fee_amount',
  /** column name */
  FeeType = 'fee_type',
  /** column name */
  HubspotId = 'hubspot_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  LastHubspotSyncAt = 'last_hubspot_sync_at',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OutreachId = 'outreach_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibleLeads = 'visible_leads',
}

/** input type for updating data in table "outreach.partners" */
export type Outreach_Partners_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  deleted_at: InputMaybe<Scalars['timestamp']>;
  fee_amount: InputMaybe<Scalars['float8']>;
  fee_type: InputMaybe<Scalars['float8']>;
  hubspot_id: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  is_new: InputMaybe<Scalars['Boolean']>;
  last_hubspot_sync_at: InputMaybe<Scalars['timestamp']>;
  name: InputMaybe<Scalars['String']>;
  organization_id: InputMaybe<Scalars['float8']>;
  outreach_id: InputMaybe<Scalars['float8']>;
  parent_id: InputMaybe<Scalars['float8']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  visible_leads: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Outreach_Partners_Stddev_Fields = {
  __typename?: 'outreach_partners_stddev_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Outreach_Partners_Stddev_Pop_Fields = {
  __typename?: 'outreach_partners_stddev_pop_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Outreach_Partners_Stddev_Samp_Fields = {
  __typename?: 'outreach_partners_stddev_samp_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "outreach_partners" */
export type Outreach_Partners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Outreach_Partners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Outreach_Partners_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_partners_hashid: InputMaybe<Scalars['String']>;
  created_at: InputMaybe<Scalars['timestamp']>;
  deleted_at: InputMaybe<Scalars['timestamp']>;
  fee_amount: InputMaybe<Scalars['float8']>;
  fee_type: InputMaybe<Scalars['float8']>;
  hubspot_id: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  is_new: InputMaybe<Scalars['Boolean']>;
  last_hubspot_sync_at: InputMaybe<Scalars['timestamp']>;
  name: InputMaybe<Scalars['String']>;
  organization_id: InputMaybe<Scalars['float8']>;
  outreach_id: InputMaybe<Scalars['float8']>;
  parent_id: InputMaybe<Scalars['float8']>;
  updated_at: InputMaybe<Scalars['timestamp']>;
  visible_leads: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Outreach_Partners_Sum_Fields = {
  __typename?: 'outreach_partners_sum_fields';
  fee_amount: Maybe<Scalars['float8']>;
  fee_type: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['float8']>;
  organization_id: Maybe<Scalars['float8']>;
  outreach_id: Maybe<Scalars['float8']>;
  parent_id: Maybe<Scalars['float8']>;
};

export type Outreach_Partners_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Outreach_Partners_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Outreach_Partners_Set_Input>;
  /** filter the rows which have to be updated */
  where: Outreach_Partners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Outreach_Partners_Var_Pop_Fields = {
  __typename?: 'outreach_partners_var_pop_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Outreach_Partners_Var_Samp_Fields = {
  __typename?: 'outreach_partners_var_samp_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Outreach_Partners_Variance_Fields = {
  __typename?: 'outreach_partners_variance_fields';
  fee_amount: Maybe<Scalars['Float']>;
  fee_type: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  organization_id: Maybe<Scalars['Float']>;
  outreach_id: Maybe<Scalars['Float']>;
  parent_id: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "outreach.google_locations" */
  outreach_google_locations: Array<Outreach_Google_Locations>;
  /** fetch aggregated fields from the table: "outreach.google_locations" */
  outreach_google_locations_aggregate: Outreach_Google_Locations_Aggregate;
  /** fetch data from the table: "outreach.partners" */
  outreach_partners: Array<Outreach_Partners>;
  /** fetch aggregated fields from the table: "outreach.partners" */
  outreach_partners_aggregate: Outreach_Partners_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_cannabinoids" */
  research__airbyte_raw_cannabinoids: Array<Research__Airbyte_Raw_Cannabinoids>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_cannabinoids" */
  research__airbyte_raw_cannabinoids_aggregate: Research__Airbyte_Raw_Cannabinoids_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_cannabinoids" using primary key columns */
  research__airbyte_raw_cannabinoids_by_pk: Maybe<Research__Airbyte_Raw_Cannabinoids>;
  /** fetch data from the table: "research._airbyte_raw_medical_conditions" */
  research__airbyte_raw_medical_conditions: Array<Research__Airbyte_Raw_Medical_Conditions>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_medical_conditions" */
  research__airbyte_raw_medical_conditions_aggregate: Research__Airbyte_Raw_Medical_Conditions_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_medical_conditions" using primary key columns */
  research__airbyte_raw_medical_conditions_by_pk: Maybe<Research__Airbyte_Raw_Medical_Conditions>;
  /** fetch data from the table: "research._airbyte_raw_organ_systems" */
  research__airbyte_raw_organ_systems: Array<Research__Airbyte_Raw_Organ_Systems>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_organ_systems" */
  research__airbyte_raw_organ_systems_aggregate: Research__Airbyte_Raw_Organ_Systems_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_organ_systems" using primary key columns */
  research__airbyte_raw_organ_systems_by_pk: Maybe<Research__Airbyte_Raw_Organ_Systems>;
  /** fetch data from the table: "research._airbyte_raw_studies" */
  research__airbyte_raw_studies: Array<Research__Airbyte_Raw_Studies>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_studies" */
  research__airbyte_raw_studies_aggregate: Research__Airbyte_Raw_Studies_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_studies" using primary key columns */
  research__airbyte_raw_studies_by_pk: Maybe<Research__Airbyte_Raw_Studies>;
  /** fetch data from the table: "research._airbyte_raw_terpenes" */
  research__airbyte_raw_terpenes: Array<Research__Airbyte_Raw_Terpenes>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_terpenes" */
  research__airbyte_raw_terpenes_aggregate: Research__Airbyte_Raw_Terpenes_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_terpenes" using primary key columns */
  research__airbyte_raw_terpenes_by_pk: Maybe<Research__Airbyte_Raw_Terpenes>;
  /** fetch data from the table: "research.administrations" */
  research_administrations: Array<Research_Administrations>;
  /** fetch aggregated fields from the table: "research.administrations" */
  research_administrations_aggregate: Research_Administrations_Aggregate;
  /** fetch data from the table: "research.cannabinoids" */
  research_cannabinoids: Array<Research_Cannabinoids>;
  /** fetch aggregated fields from the table: "research.cannabinoids" */
  research_cannabinoids_aggregate: Research_Cannabinoids_Aggregate;
  /** fetch data from the table: "research.cannabinoids_studies" */
  research_cannabinoids_studies: Array<Research_Cannabinoids_Studies>;
  /** fetch aggregated fields from the table: "research.cannabinoids_studies" */
  research_cannabinoids_studies_aggregate: Research_Cannabinoids_Studies_Aggregate;
  /** fetch data from the table: "research.chemotypes" */
  research_chemotypes: Array<Research_Chemotypes>;
  /** fetch aggregated fields from the table: "research.chemotypes" */
  research_chemotypes_aggregate: Research_Chemotypes_Aggregate;
  /** fetch data from the table: "research.ligands" */
  research_ligands: Array<Research_Ligands>;
  /** fetch aggregated fields from the table: "research.ligands" */
  research_ligands_aggregate: Research_Ligands_Aggregate;
  /** fetch data from the table: "research.locations" */
  research_locations: Array<Research_Locations>;
  /** fetch aggregated fields from the table: "research.locations" */
  research_locations_aggregate: Research_Locations_Aggregate;
  /** fetch data from the table: "research.medical_conditions" */
  research_medical_conditions: Array<Research_Medical_Conditions>;
  /** fetch aggregated fields from the table: "research.medical_conditions" */
  research_medical_conditions_aggregate: Research_Medical_Conditions_Aggregate;
  /** fetch data from the table: "research.medical_conditions_clinicial_dosing" */
  research_medical_conditions_clinicial_dosing: Array<Research_Medical_Conditions_Clinicial_Dosing>;
  /** fetch aggregated fields from the table: "research.medical_conditions_clinicial_dosing" */
  research_medical_conditions_clinicial_dosing_aggregate: Research_Medical_Conditions_Clinicial_Dosing_Aggregate;
  /** fetch data from the table: "research.medical_conditions_state_of_science" */
  research_medical_conditions_state_of_science: Array<Research_Medical_Conditions_State_Of_Science>;
  /** fetch aggregated fields from the table: "research.medical_conditions_state_of_science" */
  research_medical_conditions_state_of_science_aggregate: Research_Medical_Conditions_State_Of_Science_Aggregate;
  /** fetch data from the table: "research.medical_conditions_studies" */
  research_medical_conditions_studies: Array<Research_Medical_Conditions_Studies>;
  /** fetch aggregated fields from the table: "research.medical_conditions_studies" */
  research_medical_conditions_studies_aggregate: Research_Medical_Conditions_Studies_Aggregate;
  /** fetch data from the table: "research.organ_systems" */
  research_organ_systems: Array<Research_Organ_Systems>;
  /** fetch aggregated fields from the table: "research.organ_systems" */
  research_organ_systems_aggregate: Research_Organ_Systems_Aggregate;
  /** fetch data from the table: "research.organ_systems_studies" */
  research_organ_systems_studies: Array<Research_Organ_Systems_Studies>;
  /** fetch aggregated fields from the table: "research.organ_systems_studies" */
  research_organ_systems_studies_aggregate: Research_Organ_Systems_Studies_Aggregate;
  /** fetch data from the table: "research.receptors" */
  research_receptors: Array<Research_Receptors>;
  /** fetch aggregated fields from the table: "research.receptors" */
  research_receptors_aggregate: Research_Receptors_Aggregate;
  /** fetch data from the table: "research.studies" */
  research_studies: Array<Research_Studies>;
  /** fetch data from the table: "research.studies_administration" */
  research_studies_administration: Array<Research_Studies_Administration>;
  /** fetch aggregated fields from the table: "research.studies_administration" */
  research_studies_administration_aggregate: Research_Studies_Administration_Aggregate;
  /** fetch aggregated fields from the table: "research.studies" */
  research_studies_aggregate: Research_Studies_Aggregate;
  /** fetch data from the table: "research.studies_chemotypes" */
  research_studies_chemotypes: Array<Research_Studies_Chemotypes>;
  /** fetch aggregated fields from the table: "research.studies_chemotypes" */
  research_studies_chemotypes_aggregate: Research_Studies_Chemotypes_Aggregate;
  /** fetch data from the table: "research.studies_ligands" */
  research_studies_ligands: Array<Research_Studies_Ligands>;
  /** fetch aggregated fields from the table: "research.studies_ligands" */
  research_studies_ligands_aggregate: Research_Studies_Ligands_Aggregate;
  /** fetch data from the table: "research.studies_locations" */
  research_studies_locations: Array<Research_Studies_Locations>;
  /** fetch aggregated fields from the table: "research.studies_locations" */
  research_studies_locations_aggregate: Research_Studies_Locations_Aggregate;
  /** fetch data from the table: "research.studies_receptors" */
  research_studies_receptors: Array<Research_Studies_Receptors>;
  /** fetch aggregated fields from the table: "research.studies_receptors" */
  research_studies_receptors_aggregate: Research_Studies_Receptors_Aggregate;
  /** fetch data from the table: "research.terpenes" */
  research_terpenes: Array<Research_Terpenes>;
  /** fetch aggregated fields from the table: "research.terpenes" */
  research_terpenes_aggregate: Research_Terpenes_Aggregate;
  /** fetch data from the table: "research.terpenes_studies" */
  research_terpenes_studies: Array<Research_Terpenes_Studies>;
  /** fetch aggregated fields from the table: "research.terpenes_studies" */
  research_terpenes_studies_aggregate: Research_Terpenes_Studies_Aggregate;
};

export type Query_RootOutreach_Google_LocationsArgs = {
  distinct_on: InputMaybe<Array<Outreach_Google_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Google_Locations_Order_By>>;
  where: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
};

export type Query_RootOutreach_Google_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Outreach_Google_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Google_Locations_Order_By>>;
  where: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
};

export type Query_RootOutreach_PartnersArgs = {
  distinct_on: InputMaybe<Array<Outreach_Partners_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Partners_Order_By>>;
  where: InputMaybe<Outreach_Partners_Bool_Exp>;
};

export type Query_RootOutreach_Partners_AggregateArgs = {
  distinct_on: InputMaybe<Array<Outreach_Partners_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Partners_Order_By>>;
  where: InputMaybe<Outreach_Partners_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_CannabinoidsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Cannabinoids_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Cannabinoids_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Cannabinoids_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Cannabinoids_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Query_RootResearch__Airbyte_Raw_Medical_ConditionsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Order_By>
  >;
  where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Medical_Conditions_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Order_By>
  >;
  where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Medical_Conditions_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Query_RootResearch__Airbyte_Raw_Organ_SystemsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Organ_Systems_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Organ_Systems_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Organ_Systems_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Organ_Systems_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Query_RootResearch__Airbyte_Raw_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Studies_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Studies_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Studies_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Query_RootResearch__Airbyte_Raw_TerpenesArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Terpenes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

export type Query_RootResearch__Airbyte_Raw_Terpenes_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Query_RootResearch_AdministrationsArgs = {
  distinct_on: InputMaybe<Array<Research_Administrations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Administrations_Order_By>>;
  where: InputMaybe<Research_Administrations_Bool_Exp>;
};

export type Query_RootResearch_Administrations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Administrations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Administrations_Order_By>>;
  where: InputMaybe<Research_Administrations_Bool_Exp>;
};

export type Query_RootResearch_CannabinoidsArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Bool_Exp>;
};

export type Query_RootResearch_Cannabinoids_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Bool_Exp>;
};

export type Query_RootResearch_Cannabinoids_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

export type Query_RootResearch_Cannabinoids_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

export type Query_RootResearch_ChemotypesArgs = {
  distinct_on: InputMaybe<Array<Research_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Chemotypes_Bool_Exp>;
};

export type Query_RootResearch_Chemotypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Chemotypes_Bool_Exp>;
};

export type Query_RootResearch_LigandsArgs = {
  distinct_on: InputMaybe<Array<Research_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Ligands_Order_By>>;
  where: InputMaybe<Research_Ligands_Bool_Exp>;
};

export type Query_RootResearch_Ligands_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Ligands_Order_By>>;
  where: InputMaybe<Research_Ligands_Bool_Exp>;
};

export type Query_RootResearch_LocationsArgs = {
  distinct_on: InputMaybe<Array<Research_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Locations_Order_By>>;
  where: InputMaybe<Research_Locations_Bool_Exp>;
};

export type Query_RootResearch_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Locations_Order_By>>;
  where: InputMaybe<Research_Locations_Bool_Exp>;
};

export type Query_RootResearch_Medical_ConditionsArgs = {
  distinct_on: InputMaybe<Array<Research_Medical_Conditions_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
};

export type Query_RootResearch_Medical_Conditions_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Medical_Conditions_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
};

export type Query_RootResearch_Medical_Conditions_Clinicial_DosingArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Clinicial_Dosing_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<
    Array<Research_Medical_Conditions_Clinicial_Dosing_Order_By>
  >;
  where: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
};

export type Query_RootResearch_Medical_Conditions_Clinicial_Dosing_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
  };

export type Query_RootResearch_Medical_Conditions_State_Of_ScienceArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_State_Of_Science_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<
    Array<Research_Medical_Conditions_State_Of_Science_Order_By>
  >;
  where: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
};

export type Query_RootResearch_Medical_Conditions_State_Of_Science_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
  };

export type Query_RootResearch_Medical_Conditions_StudiesArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

export type Query_RootResearch_Medical_Conditions_Studies_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

export type Query_RootResearch_Organ_SystemsArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Bool_Exp>;
};

export type Query_RootResearch_Organ_Systems_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Bool_Exp>;
};

export type Query_RootResearch_Organ_Systems_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

export type Query_RootResearch_Organ_Systems_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

export type Query_RootResearch_ReceptorsArgs = {
  distinct_on: InputMaybe<Array<Research_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Receptors_Order_By>>;
  where: InputMaybe<Research_Receptors_Bool_Exp>;
};

export type Query_RootResearch_Receptors_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Receptors_Order_By>>;
  where: InputMaybe<Research_Receptors_Bool_Exp>;
};

export type Query_RootResearch_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Order_By>>;
  where: InputMaybe<Research_Studies_Bool_Exp>;
};

export type Query_RootResearch_Studies_AdministrationArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

export type Query_RootResearch_Studies_Administration_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

export type Query_RootResearch_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Order_By>>;
  where: InputMaybe<Research_Studies_Bool_Exp>;
};

export type Query_RootResearch_Studies_ChemotypesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

export type Query_RootResearch_Studies_Chemotypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

export type Query_RootResearch_Studies_LigandsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Ligands_Order_By>>;
  where: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
};

export type Query_RootResearch_Studies_Ligands_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Ligands_Order_By>>;
  where: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
};

export type Query_RootResearch_Studies_LocationsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

export type Query_RootResearch_Studies_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

export type Query_RootResearch_Studies_ReceptorsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Receptors_Order_By>>;
  where: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
};

export type Query_RootResearch_Studies_Receptors_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Receptors_Order_By>>;
  where: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
};

export type Query_RootResearch_TerpenesArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Order_By>>;
  where: InputMaybe<Research_Terpenes_Bool_Exp>;
};

export type Query_RootResearch_Terpenes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Order_By>>;
  where: InputMaybe<Research_Terpenes_Bool_Exp>;
};

export type Query_RootResearch_Terpenes_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Studies_Order_By>>;
  where: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
};

export type Query_RootResearch_Terpenes_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Studies_Order_By>>;
  where: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
};

/** columns and relationships of "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids = {
  __typename?: 'research__airbyte_raw_cannabinoids';
  _airbyte_ab_id: Scalars['String'];
  _airbyte_data: Maybe<Scalars['jsonb']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Airbyte_DataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Aggregate = {
  __typename?: 'research__airbyte_raw_cannabinoids_aggregate';
  aggregate: Maybe<Research__Airbyte_Raw_Cannabinoids_Aggregate_Fields>;
  nodes: Array<Research__Airbyte_Raw_Cannabinoids>;
};

/** aggregate fields of "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Aggregate_Fields = {
  __typename?: 'research__airbyte_raw_cannabinoids_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Research__Airbyte_Raw_Cannabinoids_Max_Fields>;
  min: Maybe<Research__Airbyte_Raw_Cannabinoids_Min_Fields>;
};

/** aggregate fields of "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Cannabinoids_Append_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "research._airbyte_raw_cannabinoids". All fields are combined with a logical 'AND'. */
export type Research__Airbyte_Raw_Cannabinoids_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_data: InputMaybe<Jsonb_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>>;
  _not: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
  _or: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>>;
};

/** unique or primary key constraints on table "research._airbyte_raw_cannabinoids" */
export enum Research__Airbyte_Raw_Cannabinoids_Constraint {
  /** unique or primary key constraint on columns "_airbyte_ab_id" */
  AirbyteRawCannabinoidsPkey = '_airbyte_raw_cannabinoids_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Research__Airbyte_Raw_Cannabinoids_Delete_At_Path_Input = {
  _airbyte_data: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Research__Airbyte_Raw_Cannabinoids_Delete_Elem_Input = {
  _airbyte_data: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Research__Airbyte_Raw_Cannabinoids_Delete_Key_Input = {
  _airbyte_data: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Research__Airbyte_Raw_Cannabinoids_Max_Fields = {
  __typename?: 'research__airbyte_raw_cannabinoids_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Research__Airbyte_Raw_Cannabinoids_Min_Fields = {
  __typename?: 'research__airbyte_raw_cannabinoids_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Mutation_Response = {
  __typename?: 'research__airbyte_raw_cannabinoids_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research__Airbyte_Raw_Cannabinoids>;
};

/** on_conflict condition type for table "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_On_Conflict = {
  constraint: Research__Airbyte_Raw_Cannabinoids_Constraint;
  update_columns: Array<Research__Airbyte_Raw_Cannabinoids_Update_Column>;
  where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
};

/** Ordering options when selecting data from "research._airbyte_raw_cannabinoids". */
export type Research__Airbyte_Raw_Cannabinoids_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_data: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
};

/** primary key columns input for table: research._airbyte_raw_cannabinoids */
export type Research__Airbyte_Raw_Cannabinoids_Pk_Columns_Input = {
  _airbyte_ab_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Cannabinoids_Prepend_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "research._airbyte_raw_cannabinoids" */
export enum Research__Airbyte_Raw_Cannabinoids_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

/** input type for updating data in table "research._airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "research__airbyte_raw_cannabinoids" */
export type Research__Airbyte_Raw_Cannabinoids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research__Airbyte_Raw_Cannabinoids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research__Airbyte_Raw_Cannabinoids_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "research._airbyte_raw_cannabinoids" */
export enum Research__Airbyte_Raw_Cannabinoids_Update_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

export type Research__Airbyte_Raw_Cannabinoids_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research__Airbyte_Raw_Cannabinoids_Bool_Exp;
};

/** columns and relationships of "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions = {
  __typename?: 'research__airbyte_raw_medical_conditions';
  _airbyte_ab_id: Scalars['String'];
  _airbyte_data: Maybe<Scalars['jsonb']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Airbyte_DataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Aggregate = {
  __typename?: 'research__airbyte_raw_medical_conditions_aggregate';
  aggregate: Maybe<Research__Airbyte_Raw_Medical_Conditions_Aggregate_Fields>;
  nodes: Array<Research__Airbyte_Raw_Medical_Conditions>;
};

/** aggregate fields of "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Aggregate_Fields = {
  __typename?: 'research__airbyte_raw_medical_conditions_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Research__Airbyte_Raw_Medical_Conditions_Max_Fields>;
  min: Maybe<Research__Airbyte_Raw_Medical_Conditions_Min_Fields>;
};

/** aggregate fields of "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Aggregate_FieldsCountArgs =
  {
    columns: InputMaybe<
      Array<Research__Airbyte_Raw_Medical_Conditions_Select_Column>
    >;
    distinct: InputMaybe<Scalars['Boolean']>;
  };

/** append existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Medical_Conditions_Append_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "research._airbyte_raw_medical_conditions". All fields are combined with a logical 'AND'. */
export type Research__Airbyte_Raw_Medical_Conditions_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_data: InputMaybe<Jsonb_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>>;
  _not: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
  _or: InputMaybe<Array<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>>;
};

/** unique or primary key constraints on table "research._airbyte_raw_medical_conditions" */
export enum Research__Airbyte_Raw_Medical_Conditions_Constraint {
  /** unique or primary key constraint on columns "_airbyte_ab_id" */
  AirbyteRawMedicalConditionsPkey = '_airbyte_raw_medical_conditions_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Research__Airbyte_Raw_Medical_Conditions_Delete_At_Path_Input = {
  _airbyte_data: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Research__Airbyte_Raw_Medical_Conditions_Delete_Elem_Input = {
  _airbyte_data: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Research__Airbyte_Raw_Medical_Conditions_Delete_Key_Input = {
  _airbyte_data: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Research__Airbyte_Raw_Medical_Conditions_Max_Fields = {
  __typename?: 'research__airbyte_raw_medical_conditions_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Research__Airbyte_Raw_Medical_Conditions_Min_Fields = {
  __typename?: 'research__airbyte_raw_medical_conditions_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Mutation_Response = {
  __typename?: 'research__airbyte_raw_medical_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research__Airbyte_Raw_Medical_Conditions>;
};

/** on_conflict condition type for table "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_On_Conflict = {
  constraint: Research__Airbyte_Raw_Medical_Conditions_Constraint;
  update_columns: Array<Research__Airbyte_Raw_Medical_Conditions_Update_Column>;
  where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
};

/** Ordering options when selecting data from "research._airbyte_raw_medical_conditions". */
export type Research__Airbyte_Raw_Medical_Conditions_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_data: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
};

/** primary key columns input for table: research._airbyte_raw_medical_conditions */
export type Research__Airbyte_Raw_Medical_Conditions_Pk_Columns_Input = {
  _airbyte_ab_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Medical_Conditions_Prepend_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "research._airbyte_raw_medical_conditions" */
export enum Research__Airbyte_Raw_Medical_Conditions_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

/** input type for updating data in table "research._airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "research__airbyte_raw_medical_conditions" */
export type Research__Airbyte_Raw_Medical_Conditions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research__Airbyte_Raw_Medical_Conditions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research__Airbyte_Raw_Medical_Conditions_Stream_Cursor_Value_Input =
  {
    _airbyte_ab_id: InputMaybe<Scalars['String']>;
    _airbyte_data: InputMaybe<Scalars['jsonb']>;
    _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  };

/** update columns of table "research._airbyte_raw_medical_conditions" */
export enum Research__Airbyte_Raw_Medical_Conditions_Update_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

export type Research__Airbyte_Raw_Medical_Conditions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research__Airbyte_Raw_Medical_Conditions_Bool_Exp;
};

/** columns and relationships of "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems = {
  __typename?: 'research__airbyte_raw_organ_systems';
  _airbyte_ab_id: Scalars['String'];
  _airbyte_data: Maybe<Scalars['jsonb']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Airbyte_DataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Aggregate = {
  __typename?: 'research__airbyte_raw_organ_systems_aggregate';
  aggregate: Maybe<Research__Airbyte_Raw_Organ_Systems_Aggregate_Fields>;
  nodes: Array<Research__Airbyte_Raw_Organ_Systems>;
};

/** aggregate fields of "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Aggregate_Fields = {
  __typename?: 'research__airbyte_raw_organ_systems_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Research__Airbyte_Raw_Organ_Systems_Max_Fields>;
  min: Maybe<Research__Airbyte_Raw_Organ_Systems_Min_Fields>;
};

/** aggregate fields of "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Organ_Systems_Append_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "research._airbyte_raw_organ_systems". All fields are combined with a logical 'AND'. */
export type Research__Airbyte_Raw_Organ_Systems_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_data: InputMaybe<Jsonb_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>>;
  _not: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
  _or: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>>;
};

/** unique or primary key constraints on table "research._airbyte_raw_organ_systems" */
export enum Research__Airbyte_Raw_Organ_Systems_Constraint {
  /** unique or primary key constraint on columns "_airbyte_ab_id" */
  AirbyteRawOrganSystemsPkey = '_airbyte_raw_organ_systems_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Research__Airbyte_Raw_Organ_Systems_Delete_At_Path_Input = {
  _airbyte_data: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Research__Airbyte_Raw_Organ_Systems_Delete_Elem_Input = {
  _airbyte_data: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Research__Airbyte_Raw_Organ_Systems_Delete_Key_Input = {
  _airbyte_data: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Research__Airbyte_Raw_Organ_Systems_Max_Fields = {
  __typename?: 'research__airbyte_raw_organ_systems_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Research__Airbyte_Raw_Organ_Systems_Min_Fields = {
  __typename?: 'research__airbyte_raw_organ_systems_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Mutation_Response = {
  __typename?: 'research__airbyte_raw_organ_systems_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research__Airbyte_Raw_Organ_Systems>;
};

/** on_conflict condition type for table "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_On_Conflict = {
  constraint: Research__Airbyte_Raw_Organ_Systems_Constraint;
  update_columns: Array<Research__Airbyte_Raw_Organ_Systems_Update_Column>;
  where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
};

/** Ordering options when selecting data from "research._airbyte_raw_organ_systems". */
export type Research__Airbyte_Raw_Organ_Systems_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_data: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
};

/** primary key columns input for table: research._airbyte_raw_organ_systems */
export type Research__Airbyte_Raw_Organ_Systems_Pk_Columns_Input = {
  _airbyte_ab_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Organ_Systems_Prepend_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "research._airbyte_raw_organ_systems" */
export enum Research__Airbyte_Raw_Organ_Systems_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

/** input type for updating data in table "research._airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "research__airbyte_raw_organ_systems" */
export type Research__Airbyte_Raw_Organ_Systems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research__Airbyte_Raw_Organ_Systems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research__Airbyte_Raw_Organ_Systems_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "research._airbyte_raw_organ_systems" */
export enum Research__Airbyte_Raw_Organ_Systems_Update_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

export type Research__Airbyte_Raw_Organ_Systems_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research__Airbyte_Raw_Organ_Systems_Bool_Exp;
};

/** columns and relationships of "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies = {
  __typename?: 'research__airbyte_raw_studies';
  _airbyte_ab_id: Scalars['String'];
  _airbyte_data: Maybe<Scalars['jsonb']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Airbyte_DataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Aggregate = {
  __typename?: 'research__airbyte_raw_studies_aggregate';
  aggregate: Maybe<Research__Airbyte_Raw_Studies_Aggregate_Fields>;
  nodes: Array<Research__Airbyte_Raw_Studies>;
};

/** aggregate fields of "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Aggregate_Fields = {
  __typename?: 'research__airbyte_raw_studies_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Research__Airbyte_Raw_Studies_Max_Fields>;
  min: Maybe<Research__Airbyte_Raw_Studies_Min_Fields>;
};

/** aggregate fields of "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research__Airbyte_Raw_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Studies_Append_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "research._airbyte_raw_studies". All fields are combined with a logical 'AND'. */
export type Research__Airbyte_Raw_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_data: InputMaybe<Jsonb_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research__Airbyte_Raw_Studies_Bool_Exp>>;
  _not: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research__Airbyte_Raw_Studies_Bool_Exp>>;
};

/** unique or primary key constraints on table "research._airbyte_raw_studies" */
export enum Research__Airbyte_Raw_Studies_Constraint {
  /** unique or primary key constraint on columns "_airbyte_ab_id" */
  AirbyteRawStudiesPkey = '_airbyte_raw_studies_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Research__Airbyte_Raw_Studies_Delete_At_Path_Input = {
  _airbyte_data: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Research__Airbyte_Raw_Studies_Delete_Elem_Input = {
  _airbyte_data: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Research__Airbyte_Raw_Studies_Delete_Key_Input = {
  _airbyte_data: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Research__Airbyte_Raw_Studies_Max_Fields = {
  __typename?: 'research__airbyte_raw_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Research__Airbyte_Raw_Studies_Min_Fields = {
  __typename?: 'research__airbyte_raw_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Mutation_Response = {
  __typename?: 'research__airbyte_raw_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research__Airbyte_Raw_Studies>;
};

/** on_conflict condition type for table "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_On_Conflict = {
  constraint: Research__Airbyte_Raw_Studies_Constraint;
  update_columns: Array<Research__Airbyte_Raw_Studies_Update_Column>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

/** Ordering options when selecting data from "research._airbyte_raw_studies". */
export type Research__Airbyte_Raw_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_data: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
};

/** primary key columns input for table: research._airbyte_raw_studies */
export type Research__Airbyte_Raw_Studies_Pk_Columns_Input = {
  _airbyte_ab_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Studies_Prepend_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "research._airbyte_raw_studies" */
export enum Research__Airbyte_Raw_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

/** input type for updating data in table "research._airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "research__airbyte_raw_studies" */
export type Research__Airbyte_Raw_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research__Airbyte_Raw_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research__Airbyte_Raw_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "research._airbyte_raw_studies" */
export enum Research__Airbyte_Raw_Studies_Update_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

export type Research__Airbyte_Raw_Studies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Research__Airbyte_Raw_Studies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Studies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Research__Airbyte_Raw_Studies_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Research__Airbyte_Raw_Studies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research__Airbyte_Raw_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research__Airbyte_Raw_Studies_Bool_Exp;
};

/** columns and relationships of "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes = {
  __typename?: 'research__airbyte_raw_terpenes';
  _airbyte_ab_id: Scalars['String'];
  _airbyte_data: Maybe<Scalars['jsonb']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Airbyte_DataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Aggregate = {
  __typename?: 'research__airbyte_raw_terpenes_aggregate';
  aggregate: Maybe<Research__Airbyte_Raw_Terpenes_Aggregate_Fields>;
  nodes: Array<Research__Airbyte_Raw_Terpenes>;
};

/** aggregate fields of "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Aggregate_Fields = {
  __typename?: 'research__airbyte_raw_terpenes_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Research__Airbyte_Raw_Terpenes_Max_Fields>;
  min: Maybe<Research__Airbyte_Raw_Terpenes_Min_Fields>;
};

/** aggregate fields of "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Terpenes_Append_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "research._airbyte_raw_terpenes". All fields are combined with a logical 'AND'. */
export type Research__Airbyte_Raw_Terpenes_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_data: InputMaybe<Jsonb_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Bool_Exp>>;
  _not: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
  _or: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Bool_Exp>>;
};

/** unique or primary key constraints on table "research._airbyte_raw_terpenes" */
export enum Research__Airbyte_Raw_Terpenes_Constraint {
  /** unique or primary key constraint on columns "_airbyte_ab_id" */
  AirbyteRawTerpenesPkey = '_airbyte_raw_terpenes_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Research__Airbyte_Raw_Terpenes_Delete_At_Path_Input = {
  _airbyte_data: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Research__Airbyte_Raw_Terpenes_Delete_Elem_Input = {
  _airbyte_data: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Research__Airbyte_Raw_Terpenes_Delete_Key_Input = {
  _airbyte_data: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Research__Airbyte_Raw_Terpenes_Max_Fields = {
  __typename?: 'research__airbyte_raw_terpenes_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Research__Airbyte_Raw_Terpenes_Min_Fields = {
  __typename?: 'research__airbyte_raw_terpenes_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Mutation_Response = {
  __typename?: 'research__airbyte_raw_terpenes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research__Airbyte_Raw_Terpenes>;
};

/** on_conflict condition type for table "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_On_Conflict = {
  constraint: Research__Airbyte_Raw_Terpenes_Constraint;
  update_columns: Array<Research__Airbyte_Raw_Terpenes_Update_Column>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

/** Ordering options when selecting data from "research._airbyte_raw_terpenes". */
export type Research__Airbyte_Raw_Terpenes_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_data: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
};

/** primary key columns input for table: research._airbyte_raw_terpenes */
export type Research__Airbyte_Raw_Terpenes_Pk_Columns_Input = {
  _airbyte_ab_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Research__Airbyte_Raw_Terpenes_Prepend_Input = {
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "research._airbyte_raw_terpenes" */
export enum Research__Airbyte_Raw_Terpenes_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

/** input type for updating data in table "research._airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "research__airbyte_raw_terpenes" */
export type Research__Airbyte_Raw_Terpenes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research__Airbyte_Raw_Terpenes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research__Airbyte_Raw_Terpenes_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_data: InputMaybe<Scalars['jsonb']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "research._airbyte_raw_terpenes" */
export enum Research__Airbyte_Raw_Terpenes_Update_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteData = '_airbyte_data',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
}

export type Research__Airbyte_Raw_Terpenes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Research__Airbyte_Raw_Terpenes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Research__Airbyte_Raw_Terpenes_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Research__Airbyte_Raw_Terpenes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research__Airbyte_Raw_Terpenes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research__Airbyte_Raw_Terpenes_Bool_Exp;
};

/** columns and relationships of "research.administrations" */
export type Research_Administrations = {
  __typename?: 'research_administrations';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_administrations_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  administration: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.administrations" */
export type Research_Administrations_Aggregate = {
  __typename?: 'research_administrations_aggregate';
  aggregate: Maybe<Research_Administrations_Aggregate_Fields>;
  nodes: Array<Research_Administrations>;
};

/** aggregate fields of "research.administrations" */
export type Research_Administrations_Aggregate_Fields = {
  __typename?: 'research_administrations_aggregate_fields';
  avg: Maybe<Research_Administrations_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Administrations_Max_Fields>;
  min: Maybe<Research_Administrations_Min_Fields>;
  stddev: Maybe<Research_Administrations_Stddev_Fields>;
  stddev_pop: Maybe<Research_Administrations_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Administrations_Stddev_Samp_Fields>;
  sum: Maybe<Research_Administrations_Sum_Fields>;
  var_pop: Maybe<Research_Administrations_Var_Pop_Fields>;
  var_samp: Maybe<Research_Administrations_Var_Samp_Fields>;
  variance: Maybe<Research_Administrations_Variance_Fields>;
};

/** aggregate fields of "research.administrations" */
export type Research_Administrations_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Administrations_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Administrations_Avg_Fields = {
  __typename?: 'research_administrations_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.administrations". All fields are combined with a logical 'AND'. */
export type Research_Administrations_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_administrations_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Administrations_Bool_Exp>>;
  _not: InputMaybe<Research_Administrations_Bool_Exp>;
  _or: InputMaybe<Array<Research_Administrations_Bool_Exp>>;
  administration: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.administrations" */
export type Research_Administrations_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.administrations" */
export type Research_Administrations_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_administrations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  administration: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Administrations_Max_Fields = {
  __typename?: 'research_administrations_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_administrations_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  administration: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Research_Administrations_Min_Fields = {
  __typename?: 'research_administrations_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_administrations_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  administration: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "research.administrations" */
export type Research_Administrations_Mutation_Response = {
  __typename?: 'research_administrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Administrations>;
};

/** Ordering options when selecting data from "research.administrations". */
export type Research_Administrations_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_administrations_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  administration: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
};

/** select columns of table "research.administrations" */
export enum Research_Administrations_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteAdministrationsHashid = '_airbyte_administrations_hashid',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Administration = 'administration',
  /** column name */
  Id = 'id',
}

/** input type for updating data in table "research.administrations" */
export type Research_Administrations_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_administrations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  administration: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Administrations_Stddev_Fields = {
  __typename?: 'research_administrations_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Administrations_Stddev_Pop_Fields = {
  __typename?: 'research_administrations_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Administrations_Stddev_Samp_Fields = {
  __typename?: 'research_administrations_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_administrations" */
export type Research_Administrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Administrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Administrations_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_administrations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  administration: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Administrations_Sum_Fields = {
  __typename?: 'research_administrations_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Administrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Administrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Administrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Administrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Administrations_Var_Pop_Fields = {
  __typename?: 'research_administrations_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Administrations_Var_Samp_Fields = {
  __typename?: 'research_administrations_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Administrations_Variance_Fields = {
  __typename?: 'research_administrations_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.cannabinoids" */
export type Research_Cannabinoids = {
  __typename?: 'research_cannabinoids';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  category: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  /** An array relationship */
  studies: Array<Research_Cannabinoids_Studies>;
  /** An aggregate relationship */
  studies_aggregate: Research_Cannabinoids_Studies_Aggregate;
};

/** columns and relationships of "research.cannabinoids" */
export type Research_CannabinoidsStudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

/** columns and relationships of "research.cannabinoids" */
export type Research_CannabinoidsStudies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

/** aggregated selection of "research.cannabinoids" */
export type Research_Cannabinoids_Aggregate = {
  __typename?: 'research_cannabinoids_aggregate';
  aggregate: Maybe<Research_Cannabinoids_Aggregate_Fields>;
  nodes: Array<Research_Cannabinoids>;
};

/** aggregate fields of "research.cannabinoids" */
export type Research_Cannabinoids_Aggregate_Fields = {
  __typename?: 'research_cannabinoids_aggregate_fields';
  avg: Maybe<Research_Cannabinoids_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Cannabinoids_Max_Fields>;
  min: Maybe<Research_Cannabinoids_Min_Fields>;
  stddev: Maybe<Research_Cannabinoids_Stddev_Fields>;
  stddev_pop: Maybe<Research_Cannabinoids_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Cannabinoids_Stddev_Samp_Fields>;
  sum: Maybe<Research_Cannabinoids_Sum_Fields>;
  var_pop: Maybe<Research_Cannabinoids_Var_Pop_Fields>;
  var_samp: Maybe<Research_Cannabinoids_Var_Samp_Fields>;
  variance: Maybe<Research_Cannabinoids_Variance_Fields>;
};

/** aggregate fields of "research.cannabinoids" */
export type Research_Cannabinoids_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Cannabinoids_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Cannabinoids_Avg_Fields = {
  __typename?: 'research_cannabinoids_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.cannabinoids". All fields are combined with a logical 'AND'. */
export type Research_Cannabinoids_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_cannabinoids_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Cannabinoids_Bool_Exp>>;
  _not: InputMaybe<Research_Cannabinoids_Bool_Exp>;
  _or: InputMaybe<Array<Research_Cannabinoids_Bool_Exp>>;
  category: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  studies: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  studies_aggregate: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "research.cannabinoids" */
export type Research_Cannabinoids_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.cannabinoids" */
export type Research_Cannabinoids_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  category: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  studies: InputMaybe<Research_Cannabinoids_Studies_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Research_Cannabinoids_Max_Fields = {
  __typename?: 'research_cannabinoids_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  category: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Cannabinoids_Min_Fields = {
  __typename?: 'research_cannabinoids_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  category: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.cannabinoids" */
export type Research_Cannabinoids_Mutation_Response = {
  __typename?: 'research_cannabinoids_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Cannabinoids>;
};

/** Ordering options when selecting data from "research.cannabinoids". */
export type Research_Cannabinoids_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_cannabinoids_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  category: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  studies_aggregate: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Order_By>;
};

/** select columns of table "research.cannabinoids" */
export enum Research_Cannabinoids_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteCannabinoidsHashid = '_airbyte_cannabinoids_hashid',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
}

/** input type for updating data in table "research.cannabinoids" */
export type Research_Cannabinoids_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  category: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Cannabinoids_Stddev_Fields = {
  __typename?: 'research_cannabinoids_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Cannabinoids_Stddev_Pop_Fields = {
  __typename?: 'research_cannabinoids_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Cannabinoids_Stddev_Samp_Fields = {
  __typename?: 'research_cannabinoids_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_cannabinoids" */
export type Research_Cannabinoids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Cannabinoids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Cannabinoids_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  category: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies = {
  __typename?: 'research_cannabinoids_studies';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  cannabinoid_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Aggregate = {
  __typename?: 'research_cannabinoids_studies_aggregate';
  aggregate: Maybe<Research_Cannabinoids_Studies_Aggregate_Fields>;
  nodes: Array<Research_Cannabinoids_Studies>;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Max = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Min = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Aggregate_Fields = {
  __typename?: 'research_cannabinoids_studies_aggregate_fields';
  avg: Maybe<Research_Cannabinoids_Studies_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Cannabinoids_Studies_Max_Fields>;
  min: Maybe<Research_Cannabinoids_Studies_Min_Fields>;
  stddev: Maybe<Research_Cannabinoids_Studies_Stddev_Fields>;
  stddev_pop: Maybe<Research_Cannabinoids_Studies_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Cannabinoids_Studies_Stddev_Samp_Fields>;
  sum: Maybe<Research_Cannabinoids_Studies_Sum_Fields>;
  var_pop: Maybe<Research_Cannabinoids_Studies_Var_Pop_Fields>;
  var_samp: Maybe<Research_Cannabinoids_Studies_Var_Samp_Fields>;
  variance: Maybe<Research_Cannabinoids_Studies_Variance_Fields>;
};

/** aggregate fields of "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Aggregate_Order_By = {
  avg: InputMaybe<Research_Cannabinoids_Studies_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Cannabinoids_Studies_Max_Order_By>;
  min: InputMaybe<Research_Cannabinoids_Studies_Min_Order_By>;
  stddev: InputMaybe<Research_Cannabinoids_Studies_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Cannabinoids_Studies_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Cannabinoids_Studies_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Cannabinoids_Studies_Sum_Order_By>;
  var_pop: InputMaybe<Research_Cannabinoids_Studies_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Cannabinoids_Studies_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Cannabinoids_Studies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Arr_Rel_Insert_Input = {
  data: Array<Research_Cannabinoids_Studies_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Cannabinoids_Studies_Avg_Fields = {
  __typename?: 'research_cannabinoids_studies_avg_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Avg_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.cannabinoids_studies". All fields are combined with a logical 'AND'. */
export type Research_Cannabinoids_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Cannabinoids_Studies_Bool_Exp>>;
  _not: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research_Cannabinoids_Studies_Bool_Exp>>;
  cannabinoid_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
  type: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Inc_Input = {
  cannabinoid_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  cannabinoid_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Cannabinoids_Studies_Max_Fields = {
  __typename?: 'research_cannabinoids_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  cannabinoid_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Cannabinoids_Studies_Min_Fields = {
  __typename?: 'research_cannabinoids_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  cannabinoid_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Mutation_Response = {
  __typename?: 'research_cannabinoids_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Cannabinoids_Studies>;
};

/** Ordering options when selecting data from "research.cannabinoids_studies". */
export type Research_Cannabinoids_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** select columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteCannabinoidsStudiesHashid = '_airbyte_cannabinoids_studies_hashid',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
  /** column name */
  Type = 'type',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_avg_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_corr_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_max_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_min_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_sum_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_cannabinoids_studies_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.cannabinoids_studies" */
export enum Research_Cannabinoids_Studies_Select_Column_Research_Cannabinoids_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  CannabinoidId = 'cannabinoid_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  cannabinoid_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Cannabinoids_Studies_Stddev_Fields = {
  __typename?: 'research_cannabinoids_studies_stddev_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Stddev_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Cannabinoids_Studies_Stddev_Pop_Fields = {
  __typename?: 'research_cannabinoids_studies_stddev_pop_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Stddev_Pop_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Cannabinoids_Studies_Stddev_Samp_Fields = {
  __typename?: 'research_cannabinoids_studies_stddev_samp_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Stddev_Samp_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Cannabinoids_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Cannabinoids_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_cannabinoids_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  cannabinoid_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Cannabinoids_Studies_Sum_Fields = {
  __typename?: 'research_cannabinoids_studies_sum_fields';
  cannabinoid_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Sum_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Cannabinoids_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Cannabinoids_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Cannabinoids_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Cannabinoids_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Cannabinoids_Studies_Var_Pop_Fields = {
  __typename?: 'research_cannabinoids_studies_var_pop_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Var_Pop_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Cannabinoids_Studies_Var_Samp_Fields = {
  __typename?: 'research_cannabinoids_studies_var_samp_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Var_Samp_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Cannabinoids_Studies_Variance_Fields = {
  __typename?: 'research_cannabinoids_studies_variance_fields';
  cannabinoid_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.cannabinoids_studies" */
export type Research_Cannabinoids_Studies_Variance_Order_By = {
  cannabinoid_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Research_Cannabinoids_Sum_Fields = {
  __typename?: 'research_cannabinoids_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Cannabinoids_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Cannabinoids_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Cannabinoids_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Cannabinoids_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Cannabinoids_Var_Pop_Fields = {
  __typename?: 'research_cannabinoids_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Cannabinoids_Var_Samp_Fields = {
  __typename?: 'research_cannabinoids_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Cannabinoids_Variance_Fields = {
  __typename?: 'research_cannabinoids_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.chemotypes" */
export type Research_Chemotypes = {
  __typename?: 'research_chemotypes';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  chemotype: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.chemotypes" */
export type Research_Chemotypes_Aggregate = {
  __typename?: 'research_chemotypes_aggregate';
  aggregate: Maybe<Research_Chemotypes_Aggregate_Fields>;
  nodes: Array<Research_Chemotypes>;
};

/** aggregate fields of "research.chemotypes" */
export type Research_Chemotypes_Aggregate_Fields = {
  __typename?: 'research_chemotypes_aggregate_fields';
  avg: Maybe<Research_Chemotypes_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Chemotypes_Max_Fields>;
  min: Maybe<Research_Chemotypes_Min_Fields>;
  stddev: Maybe<Research_Chemotypes_Stddev_Fields>;
  stddev_pop: Maybe<Research_Chemotypes_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Chemotypes_Stddev_Samp_Fields>;
  sum: Maybe<Research_Chemotypes_Sum_Fields>;
  var_pop: Maybe<Research_Chemotypes_Var_Pop_Fields>;
  var_samp: Maybe<Research_Chemotypes_Var_Samp_Fields>;
  variance: Maybe<Research_Chemotypes_Variance_Fields>;
};

/** aggregate fields of "research.chemotypes" */
export type Research_Chemotypes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Chemotypes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Chemotypes_Avg_Fields = {
  __typename?: 'research_chemotypes_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.chemotypes". All fields are combined with a logical 'AND'. */
export type Research_Chemotypes_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_chemotypes_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Chemotypes_Bool_Exp>>;
  _not: InputMaybe<Research_Chemotypes_Bool_Exp>;
  _or: InputMaybe<Array<Research_Chemotypes_Bool_Exp>>;
  chemotype: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.chemotypes" */
export type Research_Chemotypes_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.chemotypes" */
export type Research_Chemotypes_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  chemotype: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Chemotypes_Max_Fields = {
  __typename?: 'research_chemotypes_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  chemotype: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Research_Chemotypes_Min_Fields = {
  __typename?: 'research_chemotypes_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  chemotype: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "research.chemotypes" */
export type Research_Chemotypes_Mutation_Response = {
  __typename?: 'research_chemotypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Chemotypes>;
};

/** Ordering options when selecting data from "research.chemotypes". */
export type Research_Chemotypes_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_chemotypes_hashid: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  chemotype: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
};

/** select columns of table "research.chemotypes" */
export enum Research_Chemotypes_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteChemotypesHashid = '_airbyte_chemotypes_hashid',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Chemotype = 'chemotype',
  /** column name */
  Id = 'id',
}

/** input type for updating data in table "research.chemotypes" */
export type Research_Chemotypes_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  chemotype: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Chemotypes_Stddev_Fields = {
  __typename?: 'research_chemotypes_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Chemotypes_Stddev_Pop_Fields = {
  __typename?: 'research_chemotypes_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Chemotypes_Stddev_Samp_Fields = {
  __typename?: 'research_chemotypes_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_chemotypes" */
export type Research_Chemotypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Chemotypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Chemotypes_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_chemotypes_hashid: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  chemotype: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Chemotypes_Sum_Fields = {
  __typename?: 'research_chemotypes_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Chemotypes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Chemotypes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Chemotypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Chemotypes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Chemotypes_Var_Pop_Fields = {
  __typename?: 'research_chemotypes_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Chemotypes_Var_Samp_Fields = {
  __typename?: 'research_chemotypes_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Chemotypes_Variance_Fields = {
  __typename?: 'research_chemotypes_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.ligands" */
export type Research_Ligands = {
  __typename?: 'research_ligands';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  ligand: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.ligands" */
export type Research_Ligands_Aggregate = {
  __typename?: 'research_ligands_aggregate';
  aggregate: Maybe<Research_Ligands_Aggregate_Fields>;
  nodes: Array<Research_Ligands>;
};

/** aggregate fields of "research.ligands" */
export type Research_Ligands_Aggregate_Fields = {
  __typename?: 'research_ligands_aggregate_fields';
  avg: Maybe<Research_Ligands_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Ligands_Max_Fields>;
  min: Maybe<Research_Ligands_Min_Fields>;
  stddev: Maybe<Research_Ligands_Stddev_Fields>;
  stddev_pop: Maybe<Research_Ligands_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Ligands_Stddev_Samp_Fields>;
  sum: Maybe<Research_Ligands_Sum_Fields>;
  var_pop: Maybe<Research_Ligands_Var_Pop_Fields>;
  var_samp: Maybe<Research_Ligands_Var_Samp_Fields>;
  variance: Maybe<Research_Ligands_Variance_Fields>;
};

/** aggregate fields of "research.ligands" */
export type Research_Ligands_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Ligands_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Ligands_Avg_Fields = {
  __typename?: 'research_ligands_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.ligands". All fields are combined with a logical 'AND'. */
export type Research_Ligands_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_ligands_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Ligands_Bool_Exp>>;
  _not: InputMaybe<Research_Ligands_Bool_Exp>;
  _or: InputMaybe<Array<Research_Ligands_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  ligand: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.ligands" */
export type Research_Ligands_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.ligands" */
export type Research_Ligands_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  ligand: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Ligands_Max_Fields = {
  __typename?: 'research_ligands_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  ligand: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Ligands_Min_Fields = {
  __typename?: 'research_ligands_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  ligand: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.ligands" */
export type Research_Ligands_Mutation_Response = {
  __typename?: 'research_ligands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Ligands>;
};

/** Ordering options when selecting data from "research.ligands". */
export type Research_Ligands_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_ligands_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  ligand: InputMaybe<Order_By>;
};

/** select columns of table "research.ligands" */
export enum Research_Ligands_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteLigandsHashid = '_airbyte_ligands_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ligand = 'ligand',
}

/** input type for updating data in table "research.ligands" */
export type Research_Ligands_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  ligand: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Ligands_Stddev_Fields = {
  __typename?: 'research_ligands_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Ligands_Stddev_Pop_Fields = {
  __typename?: 'research_ligands_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Ligands_Stddev_Samp_Fields = {
  __typename?: 'research_ligands_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_ligands" */
export type Research_Ligands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Ligands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Ligands_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_ligands_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  ligand: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Ligands_Sum_Fields = {
  __typename?: 'research_ligands_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Ligands_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Ligands_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Ligands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Ligands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Ligands_Var_Pop_Fields = {
  __typename?: 'research_ligands_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Ligands_Var_Samp_Fields = {
  __typename?: 'research_ligands_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Ligands_Variance_Fields = {
  __typename?: 'research_ligands_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.locations" */
export type Research_Locations = {
  __typename?: 'research_locations';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  location: Maybe<Scalars['String']>;
  /** An array relationship */
  studies: Array<Research_Studies_Locations>;
  /** An aggregate relationship */
  studies_aggregate: Research_Studies_Locations_Aggregate;
};

/** columns and relationships of "research.locations" */
export type Research_LocationsStudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

/** columns and relationships of "research.locations" */
export type Research_LocationsStudies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

/** aggregated selection of "research.locations" */
export type Research_Locations_Aggregate = {
  __typename?: 'research_locations_aggregate';
  aggregate: Maybe<Research_Locations_Aggregate_Fields>;
  nodes: Array<Research_Locations>;
};

/** aggregate fields of "research.locations" */
export type Research_Locations_Aggregate_Fields = {
  __typename?: 'research_locations_aggregate_fields';
  avg: Maybe<Research_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Locations_Max_Fields>;
  min: Maybe<Research_Locations_Min_Fields>;
  stddev: Maybe<Research_Locations_Stddev_Fields>;
  stddev_pop: Maybe<Research_Locations_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Locations_Stddev_Samp_Fields>;
  sum: Maybe<Research_Locations_Sum_Fields>;
  var_pop: Maybe<Research_Locations_Var_Pop_Fields>;
  var_samp: Maybe<Research_Locations_Var_Samp_Fields>;
  variance: Maybe<Research_Locations_Variance_Fields>;
};

/** aggregate fields of "research.locations" */
export type Research_Locations_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Locations_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Locations_Avg_Fields = {
  __typename?: 'research_locations_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.locations". All fields are combined with a logical 'AND'. */
export type Research_Locations_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_locations_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Locations_Bool_Exp>>;
  _not: InputMaybe<Research_Locations_Bool_Exp>;
  _or: InputMaybe<Array<Research_Locations_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  location: InputMaybe<String_Comparison_Exp>;
  studies: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  studies_aggregate: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "research.locations" */
export type Research_Locations_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.locations" */
export type Research_Locations_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  location: InputMaybe<Scalars['String']>;
  studies: InputMaybe<Research_Studies_Locations_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Research_Locations_Max_Fields = {
  __typename?: 'research_locations_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  location: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Locations_Min_Fields = {
  __typename?: 'research_locations_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  location: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.locations" */
export type Research_Locations_Mutation_Response = {
  __typename?: 'research_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Locations>;
};

/** Ordering options when selecting data from "research.locations". */
export type Research_Locations_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_locations_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  location: InputMaybe<Order_By>;
  studies_aggregate: InputMaybe<Research_Studies_Locations_Aggregate_Order_By>;
};

/** select columns of table "research.locations" */
export enum Research_Locations_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteLocationsHashid = '_airbyte_locations_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
}

/** input type for updating data in table "research.locations" */
export type Research_Locations_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  location: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Locations_Stddev_Fields = {
  __typename?: 'research_locations_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Locations_Stddev_Pop_Fields = {
  __typename?: 'research_locations_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Locations_Stddev_Samp_Fields = {
  __typename?: 'research_locations_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_locations" */
export type Research_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Locations_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_locations_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  location: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Locations_Sum_Fields = {
  __typename?: 'research_locations_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Locations_Var_Pop_Fields = {
  __typename?: 'research_locations_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Locations_Var_Samp_Fields = {
  __typename?: 'research_locations_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Locations_Variance_Fields = {
  __typename?: 'research_locations_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.medical_conditions" */
export type Research_Medical_Conditions = {
  __typename?: 'research_medical_conditions';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  /** An array relationship */
  studies: Array<Research_Medical_Conditions_Studies>;
  /** An aggregate relationship */
  studies_aggregate: Research_Medical_Conditions_Studies_Aggregate;
  summary: Maybe<Scalars['String']>;
};

/** columns and relationships of "research.medical_conditions" */
export type Research_Medical_ConditionsStudiesArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

/** columns and relationships of "research.medical_conditions" */
export type Research_Medical_ConditionsStudies_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

/** aggregated selection of "research.medical_conditions" */
export type Research_Medical_Conditions_Aggregate = {
  __typename?: 'research_medical_conditions_aggregate';
  aggregate: Maybe<Research_Medical_Conditions_Aggregate_Fields>;
  nodes: Array<Research_Medical_Conditions>;
};

/** aggregate fields of "research.medical_conditions" */
export type Research_Medical_Conditions_Aggregate_Fields = {
  __typename?: 'research_medical_conditions_aggregate_fields';
  avg: Maybe<Research_Medical_Conditions_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Medical_Conditions_Max_Fields>;
  min: Maybe<Research_Medical_Conditions_Min_Fields>;
  stddev: Maybe<Research_Medical_Conditions_Stddev_Fields>;
  stddev_pop: Maybe<Research_Medical_Conditions_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Medical_Conditions_Stddev_Samp_Fields>;
  sum: Maybe<Research_Medical_Conditions_Sum_Fields>;
  var_pop: Maybe<Research_Medical_Conditions_Var_Pop_Fields>;
  var_samp: Maybe<Research_Medical_Conditions_Var_Samp_Fields>;
  variance: Maybe<Research_Medical_Conditions_Variance_Fields>;
};

/** aggregate fields of "research.medical_conditions" */
export type Research_Medical_Conditions_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Medical_Conditions_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Medical_Conditions_Avg_Fields = {
  __typename?: 'research_medical_conditions_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.medical_conditions". All fields are combined with a logical 'AND'. */
export type Research_Medical_Conditions_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_medical_conditions_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Medical_Conditions_Bool_Exp>>;
  _not: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
  _or: InputMaybe<Array<Research_Medical_Conditions_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  studies: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  studies_aggregate: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp>;
  summary: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing = {
  __typename?: 'research_medical_conditions_clinicial_dosing';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__inicial_dosing_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  meta: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Aggregate = {
  __typename?: 'research_medical_conditions_clinicial_dosing_aggregate';
  aggregate: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Aggregate_Fields>;
  nodes: Array<Research_Medical_Conditions_Clinicial_Dosing>;
};

/** aggregate fields of "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Aggregate_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_aggregate_fields';
  avg: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Max_Fields>;
  min: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Min_Fields>;
  stddev: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Stddev_Fields>;
  stddev_pop: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Stddev_Samp_Fields>;
  sum: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Sum_Fields>;
  var_pop: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Var_Pop_Fields>;
  var_samp: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Var_Samp_Fields>;
  variance: Maybe<Research_Medical_Conditions_Clinicial_Dosing_Variance_Fields>;
};

/** aggregate fields of "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Aggregate_FieldsCountArgs =
  {
    columns: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Select_Column>
    >;
    distinct: InputMaybe<Scalars['Boolean']>;
  };

/** aggregate avg on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Avg_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_avg_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.medical_conditions_clinicial_dosing". All fields are combined with a logical 'AND'. */
export type Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_medical_con__inicial_dosing_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<
    Array<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>
  >;
  _not: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
  _or: InputMaybe<Array<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>>;
  medical_condition_id: InputMaybe<Float8_Comparison_Exp>;
  meta: InputMaybe<String_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  value: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Inc_Input = {
  medical_condition_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_con__inicial_dosing_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  meta: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  value: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Max_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__inicial_dosing_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  meta: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Min_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__inicial_dosing_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  meta: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Mutation_Response = {
  __typename?: 'research_medical_conditions_clinicial_dosing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Medical_Conditions_Clinicial_Dosing>;
};

/** Ordering options when selecting data from "research.medical_conditions_clinicial_dosing". */
export type Research_Medical_Conditions_Clinicial_Dosing_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_con__inicial_dosing_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  medical_condition_id: InputMaybe<Order_By>;
  meta: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  value: InputMaybe<Order_By>;
};

/** select columns of table "research.medical_conditions_clinicial_dosing" */
export enum Research_Medical_Conditions_Clinicial_Dosing_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteMedicalConInicialDosingHashid = '_airbyte_medical_con__inicial_dosing_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "research.medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_con__inicial_dosing_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  meta: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  value: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Stddev_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_stddev_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Stddev_Pop_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_stddev_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Stddev_Samp_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_stddev_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_medical_conditions_clinicial_dosing" */
export type Research_Medical_Conditions_Clinicial_Dosing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Medical_Conditions_Clinicial_Dosing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Medical_Conditions_Clinicial_Dosing_Stream_Cursor_Value_Input =
  {
    _airbyte_ab_id: InputMaybe<Scalars['String']>;
    _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
    _airbyte_medical_con__inicial_dosing_hashid: InputMaybe<Scalars['String']>;
    _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
    medical_condition_id: InputMaybe<Scalars['float8']>;
    meta: InputMaybe<Scalars['String']>;
    name: InputMaybe<Scalars['String']>;
    value: InputMaybe<Scalars['String']>;
  };

/** aggregate sum on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Sum_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_sum_fields';
  medical_condition_id: Maybe<Scalars['float8']>;
};

export type Research_Medical_Conditions_Clinicial_Dosing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Var_Pop_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_var_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Var_Samp_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_var_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Medical_Conditions_Clinicial_Dosing_Variance_Fields = {
  __typename?: 'research_medical_conditions_clinicial_dosing_variance_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "research.medical_conditions" */
export type Research_Medical_Conditions_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.medical_conditions" */
export type Research_Medical_Conditions_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  studies: InputMaybe<Research_Medical_Conditions_Studies_Arr_Rel_Insert_Input>;
  summary: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Medical_Conditions_Max_Fields = {
  __typename?: 'research_medical_conditions_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Medical_Conditions_Min_Fields = {
  __typename?: 'research_medical_conditions_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.medical_conditions" */
export type Research_Medical_Conditions_Mutation_Response = {
  __typename?: 'research_medical_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Medical_Conditions>;
};

/** Ordering options when selecting data from "research.medical_conditions". */
export type Research_Medical_Conditions_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_conditions_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  studies_aggregate: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Order_By>;
  summary: InputMaybe<Order_By>;
};

/** select columns of table "research.medical_conditions" */
export enum Research_Medical_Conditions_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteMedicalConditionsHashid = '_airbyte_medical_conditions_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Summary = 'summary',
}

/** input type for updating data in table "research.medical_conditions" */
export type Research_Medical_Conditions_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science = {
  __typename?: 'research_medical_conditions_state_of_science';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__ate_of_science_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  dose: Maybe<Scalars['String']>;
  form: Maybe<Scalars['String']>;
  key_findings: Maybe<Scalars['String']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_title: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Aggregate = {
  __typename?: 'research_medical_conditions_state_of_science_aggregate';
  aggregate: Maybe<Research_Medical_Conditions_State_Of_Science_Aggregate_Fields>;
  nodes: Array<Research_Medical_Conditions_State_Of_Science>;
};

/** aggregate fields of "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Aggregate_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_aggregate_fields';
  avg: Maybe<Research_Medical_Conditions_State_Of_Science_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Medical_Conditions_State_Of_Science_Max_Fields>;
  min: Maybe<Research_Medical_Conditions_State_Of_Science_Min_Fields>;
  stddev: Maybe<Research_Medical_Conditions_State_Of_Science_Stddev_Fields>;
  stddev_pop: Maybe<Research_Medical_Conditions_State_Of_Science_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Medical_Conditions_State_Of_Science_Stddev_Samp_Fields>;
  sum: Maybe<Research_Medical_Conditions_State_Of_Science_Sum_Fields>;
  var_pop: Maybe<Research_Medical_Conditions_State_Of_Science_Var_Pop_Fields>;
  var_samp: Maybe<Research_Medical_Conditions_State_Of_Science_Var_Samp_Fields>;
  variance: Maybe<Research_Medical_Conditions_State_Of_Science_Variance_Fields>;
};

/** aggregate fields of "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Aggregate_FieldsCountArgs =
  {
    columns: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Select_Column>
    >;
    distinct: InputMaybe<Scalars['Boolean']>;
  };

/** aggregate avg on columns */
export type Research_Medical_Conditions_State_Of_Science_Avg_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_avg_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.medical_conditions_state_of_science". All fields are combined with a logical 'AND'. */
export type Research_Medical_Conditions_State_Of_Science_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_medical_con__ate_of_science_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<
    Array<Research_Medical_Conditions_State_Of_Science_Bool_Exp>
  >;
  _not: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
  _or: InputMaybe<Array<Research_Medical_Conditions_State_Of_Science_Bool_Exp>>;
  dose: InputMaybe<String_Comparison_Exp>;
  form: InputMaybe<String_Comparison_Exp>;
  key_findings: InputMaybe<String_Comparison_Exp>;
  medical_condition_id: InputMaybe<Float8_Comparison_Exp>;
  study_title: InputMaybe<String_Comparison_Exp>;
  year: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Inc_Input = {
  medical_condition_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_con__ate_of_science_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  dose: InputMaybe<Scalars['String']>;
  form: InputMaybe<Scalars['String']>;
  key_findings: InputMaybe<Scalars['String']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_title: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Medical_Conditions_State_Of_Science_Max_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__ate_of_science_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  dose: Maybe<Scalars['String']>;
  form: Maybe<Scalars['String']>;
  key_findings: Maybe<Scalars['String']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_title: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Medical_Conditions_State_Of_Science_Min_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_con__ate_of_science_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  dose: Maybe<Scalars['String']>;
  form: Maybe<Scalars['String']>;
  key_findings: Maybe<Scalars['String']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_title: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Mutation_Response = {
  __typename?: 'research_medical_conditions_state_of_science_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Medical_Conditions_State_Of_Science>;
};

/** Ordering options when selecting data from "research.medical_conditions_state_of_science". */
export type Research_Medical_Conditions_State_Of_Science_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_con__ate_of_science_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  dose: InputMaybe<Order_By>;
  form: InputMaybe<Order_By>;
  key_findings: InputMaybe<Order_By>;
  medical_condition_id: InputMaybe<Order_By>;
  study_title: InputMaybe<Order_By>;
  year: InputMaybe<Order_By>;
};

/** select columns of table "research.medical_conditions_state_of_science" */
export enum Research_Medical_Conditions_State_Of_Science_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteMedicalConAteOfScienceHashid = '_airbyte_medical_con__ate_of_science_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  Dose = 'dose',
  /** column name */
  Form = 'form',
  /** column name */
  KeyFindings = 'key_findings',
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyTitle = 'study_title',
  /** column name */
  Year = 'year',
}

/** input type for updating data in table "research.medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_con__ate_of_science_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  dose: InputMaybe<Scalars['String']>;
  form: InputMaybe<Scalars['String']>;
  key_findings: InputMaybe<Scalars['String']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_title: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Medical_Conditions_State_Of_Science_Stddev_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_stddev_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Medical_Conditions_State_Of_Science_Stddev_Pop_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_stddev_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Medical_Conditions_State_Of_Science_Stddev_Samp_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_stddev_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_medical_conditions_state_of_science" */
export type Research_Medical_Conditions_State_Of_Science_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Medical_Conditions_State_Of_Science_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Medical_Conditions_State_Of_Science_Stream_Cursor_Value_Input =
  {
    _airbyte_ab_id: InputMaybe<Scalars['String']>;
    _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
    _airbyte_medical_con__ate_of_science_hashid: InputMaybe<Scalars['String']>;
    _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
    dose: InputMaybe<Scalars['String']>;
    form: InputMaybe<Scalars['String']>;
    key_findings: InputMaybe<Scalars['String']>;
    medical_condition_id: InputMaybe<Scalars['float8']>;
    study_title: InputMaybe<Scalars['String']>;
    year: InputMaybe<Scalars['String']>;
  };

/** aggregate sum on columns */
export type Research_Medical_Conditions_State_Of_Science_Sum_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_sum_fields';
  medical_condition_id: Maybe<Scalars['float8']>;
};

export type Research_Medical_Conditions_State_Of_Science_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Medical_Conditions_State_Of_Science_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Medical_Conditions_State_Of_Science_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Medical_Conditions_State_Of_Science_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Medical_Conditions_State_Of_Science_Var_Pop_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_var_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Medical_Conditions_State_Of_Science_Var_Samp_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_var_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Medical_Conditions_State_Of_Science_Variance_Fields = {
  __typename?: 'research_medical_conditions_state_of_science_variance_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Research_Medical_Conditions_Stddev_Fields = {
  __typename?: 'research_medical_conditions_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Medical_Conditions_Stddev_Pop_Fields = {
  __typename?: 'research_medical_conditions_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Medical_Conditions_Stddev_Samp_Fields = {
  __typename?: 'research_medical_conditions_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_medical_conditions" */
export type Research_Medical_Conditions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Medical_Conditions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Medical_Conditions_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies = {
  __typename?: 'research_medical_conditions_studies';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Aggregate = {
  __typename?: 'research_medical_conditions_studies_aggregate';
  aggregate: Maybe<Research_Medical_Conditions_Studies_Aggregate_Fields>;
  nodes: Array<Research_Medical_Conditions_Studies>;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp =
  {
    arguments: Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct: InputMaybe<Scalars['Boolean']>;
    filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Max = {
  arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Min = {
  arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Stddev_Samp =
  {
    arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct: InputMaybe<Scalars['Boolean']>;
    filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Aggregate_Fields = {
  __typename?: 'research_medical_conditions_studies_aggregate_fields';
  avg: Maybe<Research_Medical_Conditions_Studies_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Medical_Conditions_Studies_Max_Fields>;
  min: Maybe<Research_Medical_Conditions_Studies_Min_Fields>;
  stddev: Maybe<Research_Medical_Conditions_Studies_Stddev_Fields>;
  stddev_pop: Maybe<Research_Medical_Conditions_Studies_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Medical_Conditions_Studies_Stddev_Samp_Fields>;
  sum: Maybe<Research_Medical_Conditions_Studies_Sum_Fields>;
  var_pop: Maybe<Research_Medical_Conditions_Studies_Var_Pop_Fields>;
  var_samp: Maybe<Research_Medical_Conditions_Studies_Var_Samp_Fields>;
  variance: Maybe<Research_Medical_Conditions_Studies_Variance_Fields>;
};

/** aggregate fields of "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Medical_Conditions_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Aggregate_Order_By = {
  avg: InputMaybe<Research_Medical_Conditions_Studies_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Medical_Conditions_Studies_Max_Order_By>;
  min: InputMaybe<Research_Medical_Conditions_Studies_Min_Order_By>;
  stddev: InputMaybe<Research_Medical_Conditions_Studies_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Medical_Conditions_Studies_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Medical_Conditions_Studies_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Medical_Conditions_Studies_Sum_Order_By>;
  var_pop: InputMaybe<Research_Medical_Conditions_Studies_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Medical_Conditions_Studies_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Medical_Conditions_Studies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Arr_Rel_Insert_Input = {
  data: Array<Research_Medical_Conditions_Studies_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Medical_Conditions_Studies_Avg_Fields = {
  __typename?: 'research_medical_conditions_studies_avg_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Avg_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.medical_conditions_studies". All fields are combined with a logical 'AND'. */
export type Research_Medical_Conditions_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<String_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Medical_Conditions_Studies_Bool_Exp>>;
  _not: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research_Medical_Conditions_Studies_Bool_Exp>>;
  medical_condition_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
  type: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Inc_Input = {
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Medical_Conditions_Studies_Max_Fields = {
  __typename?: 'research_medical_conditions_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Medical_Conditions_Studies_Min_Fields = {
  __typename?: 'research_medical_conditions_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: Maybe<Scalars['String']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  medical_condition_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Mutation_Response = {
  __typename?: 'research_medical_conditions_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Medical_Conditions_Studies>;
};

/** Ordering options when selecting data from "research.medical_conditions_studies". */
export type Research_Medical_Conditions_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** select columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteMedicalConditionsStudiesHashid = '_airbyte_medical_conditions_studies_hashid',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
  /** column name */
  Type = 'type',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_avg_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_corr_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_max_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_min_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_sum_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_medical_conditions_studies_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.medical_conditions_studies" */
export enum Research_Medical_Conditions_Studies_Select_Column_Research_Medical_Conditions_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MedicalConditionId = 'medical_condition_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Medical_Conditions_Studies_Stddev_Fields = {
  __typename?: 'research_medical_conditions_studies_stddev_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Stddev_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Medical_Conditions_Studies_Stddev_Pop_Fields = {
  __typename?: 'research_medical_conditions_studies_stddev_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Stddev_Pop_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Medical_Conditions_Studies_Stddev_Samp_Fields = {
  __typename?: 'research_medical_conditions_studies_stddev_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Stddev_Samp_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Medical_Conditions_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Medical_Conditions_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_medical_conditions_studies_hashid: InputMaybe<Scalars['String']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  medical_condition_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Medical_Conditions_Studies_Sum_Fields = {
  __typename?: 'research_medical_conditions_studies_sum_fields';
  medical_condition_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Sum_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Medical_Conditions_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Medical_Conditions_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Medical_Conditions_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Medical_Conditions_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Medical_Conditions_Studies_Var_Pop_Fields = {
  __typename?: 'research_medical_conditions_studies_var_pop_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Var_Pop_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Medical_Conditions_Studies_Var_Samp_Fields = {
  __typename?: 'research_medical_conditions_studies_var_samp_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Var_Samp_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Medical_Conditions_Studies_Variance_Fields = {
  __typename?: 'research_medical_conditions_studies_variance_fields';
  medical_condition_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.medical_conditions_studies" */
export type Research_Medical_Conditions_Studies_Variance_Order_By = {
  medical_condition_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Research_Medical_Conditions_Sum_Fields = {
  __typename?: 'research_medical_conditions_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Medical_Conditions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Medical_Conditions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Medical_Conditions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Medical_Conditions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Medical_Conditions_Var_Pop_Fields = {
  __typename?: 'research_medical_conditions_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Medical_Conditions_Var_Samp_Fields = {
  __typename?: 'research_medical_conditions_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Medical_Conditions_Variance_Fields = {
  __typename?: 'research_medical_conditions_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.organ_systems" */
export type Research_Organ_Systems = {
  __typename?: 'research_organ_systems';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  /** An array relationship */
  studies: Array<Research_Organ_Systems_Studies>;
  /** An aggregate relationship */
  studies_aggregate: Research_Organ_Systems_Studies_Aggregate;
  summary: Maybe<Scalars['String']>;
};

/** columns and relationships of "research.organ_systems" */
export type Research_Organ_SystemsStudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

/** columns and relationships of "research.organ_systems" */
export type Research_Organ_SystemsStudies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

/** aggregated selection of "research.organ_systems" */
export type Research_Organ_Systems_Aggregate = {
  __typename?: 'research_organ_systems_aggregate';
  aggregate: Maybe<Research_Organ_Systems_Aggregate_Fields>;
  nodes: Array<Research_Organ_Systems>;
};

/** aggregate fields of "research.organ_systems" */
export type Research_Organ_Systems_Aggregate_Fields = {
  __typename?: 'research_organ_systems_aggregate_fields';
  avg: Maybe<Research_Organ_Systems_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Organ_Systems_Max_Fields>;
  min: Maybe<Research_Organ_Systems_Min_Fields>;
  stddev: Maybe<Research_Organ_Systems_Stddev_Fields>;
  stddev_pop: Maybe<Research_Organ_Systems_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Organ_Systems_Stddev_Samp_Fields>;
  sum: Maybe<Research_Organ_Systems_Sum_Fields>;
  var_pop: Maybe<Research_Organ_Systems_Var_Pop_Fields>;
  var_samp: Maybe<Research_Organ_Systems_Var_Samp_Fields>;
  variance: Maybe<Research_Organ_Systems_Variance_Fields>;
};

/** aggregate fields of "research.organ_systems" */
export type Research_Organ_Systems_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Organ_Systems_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Organ_Systems_Avg_Fields = {
  __typename?: 'research_organ_systems_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.organ_systems". All fields are combined with a logical 'AND'. */
export type Research_Organ_Systems_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_organ_systems_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Organ_Systems_Bool_Exp>>;
  _not: InputMaybe<Research_Organ_Systems_Bool_Exp>;
  _or: InputMaybe<Array<Research_Organ_Systems_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  studies: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  studies_aggregate: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp>;
  summary: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.organ_systems" */
export type Research_Organ_Systems_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.organ_systems" */
export type Research_Organ_Systems_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  studies: InputMaybe<Research_Organ_Systems_Studies_Arr_Rel_Insert_Input>;
  summary: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Organ_Systems_Max_Fields = {
  __typename?: 'research_organ_systems_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Organ_Systems_Min_Fields = {
  __typename?: 'research_organ_systems_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.organ_systems" */
export type Research_Organ_Systems_Mutation_Response = {
  __typename?: 'research_organ_systems_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Organ_Systems>;
};

/** Ordering options when selecting data from "research.organ_systems". */
export type Research_Organ_Systems_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_organ_systems_hashid: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  studies_aggregate: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Order_By>;
  summary: InputMaybe<Order_By>;
};

/** select columns of table "research.organ_systems" */
export enum Research_Organ_Systems_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteOrganSystemsHashid = '_airbyte_organ_systems_hashid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Summary = 'summary',
}

/** input type for updating data in table "research.organ_systems" */
export type Research_Organ_Systems_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Organ_Systems_Stddev_Fields = {
  __typename?: 'research_organ_systems_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Organ_Systems_Stddev_Pop_Fields = {
  __typename?: 'research_organ_systems_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Organ_Systems_Stddev_Samp_Fields = {
  __typename?: 'research_organ_systems_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_organ_systems" */
export type Research_Organ_Systems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Organ_Systems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Organ_Systems_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies = {
  __typename?: 'research_organ_systems_studies';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: Maybe<Scalars['String']>;
  organ_system_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Aggregate = {
  __typename?: 'research_organ_systems_studies_aggregate';
  aggregate: Maybe<Research_Organ_Systems_Studies_Aggregate_Fields>;
  nodes: Array<Research_Organ_Systems_Studies>;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Max = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Min = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Aggregate_Fields = {
  __typename?: 'research_organ_systems_studies_aggregate_fields';
  avg: Maybe<Research_Organ_Systems_Studies_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Organ_Systems_Studies_Max_Fields>;
  min: Maybe<Research_Organ_Systems_Studies_Min_Fields>;
  stddev: Maybe<Research_Organ_Systems_Studies_Stddev_Fields>;
  stddev_pop: Maybe<Research_Organ_Systems_Studies_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Organ_Systems_Studies_Stddev_Samp_Fields>;
  sum: Maybe<Research_Organ_Systems_Studies_Sum_Fields>;
  var_pop: Maybe<Research_Organ_Systems_Studies_Var_Pop_Fields>;
  var_samp: Maybe<Research_Organ_Systems_Studies_Var_Samp_Fields>;
  variance: Maybe<Research_Organ_Systems_Studies_Variance_Fields>;
};

/** aggregate fields of "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Aggregate_Order_By = {
  avg: InputMaybe<Research_Organ_Systems_Studies_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Organ_Systems_Studies_Max_Order_By>;
  min: InputMaybe<Research_Organ_Systems_Studies_Min_Order_By>;
  stddev: InputMaybe<Research_Organ_Systems_Studies_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Organ_Systems_Studies_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Organ_Systems_Studies_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Organ_Systems_Studies_Sum_Order_By>;
  var_pop: InputMaybe<Research_Organ_Systems_Studies_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Organ_Systems_Studies_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Organ_Systems_Studies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Arr_Rel_Insert_Input = {
  data: Array<Research_Organ_Systems_Studies_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Organ_Systems_Studies_Avg_Fields = {
  __typename?: 'research_organ_systems_studies_avg_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Avg_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.organ_systems_studies". All fields are combined with a logical 'AND'. */
export type Research_Organ_Systems_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Organ_Systems_Studies_Bool_Exp>>;
  _not: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research_Organ_Systems_Studies_Bool_Exp>>;
  organ_system_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
  type: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Inc_Input = {
  organ_system_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Scalars['String']>;
  organ_system_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Organ_Systems_Studies_Max_Fields = {
  __typename?: 'research_organ_systems_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: Maybe<Scalars['String']>;
  organ_system_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Order_By>;
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Organ_Systems_Studies_Min_Fields = {
  __typename?: 'research_organ_systems_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: Maybe<Scalars['String']>;
  organ_system_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Order_By>;
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Mutation_Response = {
  __typename?: 'research_organ_systems_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Organ_Systems_Studies>;
};

/** Ordering options when selecting data from "research.organ_systems_studies". */
export type Research_Organ_Systems_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Order_By>;
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** select columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteOrganSystemsStudiesHashid = '_airbyte_organ_systems_studies_hashid',
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
  /** column name */
  Type = 'type',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_avg_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_corr_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_max_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_min_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_sum_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_organ_systems_studies_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.organ_systems_studies" */
export enum Research_Organ_Systems_Studies_Select_Column_Research_Organ_Systems_Studies_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  OrganSystemId = 'organ_system_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Scalars['String']>;
  organ_system_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Organ_Systems_Studies_Stddev_Fields = {
  __typename?: 'research_organ_systems_studies_stddev_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Stddev_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Organ_Systems_Studies_Stddev_Pop_Fields = {
  __typename?: 'research_organ_systems_studies_stddev_pop_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Stddev_Pop_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Organ_Systems_Studies_Stddev_Samp_Fields = {
  __typename?: 'research_organ_systems_studies_stddev_samp_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Stddev_Samp_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_organ_systems_studies" */
export type Research_Organ_Systems_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Organ_Systems_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Organ_Systems_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_organ_systems_studies_hashid: InputMaybe<Scalars['String']>;
  organ_system_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Organ_Systems_Studies_Sum_Fields = {
  __typename?: 'research_organ_systems_studies_sum_fields';
  organ_system_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Sum_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Organ_Systems_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Organ_Systems_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Organ_Systems_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Organ_Systems_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Organ_Systems_Studies_Var_Pop_Fields = {
  __typename?: 'research_organ_systems_studies_var_pop_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Var_Pop_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Organ_Systems_Studies_Var_Samp_Fields = {
  __typename?: 'research_organ_systems_studies_var_samp_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Var_Samp_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Organ_Systems_Studies_Variance_Fields = {
  __typename?: 'research_organ_systems_studies_variance_fields';
  organ_system_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.organ_systems_studies" */
export type Research_Organ_Systems_Studies_Variance_Order_By = {
  organ_system_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Research_Organ_Systems_Sum_Fields = {
  __typename?: 'research_organ_systems_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Organ_Systems_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Organ_Systems_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Organ_Systems_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Organ_Systems_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Organ_Systems_Var_Pop_Fields = {
  __typename?: 'research_organ_systems_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Organ_Systems_Var_Samp_Fields = {
  __typename?: 'research_organ_systems_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Organ_Systems_Variance_Fields = {
  __typename?: 'research_organ_systems_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.receptors" */
export type Research_Receptors = {
  __typename?: 'research_receptors';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  receptor: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.receptors" */
export type Research_Receptors_Aggregate = {
  __typename?: 'research_receptors_aggregate';
  aggregate: Maybe<Research_Receptors_Aggregate_Fields>;
  nodes: Array<Research_Receptors>;
};

/** aggregate fields of "research.receptors" */
export type Research_Receptors_Aggregate_Fields = {
  __typename?: 'research_receptors_aggregate_fields';
  avg: Maybe<Research_Receptors_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Receptors_Max_Fields>;
  min: Maybe<Research_Receptors_Min_Fields>;
  stddev: Maybe<Research_Receptors_Stddev_Fields>;
  stddev_pop: Maybe<Research_Receptors_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Receptors_Stddev_Samp_Fields>;
  sum: Maybe<Research_Receptors_Sum_Fields>;
  var_pop: Maybe<Research_Receptors_Var_Pop_Fields>;
  var_samp: Maybe<Research_Receptors_Var_Samp_Fields>;
  variance: Maybe<Research_Receptors_Variance_Fields>;
};

/** aggregate fields of "research.receptors" */
export type Research_Receptors_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Receptors_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Receptors_Avg_Fields = {
  __typename?: 'research_receptors_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.receptors". All fields are combined with a logical 'AND'. */
export type Research_Receptors_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_receptors_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Receptors_Bool_Exp>>;
  _not: InputMaybe<Research_Receptors_Bool_Exp>;
  _or: InputMaybe<Array<Research_Receptors_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  receptor: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.receptors" */
export type Research_Receptors_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.receptors" */
export type Research_Receptors_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  receptor: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Receptors_Max_Fields = {
  __typename?: 'research_receptors_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  receptor: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Receptors_Min_Fields = {
  __typename?: 'research_receptors_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  receptor: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.receptors" */
export type Research_Receptors_Mutation_Response = {
  __typename?: 'research_receptors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Receptors>;
};

/** Ordering options when selecting data from "research.receptors". */
export type Research_Receptors_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_receptors_hashid: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  receptor: InputMaybe<Order_By>;
};

/** select columns of table "research.receptors" */
export enum Research_Receptors_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteReceptorsHashid = '_airbyte_receptors_hashid',
  /** column name */
  Id = 'id',
  /** column name */
  Receptor = 'receptor',
}

/** input type for updating data in table "research.receptors" */
export type Research_Receptors_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  receptor: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Receptors_Stddev_Fields = {
  __typename?: 'research_receptors_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Receptors_Stddev_Pop_Fields = {
  __typename?: 'research_receptors_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Receptors_Stddev_Samp_Fields = {
  __typename?: 'research_receptors_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_receptors" */
export type Research_Receptors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Receptors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Receptors_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_receptors_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  receptor: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Receptors_Sum_Fields = {
  __typename?: 'research_receptors_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Receptors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Receptors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Receptors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Receptors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Receptors_Var_Pop_Fields = {
  __typename?: 'research_receptors_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Receptors_Var_Samp_Fields = {
  __typename?: 'research_receptors_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Receptors_Variance_Fields = {
  __typename?: 'research_receptors_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.studies" */
export type Research_Studies = {
  __typename?: 'research_studies';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: Maybe<Scalars['String']>;
  /** An array relationship */
  administrations: Array<Research_Studies_Administration>;
  /** An aggregate relationship */
  administrations_aggregate: Research_Studies_Administration_Aggregate;
  /** An array relationship */
  cannabinoids: Array<Research_Cannabinoids_Studies>;
  /** An aggregate relationship */
  cannabinoids_aggregate: Research_Cannabinoids_Studies_Aggregate;
  category: Maybe<Scalars['String']>;
  /** An array relationship */
  chemotypes: Array<Research_Studies_Chemotypes>;
  /** An aggregate relationship */
  chemotypes_aggregate: Research_Studies_Chemotypes_Aggregate;
  /** An array relationship */
  conditions: Array<Research_Medical_Conditions_Studies>;
  /** An aggregate relationship */
  conditions_aggregate: Research_Medical_Conditions_Studies_Aggregate;
  dosage: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  keyfindings: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  /** An array relationship */
  locations: Array<Research_Studies_Locations>;
  /** An aggregate relationship */
  locations_aggregate: Research_Studies_Locations_Aggregate;
  /** An array relationship */
  organ_systems: Array<Research_Organ_Systems_Studies>;
  /** An aggregate relationship */
  organ_systems_aggregate: Research_Organ_Systems_Studies_Aggregate;
  phytocannabinoidsource: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  samplesize: Maybe<Scalars['float8']>;
  source: Maybe<Scalars['String']>;
  subratio: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  typeofstudy: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesAdministrationsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesAdministrations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesCannabinoidsArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesCannabinoids_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesChemotypesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesChemotypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesConditionsArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesConditions_AggregateArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesLocationsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesLocations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesOrgan_SystemsArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies" */
export type Research_StudiesOrgan_Systems_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

/** columns and relationships of "research.studies_administration" */
export type Research_Studies_Administration = {
  __typename?: 'research_studies_administration';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: Maybe<Scalars['String']>;
  administration_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.studies_administration" */
export type Research_Studies_Administration_Aggregate = {
  __typename?: 'research_studies_administration_aggregate';
  aggregate: Maybe<Research_Studies_Administration_Aggregate_Fields>;
  nodes: Array<Research_Studies_Administration>;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Studies_Administration_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Research_Studies_Administration_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Studies_Administration_Aggregate_Bool_Exp_Max = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Min = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Administration_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.studies_administration" */
export type Research_Studies_Administration_Aggregate_Fields = {
  __typename?: 'research_studies_administration_aggregate_fields';
  avg: Maybe<Research_Studies_Administration_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Administration_Max_Fields>;
  min: Maybe<Research_Studies_Administration_Min_Fields>;
  stddev: Maybe<Research_Studies_Administration_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Administration_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Administration_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Administration_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Administration_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Administration_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Administration_Variance_Fields>;
};

/** aggregate fields of "research.studies_administration" */
export type Research_Studies_Administration_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.studies_administration" */
export type Research_Studies_Administration_Aggregate_Order_By = {
  avg: InputMaybe<Research_Studies_Administration_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Studies_Administration_Max_Order_By>;
  min: InputMaybe<Research_Studies_Administration_Min_Order_By>;
  stddev: InputMaybe<Research_Studies_Administration_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Studies_Administration_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Studies_Administration_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Studies_Administration_Sum_Order_By>;
  var_pop: InputMaybe<Research_Studies_Administration_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Studies_Administration_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Studies_Administration_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.studies_administration" */
export type Research_Studies_Administration_Arr_Rel_Insert_Input = {
  data: Array<Research_Studies_Administration_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Studies_Administration_Avg_Fields = {
  __typename?: 'research_studies_administration_avg_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Avg_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.studies_administration". All fields are combined with a logical 'AND'. */
export type Research_Studies_Administration_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_administration_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Administration_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Administration_Bool_Exp>>;
  administration_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.studies_administration" */
export type Research_Studies_Administration_Inc_Input = {
  administration_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies_administration" */
export type Research_Studies_Administration_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: InputMaybe<Scalars['String']>;
  administration_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Studies_Administration_Max_Fields = {
  __typename?: 'research_studies_administration_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: Maybe<Scalars['String']>;
  administration_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_administration_hashid: InputMaybe<Order_By>;
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Studies_Administration_Min_Fields = {
  __typename?: 'research_studies_administration_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: Maybe<Scalars['String']>;
  administration_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_administration_hashid: InputMaybe<Order_By>;
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.studies_administration" */
export type Research_Studies_Administration_Mutation_Response = {
  __typename?: 'research_studies_administration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies_Administration>;
};

/** Ordering options when selecting data from "research.studies_administration". */
export type Research_Studies_Administration_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_administration_hashid: InputMaybe<Order_By>;
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** select columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesAdministrationHashid = '_airbyte_studies_administration_hashid',
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_avg_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_corr_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_max_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_min_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_sum_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_administration_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.studies_administration" */
export enum Research_Studies_Administration_Select_Column_Research_Studies_Administration_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AdministrationId = 'administration_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.studies_administration" */
export type Research_Studies_Administration_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: InputMaybe<Scalars['String']>;
  administration_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Administration_Stddev_Fields = {
  __typename?: 'research_studies_administration_stddev_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Stddev_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Administration_Stddev_Pop_Fields = {
  __typename?: 'research_studies_administration_stddev_pop_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Stddev_Pop_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Administration_Stddev_Samp_Fields = {
  __typename?: 'research_studies_administration_stddev_samp_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Stddev_Samp_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_studies_administration" */
export type Research_Studies_Administration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Administration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Administration_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_administration_hashid: InputMaybe<Scalars['String']>;
  administration_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Studies_Administration_Sum_Fields = {
  __typename?: 'research_studies_administration_sum_fields';
  administration_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Sum_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Studies_Administration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Administration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Administration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Administration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Administration_Var_Pop_Fields = {
  __typename?: 'research_studies_administration_var_pop_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Var_Pop_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Administration_Var_Samp_Fields = {
  __typename?: 'research_studies_administration_var_samp_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Var_Samp_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Studies_Administration_Variance_Fields = {
  __typename?: 'research_studies_administration_variance_fields';
  administration_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.studies_administration" */
export type Research_Studies_Administration_Variance_Order_By = {
  administration_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregated selection of "research.studies" */
export type Research_Studies_Aggregate = {
  __typename?: 'research_studies_aggregate';
  aggregate: Maybe<Research_Studies_Aggregate_Fields>;
  nodes: Array<Research_Studies>;
};

/** aggregate fields of "research.studies" */
export type Research_Studies_Aggregate_Fields = {
  __typename?: 'research_studies_aggregate_fields';
  avg: Maybe<Research_Studies_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Max_Fields>;
  min: Maybe<Research_Studies_Min_Fields>;
  stddev: Maybe<Research_Studies_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Variance_Fields>;
};

/** aggregate fields of "research.studies" */
export type Research_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Studies_Avg_Fields = {
  __typename?: 'research_studies_avg_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.studies". All fields are combined with a logical 'AND'. */
export type Research_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Bool_Exp>>;
  administrations: InputMaybe<Research_Studies_Administration_Bool_Exp>;
  administrations_aggregate: InputMaybe<Research_Studies_Administration_Aggregate_Bool_Exp>;
  cannabinoids: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
  cannabinoids_aggregate: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Bool_Exp>;
  category: InputMaybe<String_Comparison_Exp>;
  chemotypes: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  chemotypes_aggregate: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp>;
  conditions: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  conditions_aggregate: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Bool_Exp>;
  dosage: InputMaybe<String_Comparison_Exp>;
  id: InputMaybe<Float8_Comparison_Exp>;
  keyfindings: InputMaybe<String_Comparison_Exp>;
  link: InputMaybe<String_Comparison_Exp>;
  locations: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  locations_aggregate: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp>;
  organ_systems: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
  organ_systems_aggregate: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Bool_Exp>;
  phytocannabinoidsource: InputMaybe<String_Comparison_Exp>;
  result: InputMaybe<String_Comparison_Exp>;
  samplesize: InputMaybe<Float8_Comparison_Exp>;
  source: InputMaybe<String_Comparison_Exp>;
  subratio: InputMaybe<String_Comparison_Exp>;
  title: InputMaybe<String_Comparison_Exp>;
  typeofstudy: InputMaybe<String_Comparison_Exp>;
  year: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "research.studies_chemotypes" */
export type Research_Studies_Chemotypes = {
  __typename?: 'research_studies_chemotypes';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: Maybe<Scalars['String']>;
  chemotype_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Aggregate = {
  __typename?: 'research_studies_chemotypes_aggregate';
  aggregate: Maybe<Research_Studies_Chemotypes_Aggregate_Fields>;
  nodes: Array<Research_Studies_Chemotypes>;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Studies_Chemotypes_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Max = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Min = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Chemotypes_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Aggregate_Fields = {
  __typename?: 'research_studies_chemotypes_aggregate_fields';
  avg: Maybe<Research_Studies_Chemotypes_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Chemotypes_Max_Fields>;
  min: Maybe<Research_Studies_Chemotypes_Min_Fields>;
  stddev: Maybe<Research_Studies_Chemotypes_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Chemotypes_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Chemotypes_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Chemotypes_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Chemotypes_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Chemotypes_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Chemotypes_Variance_Fields>;
};

/** aggregate fields of "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Aggregate_Order_By = {
  avg: InputMaybe<Research_Studies_Chemotypes_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Studies_Chemotypes_Max_Order_By>;
  min: InputMaybe<Research_Studies_Chemotypes_Min_Order_By>;
  stddev: InputMaybe<Research_Studies_Chemotypes_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Studies_Chemotypes_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Studies_Chemotypes_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Studies_Chemotypes_Sum_Order_By>;
  var_pop: InputMaybe<Research_Studies_Chemotypes_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Studies_Chemotypes_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Studies_Chemotypes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Arr_Rel_Insert_Input = {
  data: Array<Research_Studies_Chemotypes_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Studies_Chemotypes_Avg_Fields = {
  __typename?: 'research_studies_chemotypes_avg_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Avg_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.studies_chemotypes". All fields are combined with a logical 'AND'. */
export type Research_Studies_Chemotypes_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Chemotypes_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Chemotypes_Bool_Exp>>;
  chemotype_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Inc_Input = {
  chemotype_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Scalars['String']>;
  chemotype_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Studies_Chemotypes_Max_Fields = {
  __typename?: 'research_studies_chemotypes_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: Maybe<Scalars['String']>;
  chemotype_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Order_By>;
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Studies_Chemotypes_Min_Fields = {
  __typename?: 'research_studies_chemotypes_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: Maybe<Scalars['String']>;
  chemotype_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Order_By>;
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Mutation_Response = {
  __typename?: 'research_studies_chemotypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies_Chemotypes>;
};

/** Ordering options when selecting data from "research.studies_chemotypes". */
export type Research_Studies_Chemotypes_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Order_By>;
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** select columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesChemotypesHashid = '_airbyte_studies_chemotypes_hashid',
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_avg_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_corr_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_max_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_min_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_sum_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_chemotypes_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.studies_chemotypes" */
export enum Research_Studies_Chemotypes_Select_Column_Research_Studies_Chemotypes_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ChemotypeId = 'chemotype_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Scalars['String']>;
  chemotype_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Chemotypes_Stddev_Fields = {
  __typename?: 'research_studies_chemotypes_stddev_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Stddev_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Chemotypes_Stddev_Pop_Fields = {
  __typename?: 'research_studies_chemotypes_stddev_pop_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Stddev_Pop_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Chemotypes_Stddev_Samp_Fields = {
  __typename?: 'research_studies_chemotypes_stddev_samp_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Stddev_Samp_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_studies_chemotypes" */
export type Research_Studies_Chemotypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Chemotypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Chemotypes_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_chemotypes_hashid: InputMaybe<Scalars['String']>;
  chemotype_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Studies_Chemotypes_Sum_Fields = {
  __typename?: 'research_studies_chemotypes_sum_fields';
  chemotype_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Sum_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Studies_Chemotypes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Chemotypes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Chemotypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Chemotypes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Chemotypes_Var_Pop_Fields = {
  __typename?: 'research_studies_chemotypes_var_pop_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Var_Pop_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Chemotypes_Var_Samp_Fields = {
  __typename?: 'research_studies_chemotypes_var_samp_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Var_Samp_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Studies_Chemotypes_Variance_Fields = {
  __typename?: 'research_studies_chemotypes_variance_fields';
  chemotype_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.studies_chemotypes" */
export type Research_Studies_Chemotypes_Variance_Order_By = {
  chemotype_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "research.studies" */
export type Research_Studies_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
  samplesize: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies" */
export type Research_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: InputMaybe<Scalars['String']>;
  administrations: InputMaybe<Research_Studies_Administration_Arr_Rel_Insert_Input>;
  cannabinoids: InputMaybe<Research_Cannabinoids_Studies_Arr_Rel_Insert_Input>;
  category: InputMaybe<Scalars['String']>;
  chemotypes: InputMaybe<Research_Studies_Chemotypes_Arr_Rel_Insert_Input>;
  conditions: InputMaybe<Research_Medical_Conditions_Studies_Arr_Rel_Insert_Input>;
  dosage: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  keyfindings: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  locations: InputMaybe<Research_Studies_Locations_Arr_Rel_Insert_Input>;
  organ_systems: InputMaybe<Research_Organ_Systems_Studies_Arr_Rel_Insert_Input>;
  phytocannabinoidsource: InputMaybe<Scalars['String']>;
  result: InputMaybe<Scalars['String']>;
  samplesize: InputMaybe<Scalars['float8']>;
  source: InputMaybe<Scalars['String']>;
  subratio: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  typeofstudy: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.studies_ligands" */
export type Research_Studies_Ligands = {
  __typename?: 'research_studies_ligands';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: Maybe<Scalars['String']>;
  ligand_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.studies_ligands" */
export type Research_Studies_Ligands_Aggregate = {
  __typename?: 'research_studies_ligands_aggregate';
  aggregate: Maybe<Research_Studies_Ligands_Aggregate_Fields>;
  nodes: Array<Research_Studies_Ligands>;
};

/** aggregate fields of "research.studies_ligands" */
export type Research_Studies_Ligands_Aggregate_Fields = {
  __typename?: 'research_studies_ligands_aggregate_fields';
  avg: Maybe<Research_Studies_Ligands_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Ligands_Max_Fields>;
  min: Maybe<Research_Studies_Ligands_Min_Fields>;
  stddev: Maybe<Research_Studies_Ligands_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Ligands_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Ligands_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Ligands_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Ligands_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Ligands_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Ligands_Variance_Fields>;
};

/** aggregate fields of "research.studies_ligands" */
export type Research_Studies_Ligands_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Ligands_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Studies_Ligands_Avg_Fields = {
  __typename?: 'research_studies_ligands_avg_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.studies_ligands". All fields are combined with a logical 'AND'. */
export type Research_Studies_Ligands_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_ligands_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Ligands_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Ligands_Bool_Exp>>;
  ligand_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.studies_ligands" */
export type Research_Studies_Ligands_Inc_Input = {
  ligand_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies_ligands" */
export type Research_Studies_Ligands_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: InputMaybe<Scalars['String']>;
  ligand_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Studies_Ligands_Max_Fields = {
  __typename?: 'research_studies_ligands_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: Maybe<Scalars['String']>;
  ligand_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Research_Studies_Ligands_Min_Fields = {
  __typename?: 'research_studies_ligands_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: Maybe<Scalars['String']>;
  ligand_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "research.studies_ligands" */
export type Research_Studies_Ligands_Mutation_Response = {
  __typename?: 'research_studies_ligands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies_Ligands>;
};

/** Ordering options when selecting data from "research.studies_ligands". */
export type Research_Studies_Ligands_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_ligands_hashid: InputMaybe<Order_By>;
  ligand_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** select columns of table "research.studies_ligands" */
export enum Research_Studies_Ligands_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesLigandsHashid = '_airbyte_studies_ligands_hashid',
  /** column name */
  LigandId = 'ligand_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.studies_ligands" */
export type Research_Studies_Ligands_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: InputMaybe<Scalars['String']>;
  ligand_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Ligands_Stddev_Fields = {
  __typename?: 'research_studies_ligands_stddev_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Ligands_Stddev_Pop_Fields = {
  __typename?: 'research_studies_ligands_stddev_pop_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Ligands_Stddev_Samp_Fields = {
  __typename?: 'research_studies_ligands_stddev_samp_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_studies_ligands" */
export type Research_Studies_Ligands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Ligands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Ligands_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_ligands_hashid: InputMaybe<Scalars['String']>;
  ligand_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Studies_Ligands_Sum_Fields = {
  __typename?: 'research_studies_ligands_sum_fields';
  ligand_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

export type Research_Studies_Ligands_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Ligands_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Ligands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Ligands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Ligands_Var_Pop_Fields = {
  __typename?: 'research_studies_ligands_var_pop_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Ligands_Var_Samp_Fields = {
  __typename?: 'research_studies_ligands_var_samp_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Studies_Ligands_Variance_Fields = {
  __typename?: 'research_studies_ligands_variance_fields';
  ligand_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.studies_locations" */
export type Research_Studies_Locations = {
  __typename?: 'research_studies_locations';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: Maybe<Scalars['String']>;
  location_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.studies_locations" */
export type Research_Studies_Locations_Aggregate = {
  __typename?: 'research_studies_locations_aggregate';
  aggregate: Maybe<Research_Studies_Locations_Aggregate_Fields>;
  nodes: Array<Research_Studies_Locations>;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp = {
  avg: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Avg>;
  corr: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Corr>;
  count: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Count>;
  covar_samp: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp>;
  max: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Max>;
  min: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Min>;
  stddev_samp: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Stddev_Samp>;
  sum: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Sum>;
  var_samp: InputMaybe<Research_Studies_Locations_Aggregate_Bool_Exp_Var_Samp>;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Avg = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Corr = {
  arguments: Research_Studies_Locations_Aggregate_Bool_Exp_Corr_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Research_Studies_Locations_Aggregate_Bool_Exp_Max = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Min = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Sum = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Research_Studies_Locations_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "research.studies_locations" */
export type Research_Studies_Locations_Aggregate_Fields = {
  __typename?: 'research_studies_locations_aggregate_fields';
  avg: Maybe<Research_Studies_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Locations_Max_Fields>;
  min: Maybe<Research_Studies_Locations_Min_Fields>;
  stddev: Maybe<Research_Studies_Locations_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Locations_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Locations_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Locations_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Locations_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Locations_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Locations_Variance_Fields>;
};

/** aggregate fields of "research.studies_locations" */
export type Research_Studies_Locations_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "research.studies_locations" */
export type Research_Studies_Locations_Aggregate_Order_By = {
  avg: InputMaybe<Research_Studies_Locations_Avg_Order_By>;
  count: InputMaybe<Order_By>;
  max: InputMaybe<Research_Studies_Locations_Max_Order_By>;
  min: InputMaybe<Research_Studies_Locations_Min_Order_By>;
  stddev: InputMaybe<Research_Studies_Locations_Stddev_Order_By>;
  stddev_pop: InputMaybe<Research_Studies_Locations_Stddev_Pop_Order_By>;
  stddev_samp: InputMaybe<Research_Studies_Locations_Stddev_Samp_Order_By>;
  sum: InputMaybe<Research_Studies_Locations_Sum_Order_By>;
  var_pop: InputMaybe<Research_Studies_Locations_Var_Pop_Order_By>;
  var_samp: InputMaybe<Research_Studies_Locations_Var_Samp_Order_By>;
  variance: InputMaybe<Research_Studies_Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research.studies_locations" */
export type Research_Studies_Locations_Arr_Rel_Insert_Input = {
  data: Array<Research_Studies_Locations_Insert_Input>;
};

/** aggregate avg on columns */
export type Research_Studies_Locations_Avg_Fields = {
  __typename?: 'research_studies_locations_avg_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Avg_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research.studies_locations". All fields are combined with a logical 'AND'. */
export type Research_Studies_Locations_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_locations_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Locations_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Locations_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Locations_Bool_Exp>>;
  location_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.studies_locations" */
export type Research_Studies_Locations_Inc_Input = {
  location_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies_locations" */
export type Research_Studies_Locations_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: InputMaybe<Scalars['String']>;
  location_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Studies_Locations_Max_Fields = {
  __typename?: 'research_studies_locations_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: Maybe<Scalars['String']>;
  location_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Max_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_locations_hashid: InputMaybe<Order_By>;
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Studies_Locations_Min_Fields = {
  __typename?: 'research_studies_locations_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: Maybe<Scalars['String']>;
  location_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Min_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_locations_hashid: InputMaybe<Order_By>;
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** response of any mutation on the table "research.studies_locations" */
export type Research_Studies_Locations_Mutation_Response = {
  __typename?: 'research_studies_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies_Locations>;
};

/** Ordering options when selecting data from "research.studies_locations". */
export type Research_Studies_Locations_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_locations_hashid: InputMaybe<Order_By>;
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** select columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesLocationsHashid = '_airbyte_studies_locations_hashid',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_avg_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_corr_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_max_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_min_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_sum_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** select "research_studies_locations_aggregate_bool_exp_var_samp_arguments_columns" columns of table "research.studies_locations" */
export enum Research_Studies_Locations_Select_Column_Research_Studies_Locations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.studies_locations" */
export type Research_Studies_Locations_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: InputMaybe<Scalars['String']>;
  location_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Locations_Stddev_Fields = {
  __typename?: 'research_studies_locations_stddev_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Stddev_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Locations_Stddev_Pop_Fields = {
  __typename?: 'research_studies_locations_stddev_pop_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Stddev_Pop_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Locations_Stddev_Samp_Fields = {
  __typename?: 'research_studies_locations_stddev_samp_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Stddev_Samp_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "research_studies_locations" */
export type Research_Studies_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Locations_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_locations_hashid: InputMaybe<Scalars['String']>;
  location_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Studies_Locations_Sum_Fields = {
  __typename?: 'research_studies_locations_sum_fields';
  location_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Sum_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

export type Research_Studies_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Locations_Var_Pop_Fields = {
  __typename?: 'research_studies_locations_var_pop_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Var_Pop_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Locations_Var_Samp_Fields = {
  __typename?: 'research_studies_locations_var_samp_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Var_Samp_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Studies_Locations_Variance_Fields = {
  __typename?: 'research_studies_locations_variance_fields';
  location_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "research.studies_locations" */
export type Research_Studies_Locations_Variance_Order_By = {
  location_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Research_Studies_Max_Fields = {
  __typename?: 'research_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  dosage: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  keyfindings: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  phytocannabinoidsource: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  samplesize: Maybe<Scalars['float8']>;
  source: Maybe<Scalars['String']>;
  subratio: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  typeofstudy: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Studies_Min_Fields = {
  __typename?: 'research_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  dosage: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  keyfindings: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  phytocannabinoidsource: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
  samplesize: Maybe<Scalars['float8']>;
  source: Maybe<Scalars['String']>;
  subratio: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  typeofstudy: Maybe<Scalars['String']>;
  year: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.studies" */
export type Research_Studies_Mutation_Response = {
  __typename?: 'research_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies>;
};

/** Ordering options when selecting data from "research.studies". */
export type Research_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_hashid: InputMaybe<Order_By>;
  administrations_aggregate: InputMaybe<Research_Studies_Administration_Aggregate_Order_By>;
  cannabinoids_aggregate: InputMaybe<Research_Cannabinoids_Studies_Aggregate_Order_By>;
  category: InputMaybe<Order_By>;
  chemotypes_aggregate: InputMaybe<Research_Studies_Chemotypes_Aggregate_Order_By>;
  conditions_aggregate: InputMaybe<Research_Medical_Conditions_Studies_Aggregate_Order_By>;
  dosage: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  keyfindings: InputMaybe<Order_By>;
  link: InputMaybe<Order_By>;
  locations_aggregate: InputMaybe<Research_Studies_Locations_Aggregate_Order_By>;
  organ_systems_aggregate: InputMaybe<Research_Organ_Systems_Studies_Aggregate_Order_By>;
  phytocannabinoidsource: InputMaybe<Order_By>;
  result: InputMaybe<Order_By>;
  samplesize: InputMaybe<Order_By>;
  source: InputMaybe<Order_By>;
  subratio: InputMaybe<Order_By>;
  title: InputMaybe<Order_By>;
  typeofstudy: InputMaybe<Order_By>;
  year: InputMaybe<Order_By>;
};

/** columns and relationships of "research.studies_receptors" */
export type Research_Studies_Receptors = {
  __typename?: 'research_studies_receptors';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: Maybe<Scalars['String']>;
  receptor_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregated selection of "research.studies_receptors" */
export type Research_Studies_Receptors_Aggregate = {
  __typename?: 'research_studies_receptors_aggregate';
  aggregate: Maybe<Research_Studies_Receptors_Aggregate_Fields>;
  nodes: Array<Research_Studies_Receptors>;
};

/** aggregate fields of "research.studies_receptors" */
export type Research_Studies_Receptors_Aggregate_Fields = {
  __typename?: 'research_studies_receptors_aggregate_fields';
  avg: Maybe<Research_Studies_Receptors_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Studies_Receptors_Max_Fields>;
  min: Maybe<Research_Studies_Receptors_Min_Fields>;
  stddev: Maybe<Research_Studies_Receptors_Stddev_Fields>;
  stddev_pop: Maybe<Research_Studies_Receptors_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Studies_Receptors_Stddev_Samp_Fields>;
  sum: Maybe<Research_Studies_Receptors_Sum_Fields>;
  var_pop: Maybe<Research_Studies_Receptors_Var_Pop_Fields>;
  var_samp: Maybe<Research_Studies_Receptors_Var_Samp_Fields>;
  variance: Maybe<Research_Studies_Receptors_Variance_Fields>;
};

/** aggregate fields of "research.studies_receptors" */
export type Research_Studies_Receptors_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Studies_Receptors_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Studies_Receptors_Avg_Fields = {
  __typename?: 'research_studies_receptors_avg_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.studies_receptors". All fields are combined with a logical 'AND'. */
export type Research_Studies_Receptors_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_studies_receptors_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Studies_Receptors_Bool_Exp>>;
  _not: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
  _or: InputMaybe<Array<Research_Studies_Receptors_Bool_Exp>>;
  receptor_id: InputMaybe<Float8_Comparison_Exp>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.studies_receptors" */
export type Research_Studies_Receptors_Inc_Input = {
  receptor_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.studies_receptors" */
export type Research_Studies_Receptors_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: InputMaybe<Scalars['String']>;
  receptor_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Research_Studies_Receptors_Max_Fields = {
  __typename?: 'research_studies_receptors_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: Maybe<Scalars['String']>;
  receptor_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Research_Studies_Receptors_Min_Fields = {
  __typename?: 'research_studies_receptors_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: Maybe<Scalars['String']>;
  receptor_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "research.studies_receptors" */
export type Research_Studies_Receptors_Mutation_Response = {
  __typename?: 'research_studies_receptors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Studies_Receptors>;
};

/** Ordering options when selecting data from "research.studies_receptors". */
export type Research_Studies_Receptors_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_studies_receptors_hashid: InputMaybe<Order_By>;
  receptor_id: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
};

/** select columns of table "research.studies_receptors" */
export enum Research_Studies_Receptors_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesReceptorsHashid = '_airbyte_studies_receptors_hashid',
  /** column name */
  ReceptorId = 'receptor_id',
  /** column name */
  StudyId = 'study_id',
}

/** input type for updating data in table "research.studies_receptors" */
export type Research_Studies_Receptors_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: InputMaybe<Scalars['String']>;
  receptor_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Receptors_Stddev_Fields = {
  __typename?: 'research_studies_receptors_stddev_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Receptors_Stddev_Pop_Fields = {
  __typename?: 'research_studies_receptors_stddev_pop_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Receptors_Stddev_Samp_Fields = {
  __typename?: 'research_studies_receptors_stddev_samp_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_studies_receptors" */
export type Research_Studies_Receptors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Receptors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Receptors_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_receptors_hashid: InputMaybe<Scalars['String']>;
  receptor_id: InputMaybe<Scalars['float8']>;
  study_id: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Research_Studies_Receptors_Sum_Fields = {
  __typename?: 'research_studies_receptors_sum_fields';
  receptor_id: Maybe<Scalars['float8']>;
  study_id: Maybe<Scalars['float8']>;
};

export type Research_Studies_Receptors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Receptors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Receptors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Receptors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Receptors_Var_Pop_Fields = {
  __typename?: 'research_studies_receptors_var_pop_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Receptors_Var_Samp_Fields = {
  __typename?: 'research_studies_receptors_var_samp_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Studies_Receptors_Variance_Fields = {
  __typename?: 'research_studies_receptors_variance_fields';
  receptor_id: Maybe<Scalars['Float']>;
  study_id: Maybe<Scalars['Float']>;
};

/** select columns of table "research.studies" */
export enum Research_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteStudiesHashid = '_airbyte_studies_hashid',
  /** column name */
  Category = 'category',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  Id = 'id',
  /** column name */
  Keyfindings = 'keyfindings',
  /** column name */
  Link = 'link',
  /** column name */
  Phytocannabinoidsource = 'phytocannabinoidsource',
  /** column name */
  Result = 'result',
  /** column name */
  Samplesize = 'samplesize',
  /** column name */
  Source = 'source',
  /** column name */
  Subratio = 'subratio',
  /** column name */
  Title = 'title',
  /** column name */
  Typeofstudy = 'typeofstudy',
  /** column name */
  Year = 'year',
}

/** input type for updating data in table "research.studies" */
export type Research_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: InputMaybe<Scalars['String']>;
  category: InputMaybe<Scalars['String']>;
  dosage: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  keyfindings: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  phytocannabinoidsource: InputMaybe<Scalars['String']>;
  result: InputMaybe<Scalars['String']>;
  samplesize: InputMaybe<Scalars['float8']>;
  source: InputMaybe<Scalars['String']>;
  subratio: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  typeofstudy: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Studies_Stddev_Fields = {
  __typename?: 'research_studies_stddev_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Studies_Stddev_Pop_Fields = {
  __typename?: 'research_studies_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Studies_Stddev_Samp_Fields = {
  __typename?: 'research_studies_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_studies" */
export type Research_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_studies_hashid: InputMaybe<Scalars['String']>;
  category: InputMaybe<Scalars['String']>;
  dosage: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  keyfindings: InputMaybe<Scalars['String']>;
  link: InputMaybe<Scalars['String']>;
  phytocannabinoidsource: InputMaybe<Scalars['String']>;
  result: InputMaybe<Scalars['String']>;
  samplesize: InputMaybe<Scalars['float8']>;
  source: InputMaybe<Scalars['String']>;
  subratio: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  typeofstudy: InputMaybe<Scalars['String']>;
  year: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Studies_Sum_Fields = {
  __typename?: 'research_studies_sum_fields';
  id: Maybe<Scalars['float8']>;
  samplesize: Maybe<Scalars['float8']>;
};

export type Research_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Studies_Var_Pop_Fields = {
  __typename?: 'research_studies_var_pop_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Studies_Var_Samp_Fields = {
  __typename?: 'research_studies_var_samp_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Studies_Variance_Fields = {
  __typename?: 'research_studies_variance_fields';
  id: Maybe<Scalars['Float']>;
  samplesize: Maybe<Scalars['Float']>;
};

/** columns and relationships of "research.terpenes" */
export type Research_Terpenes = {
  __typename?: 'research_terpenes';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.terpenes" */
export type Research_Terpenes_Aggregate = {
  __typename?: 'research_terpenes_aggregate';
  aggregate: Maybe<Research_Terpenes_Aggregate_Fields>;
  nodes: Array<Research_Terpenes>;
};

/** aggregate fields of "research.terpenes" */
export type Research_Terpenes_Aggregate_Fields = {
  __typename?: 'research_terpenes_aggregate_fields';
  avg: Maybe<Research_Terpenes_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Terpenes_Max_Fields>;
  min: Maybe<Research_Terpenes_Min_Fields>;
  stddev: Maybe<Research_Terpenes_Stddev_Fields>;
  stddev_pop: Maybe<Research_Terpenes_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Terpenes_Stddev_Samp_Fields>;
  sum: Maybe<Research_Terpenes_Sum_Fields>;
  var_pop: Maybe<Research_Terpenes_Var_Pop_Fields>;
  var_samp: Maybe<Research_Terpenes_Var_Samp_Fields>;
  variance: Maybe<Research_Terpenes_Variance_Fields>;
};

/** aggregate fields of "research.terpenes" */
export type Research_Terpenes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Terpenes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Terpenes_Avg_Fields = {
  __typename?: 'research_terpenes_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.terpenes". All fields are combined with a logical 'AND'. */
export type Research_Terpenes_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_terpenes_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Terpenes_Bool_Exp>>;
  _not: InputMaybe<Research_Terpenes_Bool_Exp>;
  _or: InputMaybe<Array<Research_Terpenes_Bool_Exp>>;
  id: InputMaybe<Float8_Comparison_Exp>;
  name: InputMaybe<String_Comparison_Exp>;
  summary: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.terpenes" */
export type Research_Terpenes_Inc_Input = {
  id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.terpenes" */
export type Research_Terpenes_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Terpenes_Max_Fields = {
  __typename?: 'research_terpenes_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Terpenes_Min_Fields = {
  __typename?: 'research_terpenes_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['float8']>;
  name: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.terpenes" */
export type Research_Terpenes_Mutation_Response = {
  __typename?: 'research_terpenes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Terpenes>;
};

/** Ordering options when selecting data from "research.terpenes". */
export type Research_Terpenes_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_terpenes_hashid: InputMaybe<Order_By>;
  id: InputMaybe<Order_By>;
  name: InputMaybe<Order_By>;
  summary: InputMaybe<Order_By>;
};

/** select columns of table "research.terpenes" */
export enum Research_Terpenes_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteTerpenesHashid = '_airbyte_terpenes_hashid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Summary = 'summary',
}

/** input type for updating data in table "research.terpenes" */
export type Research_Terpenes_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Terpenes_Stddev_Fields = {
  __typename?: 'research_terpenes_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Terpenes_Stddev_Pop_Fields = {
  __typename?: 'research_terpenes_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Terpenes_Stddev_Samp_Fields = {
  __typename?: 'research_terpenes_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_terpenes" */
export type Research_Terpenes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Terpenes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Terpenes_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_hashid: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['float8']>;
  name: InputMaybe<Scalars['String']>;
  summary: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "research.terpenes_studies" */
export type Research_Terpenes_Studies = {
  __typename?: 'research_terpenes_studies';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: Maybe<Scalars['String']>;
  study_id: Maybe<Scalars['float8']>;
  terpene_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** aggregated selection of "research.terpenes_studies" */
export type Research_Terpenes_Studies_Aggregate = {
  __typename?: 'research_terpenes_studies_aggregate';
  aggregate: Maybe<Research_Terpenes_Studies_Aggregate_Fields>;
  nodes: Array<Research_Terpenes_Studies>;
};

/** aggregate fields of "research.terpenes_studies" */
export type Research_Terpenes_Studies_Aggregate_Fields = {
  __typename?: 'research_terpenes_studies_aggregate_fields';
  avg: Maybe<Research_Terpenes_Studies_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Research_Terpenes_Studies_Max_Fields>;
  min: Maybe<Research_Terpenes_Studies_Min_Fields>;
  stddev: Maybe<Research_Terpenes_Studies_Stddev_Fields>;
  stddev_pop: Maybe<Research_Terpenes_Studies_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Research_Terpenes_Studies_Stddev_Samp_Fields>;
  sum: Maybe<Research_Terpenes_Studies_Sum_Fields>;
  var_pop: Maybe<Research_Terpenes_Studies_Var_Pop_Fields>;
  var_samp: Maybe<Research_Terpenes_Studies_Var_Samp_Fields>;
  variance: Maybe<Research_Terpenes_Studies_Variance_Fields>;
};

/** aggregate fields of "research.terpenes_studies" */
export type Research_Terpenes_Studies_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Research_Terpenes_Studies_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Research_Terpenes_Studies_Avg_Fields = {
  __typename?: 'research_terpenes_studies_avg_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "research.terpenes_studies". All fields are combined with a logical 'AND'. */
export type Research_Terpenes_Studies_Bool_Exp = {
  _airbyte_ab_id: InputMaybe<String_Comparison_Exp>;
  _airbyte_emitted_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_normalized_at: InputMaybe<Timestamptz_Comparison_Exp>;
  _airbyte_terpenes_studies_hashid: InputMaybe<String_Comparison_Exp>;
  _and: InputMaybe<Array<Research_Terpenes_Studies_Bool_Exp>>;
  _not: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
  _or: InputMaybe<Array<Research_Terpenes_Studies_Bool_Exp>>;
  study_id: InputMaybe<Float8_Comparison_Exp>;
  terpene_id: InputMaybe<Float8_Comparison_Exp>;
  type: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "research.terpenes_studies" */
export type Research_Terpenes_Studies_Inc_Input = {
  study_id: InputMaybe<Scalars['float8']>;
  terpene_id: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "research.terpenes_studies" */
export type Research_Terpenes_Studies_Insert_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: InputMaybe<Scalars['String']>;
  study_id: InputMaybe<Scalars['float8']>;
  terpene_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Research_Terpenes_Studies_Max_Fields = {
  __typename?: 'research_terpenes_studies_max_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: Maybe<Scalars['String']>;
  study_id: Maybe<Scalars['float8']>;
  terpene_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Research_Terpenes_Studies_Min_Fields = {
  __typename?: 'research_terpenes_studies_min_fields';
  _airbyte_ab_id: Maybe<Scalars['String']>;
  _airbyte_emitted_at: Maybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: Maybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: Maybe<Scalars['String']>;
  study_id: Maybe<Scalars['float8']>;
  terpene_id: Maybe<Scalars['float8']>;
  type: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "research.terpenes_studies" */
export type Research_Terpenes_Studies_Mutation_Response = {
  __typename?: 'research_terpenes_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Research_Terpenes_Studies>;
};

/** Ordering options when selecting data from "research.terpenes_studies". */
export type Research_Terpenes_Studies_Order_By = {
  _airbyte_ab_id: InputMaybe<Order_By>;
  _airbyte_emitted_at: InputMaybe<Order_By>;
  _airbyte_normalized_at: InputMaybe<Order_By>;
  _airbyte_terpenes_studies_hashid: InputMaybe<Order_By>;
  study_id: InputMaybe<Order_By>;
  terpene_id: InputMaybe<Order_By>;
  type: InputMaybe<Order_By>;
};

/** select columns of table "research.terpenes_studies" */
export enum Research_Terpenes_Studies_Select_Column {
  /** column name */
  AirbyteAbId = '_airbyte_ab_id',
  /** column name */
  AirbyteEmittedAt = '_airbyte_emitted_at',
  /** column name */
  AirbyteNormalizedAt = '_airbyte_normalized_at',
  /** column name */
  AirbyteTerpenesStudiesHashid = '_airbyte_terpenes_studies_hashid',
  /** column name */
  StudyId = 'study_id',
  /** column name */
  TerpeneId = 'terpene_id',
  /** column name */
  Type = 'type',
}

/** input type for updating data in table "research.terpenes_studies" */
export type Research_Terpenes_Studies_Set_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: InputMaybe<Scalars['String']>;
  study_id: InputMaybe<Scalars['float8']>;
  terpene_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Research_Terpenes_Studies_Stddev_Fields = {
  __typename?: 'research_terpenes_studies_stddev_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Research_Terpenes_Studies_Stddev_Pop_Fields = {
  __typename?: 'research_terpenes_studies_stddev_pop_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Research_Terpenes_Studies_Stddev_Samp_Fields = {
  __typename?: 'research_terpenes_studies_stddev_samp_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "research_terpenes_studies" */
export type Research_Terpenes_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Research_Terpenes_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Research_Terpenes_Studies_Stream_Cursor_Value_Input = {
  _airbyte_ab_id: InputMaybe<Scalars['String']>;
  _airbyte_emitted_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_normalized_at: InputMaybe<Scalars['timestamptz']>;
  _airbyte_terpenes_studies_hashid: InputMaybe<Scalars['String']>;
  study_id: InputMaybe<Scalars['float8']>;
  terpene_id: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Research_Terpenes_Studies_Sum_Fields = {
  __typename?: 'research_terpenes_studies_sum_fields';
  study_id: Maybe<Scalars['float8']>;
  terpene_id: Maybe<Scalars['float8']>;
};

export type Research_Terpenes_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Terpenes_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Terpenes_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Terpenes_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Terpenes_Studies_Var_Pop_Fields = {
  __typename?: 'research_terpenes_studies_var_pop_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Terpenes_Studies_Var_Samp_Fields = {
  __typename?: 'research_terpenes_studies_var_samp_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Terpenes_Studies_Variance_Fields = {
  __typename?: 'research_terpenes_studies_variance_fields';
  study_id: Maybe<Scalars['Float']>;
  terpene_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Research_Terpenes_Sum_Fields = {
  __typename?: 'research_terpenes_sum_fields';
  id: Maybe<Scalars['float8']>;
};

export type Research_Terpenes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Research_Terpenes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Research_Terpenes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Research_Terpenes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Research_Terpenes_Var_Pop_Fields = {
  __typename?: 'research_terpenes_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Research_Terpenes_Var_Samp_Fields = {
  __typename?: 'research_terpenes_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Research_Terpenes_Variance_Fields = {
  __typename?: 'research_terpenes_variance_fields';
  id: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "outreach.google_locations" */
  outreach_google_locations: Array<Outreach_Google_Locations>;
  /** fetch aggregated fields from the table: "outreach.google_locations" */
  outreach_google_locations_aggregate: Outreach_Google_Locations_Aggregate;
  /** fetch data from the table in a streaming manner: "outreach.google_locations" */
  outreach_google_locations_stream: Array<Outreach_Google_Locations>;
  /** fetch data from the table: "outreach.partners" */
  outreach_partners: Array<Outreach_Partners>;
  /** fetch aggregated fields from the table: "outreach.partners" */
  outreach_partners_aggregate: Outreach_Partners_Aggregate;
  /** fetch data from the table in a streaming manner: "outreach.partners" */
  outreach_partners_stream: Array<Outreach_Partners>;
  /** fetch data from the table: "research._airbyte_raw_cannabinoids" */
  research__airbyte_raw_cannabinoids: Array<Research__Airbyte_Raw_Cannabinoids>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_cannabinoids" */
  research__airbyte_raw_cannabinoids_aggregate: Research__Airbyte_Raw_Cannabinoids_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_cannabinoids" using primary key columns */
  research__airbyte_raw_cannabinoids_by_pk: Maybe<Research__Airbyte_Raw_Cannabinoids>;
  /** fetch data from the table in a streaming manner: "research._airbyte_raw_cannabinoids" */
  research__airbyte_raw_cannabinoids_stream: Array<Research__Airbyte_Raw_Cannabinoids>;
  /** fetch data from the table: "research._airbyte_raw_medical_conditions" */
  research__airbyte_raw_medical_conditions: Array<Research__Airbyte_Raw_Medical_Conditions>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_medical_conditions" */
  research__airbyte_raw_medical_conditions_aggregate: Research__Airbyte_Raw_Medical_Conditions_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_medical_conditions" using primary key columns */
  research__airbyte_raw_medical_conditions_by_pk: Maybe<Research__Airbyte_Raw_Medical_Conditions>;
  /** fetch data from the table in a streaming manner: "research._airbyte_raw_medical_conditions" */
  research__airbyte_raw_medical_conditions_stream: Array<Research__Airbyte_Raw_Medical_Conditions>;
  /** fetch data from the table: "research._airbyte_raw_organ_systems" */
  research__airbyte_raw_organ_systems: Array<Research__Airbyte_Raw_Organ_Systems>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_organ_systems" */
  research__airbyte_raw_organ_systems_aggregate: Research__Airbyte_Raw_Organ_Systems_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_organ_systems" using primary key columns */
  research__airbyte_raw_organ_systems_by_pk: Maybe<Research__Airbyte_Raw_Organ_Systems>;
  /** fetch data from the table in a streaming manner: "research._airbyte_raw_organ_systems" */
  research__airbyte_raw_organ_systems_stream: Array<Research__Airbyte_Raw_Organ_Systems>;
  /** fetch data from the table: "research._airbyte_raw_studies" */
  research__airbyte_raw_studies: Array<Research__Airbyte_Raw_Studies>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_studies" */
  research__airbyte_raw_studies_aggregate: Research__Airbyte_Raw_Studies_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_studies" using primary key columns */
  research__airbyte_raw_studies_by_pk: Maybe<Research__Airbyte_Raw_Studies>;
  /** fetch data from the table in a streaming manner: "research._airbyte_raw_studies" */
  research__airbyte_raw_studies_stream: Array<Research__Airbyte_Raw_Studies>;
  /** fetch data from the table: "research._airbyte_raw_terpenes" */
  research__airbyte_raw_terpenes: Array<Research__Airbyte_Raw_Terpenes>;
  /** fetch aggregated fields from the table: "research._airbyte_raw_terpenes" */
  research__airbyte_raw_terpenes_aggregate: Research__Airbyte_Raw_Terpenes_Aggregate;
  /** fetch data from the table: "research._airbyte_raw_terpenes" using primary key columns */
  research__airbyte_raw_terpenes_by_pk: Maybe<Research__Airbyte_Raw_Terpenes>;
  /** fetch data from the table in a streaming manner: "research._airbyte_raw_terpenes" */
  research__airbyte_raw_terpenes_stream: Array<Research__Airbyte_Raw_Terpenes>;
  /** fetch data from the table: "research.administrations" */
  research_administrations: Array<Research_Administrations>;
  /** fetch aggregated fields from the table: "research.administrations" */
  research_administrations_aggregate: Research_Administrations_Aggregate;
  /** fetch data from the table in a streaming manner: "research.administrations" */
  research_administrations_stream: Array<Research_Administrations>;
  /** fetch data from the table: "research.cannabinoids" */
  research_cannabinoids: Array<Research_Cannabinoids>;
  /** fetch aggregated fields from the table: "research.cannabinoids" */
  research_cannabinoids_aggregate: Research_Cannabinoids_Aggregate;
  /** fetch data from the table in a streaming manner: "research.cannabinoids" */
  research_cannabinoids_stream: Array<Research_Cannabinoids>;
  /** fetch data from the table: "research.cannabinoids_studies" */
  research_cannabinoids_studies: Array<Research_Cannabinoids_Studies>;
  /** fetch aggregated fields from the table: "research.cannabinoids_studies" */
  research_cannabinoids_studies_aggregate: Research_Cannabinoids_Studies_Aggregate;
  /** fetch data from the table in a streaming manner: "research.cannabinoids_studies" */
  research_cannabinoids_studies_stream: Array<Research_Cannabinoids_Studies>;
  /** fetch data from the table: "research.chemotypes" */
  research_chemotypes: Array<Research_Chemotypes>;
  /** fetch aggregated fields from the table: "research.chemotypes" */
  research_chemotypes_aggregate: Research_Chemotypes_Aggregate;
  /** fetch data from the table in a streaming manner: "research.chemotypes" */
  research_chemotypes_stream: Array<Research_Chemotypes>;
  /** fetch data from the table: "research.ligands" */
  research_ligands: Array<Research_Ligands>;
  /** fetch aggregated fields from the table: "research.ligands" */
  research_ligands_aggregate: Research_Ligands_Aggregate;
  /** fetch data from the table in a streaming manner: "research.ligands" */
  research_ligands_stream: Array<Research_Ligands>;
  /** fetch data from the table: "research.locations" */
  research_locations: Array<Research_Locations>;
  /** fetch aggregated fields from the table: "research.locations" */
  research_locations_aggregate: Research_Locations_Aggregate;
  /** fetch data from the table in a streaming manner: "research.locations" */
  research_locations_stream: Array<Research_Locations>;
  /** fetch data from the table: "research.medical_conditions" */
  research_medical_conditions: Array<Research_Medical_Conditions>;
  /** fetch aggregated fields from the table: "research.medical_conditions" */
  research_medical_conditions_aggregate: Research_Medical_Conditions_Aggregate;
  /** fetch data from the table: "research.medical_conditions_clinicial_dosing" */
  research_medical_conditions_clinicial_dosing: Array<Research_Medical_Conditions_Clinicial_Dosing>;
  /** fetch aggregated fields from the table: "research.medical_conditions_clinicial_dosing" */
  research_medical_conditions_clinicial_dosing_aggregate: Research_Medical_Conditions_Clinicial_Dosing_Aggregate;
  /** fetch data from the table in a streaming manner: "research.medical_conditions_clinicial_dosing" */
  research_medical_conditions_clinicial_dosing_stream: Array<Research_Medical_Conditions_Clinicial_Dosing>;
  /** fetch data from the table: "research.medical_conditions_state_of_science" */
  research_medical_conditions_state_of_science: Array<Research_Medical_Conditions_State_Of_Science>;
  /** fetch aggregated fields from the table: "research.medical_conditions_state_of_science" */
  research_medical_conditions_state_of_science_aggregate: Research_Medical_Conditions_State_Of_Science_Aggregate;
  /** fetch data from the table in a streaming manner: "research.medical_conditions_state_of_science" */
  research_medical_conditions_state_of_science_stream: Array<Research_Medical_Conditions_State_Of_Science>;
  /** fetch data from the table in a streaming manner: "research.medical_conditions" */
  research_medical_conditions_stream: Array<Research_Medical_Conditions>;
  /** fetch data from the table: "research.medical_conditions_studies" */
  research_medical_conditions_studies: Array<Research_Medical_Conditions_Studies>;
  /** fetch aggregated fields from the table: "research.medical_conditions_studies" */
  research_medical_conditions_studies_aggregate: Research_Medical_Conditions_Studies_Aggregate;
  /** fetch data from the table in a streaming manner: "research.medical_conditions_studies" */
  research_medical_conditions_studies_stream: Array<Research_Medical_Conditions_Studies>;
  /** fetch data from the table: "research.organ_systems" */
  research_organ_systems: Array<Research_Organ_Systems>;
  /** fetch aggregated fields from the table: "research.organ_systems" */
  research_organ_systems_aggregate: Research_Organ_Systems_Aggregate;
  /** fetch data from the table in a streaming manner: "research.organ_systems" */
  research_organ_systems_stream: Array<Research_Organ_Systems>;
  /** fetch data from the table: "research.organ_systems_studies" */
  research_organ_systems_studies: Array<Research_Organ_Systems_Studies>;
  /** fetch aggregated fields from the table: "research.organ_systems_studies" */
  research_organ_systems_studies_aggregate: Research_Organ_Systems_Studies_Aggregate;
  /** fetch data from the table in a streaming manner: "research.organ_systems_studies" */
  research_organ_systems_studies_stream: Array<Research_Organ_Systems_Studies>;
  /** fetch data from the table: "research.receptors" */
  research_receptors: Array<Research_Receptors>;
  /** fetch aggregated fields from the table: "research.receptors" */
  research_receptors_aggregate: Research_Receptors_Aggregate;
  /** fetch data from the table in a streaming manner: "research.receptors" */
  research_receptors_stream: Array<Research_Receptors>;
  /** fetch data from the table: "research.studies" */
  research_studies: Array<Research_Studies>;
  /** fetch data from the table: "research.studies_administration" */
  research_studies_administration: Array<Research_Studies_Administration>;
  /** fetch aggregated fields from the table: "research.studies_administration" */
  research_studies_administration_aggregate: Research_Studies_Administration_Aggregate;
  /** fetch data from the table in a streaming manner: "research.studies_administration" */
  research_studies_administration_stream: Array<Research_Studies_Administration>;
  /** fetch aggregated fields from the table: "research.studies" */
  research_studies_aggregate: Research_Studies_Aggregate;
  /** fetch data from the table: "research.studies_chemotypes" */
  research_studies_chemotypes: Array<Research_Studies_Chemotypes>;
  /** fetch aggregated fields from the table: "research.studies_chemotypes" */
  research_studies_chemotypes_aggregate: Research_Studies_Chemotypes_Aggregate;
  /** fetch data from the table in a streaming manner: "research.studies_chemotypes" */
  research_studies_chemotypes_stream: Array<Research_Studies_Chemotypes>;
  /** fetch data from the table: "research.studies_ligands" */
  research_studies_ligands: Array<Research_Studies_Ligands>;
  /** fetch aggregated fields from the table: "research.studies_ligands" */
  research_studies_ligands_aggregate: Research_Studies_Ligands_Aggregate;
  /** fetch data from the table in a streaming manner: "research.studies_ligands" */
  research_studies_ligands_stream: Array<Research_Studies_Ligands>;
  /** fetch data from the table: "research.studies_locations" */
  research_studies_locations: Array<Research_Studies_Locations>;
  /** fetch aggregated fields from the table: "research.studies_locations" */
  research_studies_locations_aggregate: Research_Studies_Locations_Aggregate;
  /** fetch data from the table in a streaming manner: "research.studies_locations" */
  research_studies_locations_stream: Array<Research_Studies_Locations>;
  /** fetch data from the table: "research.studies_receptors" */
  research_studies_receptors: Array<Research_Studies_Receptors>;
  /** fetch aggregated fields from the table: "research.studies_receptors" */
  research_studies_receptors_aggregate: Research_Studies_Receptors_Aggregate;
  /** fetch data from the table in a streaming manner: "research.studies_receptors" */
  research_studies_receptors_stream: Array<Research_Studies_Receptors>;
  /** fetch data from the table in a streaming manner: "research.studies" */
  research_studies_stream: Array<Research_Studies>;
  /** fetch data from the table: "research.terpenes" */
  research_terpenes: Array<Research_Terpenes>;
  /** fetch aggregated fields from the table: "research.terpenes" */
  research_terpenes_aggregate: Research_Terpenes_Aggregate;
  /** fetch data from the table in a streaming manner: "research.terpenes" */
  research_terpenes_stream: Array<Research_Terpenes>;
  /** fetch data from the table: "research.terpenes_studies" */
  research_terpenes_studies: Array<Research_Terpenes_Studies>;
  /** fetch aggregated fields from the table: "research.terpenes_studies" */
  research_terpenes_studies_aggregate: Research_Terpenes_Studies_Aggregate;
  /** fetch data from the table in a streaming manner: "research.terpenes_studies" */
  research_terpenes_studies_stream: Array<Research_Terpenes_Studies>;
};

export type Subscription_RootOutreach_Google_LocationsArgs = {
  distinct_on: InputMaybe<Array<Outreach_Google_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Google_Locations_Order_By>>;
  where: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
};

export type Subscription_RootOutreach_Google_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Outreach_Google_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Google_Locations_Order_By>>;
  where: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
};

export type Subscription_RootOutreach_Google_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Outreach_Google_Locations_Stream_Cursor_Input>>;
  where: InputMaybe<Outreach_Google_Locations_Bool_Exp>;
};

export type Subscription_RootOutreach_PartnersArgs = {
  distinct_on: InputMaybe<Array<Outreach_Partners_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Partners_Order_By>>;
  where: InputMaybe<Outreach_Partners_Bool_Exp>;
};

export type Subscription_RootOutreach_Partners_AggregateArgs = {
  distinct_on: InputMaybe<Array<Outreach_Partners_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Outreach_Partners_Order_By>>;
  where: InputMaybe<Outreach_Partners_Bool_Exp>;
};

export type Subscription_RootOutreach_Partners_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Outreach_Partners_Stream_Cursor_Input>>;
  where: InputMaybe<Outreach_Partners_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_CannabinoidsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Cannabinoids_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Cannabinoids_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research__Airbyte_Raw_Cannabinoids_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<Array<Research__Airbyte_Raw_Cannabinoids_Order_By>>;
    where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
  };

export type Subscription_RootResearch__Airbyte_Raw_Cannabinoids_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Subscription_RootResearch__Airbyte_Raw_Cannabinoids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<
    InputMaybe<Research__Airbyte_Raw_Cannabinoids_Stream_Cursor_Input>
  >;
  where: InputMaybe<Research__Airbyte_Raw_Cannabinoids_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Medical_ConditionsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<
    Array<Research__Airbyte_Raw_Medical_Conditions_Order_By>
  >;
  where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Medical_Conditions_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research__Airbyte_Raw_Medical_Conditions_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research__Airbyte_Raw_Medical_Conditions_Order_By>
    >;
    where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
  };

export type Subscription_RootResearch__Airbyte_Raw_Medical_Conditions_By_PkArgs =
  {
    _airbyte_ab_id: Scalars['String'];
  };

export type Subscription_RootResearch__Airbyte_Raw_Medical_Conditions_StreamArgs =
  {
    batch_size: Scalars['Int'];
    cursor: Array<
      InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Stream_Cursor_Input>
    >;
    where: InputMaybe<Research__Airbyte_Raw_Medical_Conditions_Bool_Exp>;
  };

export type Subscription_RootResearch__Airbyte_Raw_Organ_SystemsArgs = {
  distinct_on: InputMaybe<
    Array<Research__Airbyte_Raw_Organ_Systems_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Organ_Systems_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research__Airbyte_Raw_Organ_Systems_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<Array<Research__Airbyte_Raw_Organ_Systems_Order_By>>;
    where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
  };

export type Subscription_RootResearch__Airbyte_Raw_Organ_Systems_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Subscription_RootResearch__Airbyte_Raw_Organ_Systems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<
    InputMaybe<Research__Airbyte_Raw_Organ_Systems_Stream_Cursor_Input>
  >;
  where: InputMaybe<Research__Airbyte_Raw_Organ_Systems_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Studies_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Studies_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Studies_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Subscription_RootResearch__Airbyte_Raw_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research__Airbyte_Raw_Studies_Stream_Cursor_Input>>;
  where: InputMaybe<Research__Airbyte_Raw_Studies_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_TerpenesArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Terpenes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research__Airbyte_Raw_Terpenes_Order_By>>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch__Airbyte_Raw_Terpenes_By_PkArgs = {
  _airbyte_ab_id: Scalars['String'];
};

export type Subscription_RootResearch__Airbyte_Raw_Terpenes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research__Airbyte_Raw_Terpenes_Stream_Cursor_Input>>;
  where: InputMaybe<Research__Airbyte_Raw_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch_AdministrationsArgs = {
  distinct_on: InputMaybe<Array<Research_Administrations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Administrations_Order_By>>;
  where: InputMaybe<Research_Administrations_Bool_Exp>;
};

export type Subscription_RootResearch_Administrations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Administrations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Administrations_Order_By>>;
  where: InputMaybe<Research_Administrations_Bool_Exp>;
};

export type Subscription_RootResearch_Administrations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Administrations_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Administrations_Bool_Exp>;
};

export type Subscription_RootResearch_CannabinoidsArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Bool_Exp>;
};

export type Subscription_RootResearch_Cannabinoids_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Bool_Exp>;
};

export type Subscription_RootResearch_Cannabinoids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Cannabinoids_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Cannabinoids_Bool_Exp>;
};

export type Subscription_RootResearch_Cannabinoids_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Cannabinoids_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Cannabinoids_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Cannabinoids_Studies_Order_By>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Cannabinoids_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Cannabinoids_Studies_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Cannabinoids_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_ChemotypesArgs = {
  distinct_on: InputMaybe<Array<Research_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_Chemotypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_Chemotypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Chemotypes_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_LigandsArgs = {
  distinct_on: InputMaybe<Array<Research_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Ligands_Order_By>>;
  where: InputMaybe<Research_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_Ligands_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Ligands_Order_By>>;
  where: InputMaybe<Research_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_Ligands_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Ligands_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_LocationsArgs = {
  distinct_on: InputMaybe<Array<Research_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Locations_Order_By>>;
  where: InputMaybe<Research_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Locations_Order_By>>;
  where: InputMaybe<Research_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Locations_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Medical_ConditionsArgs = {
  distinct_on: InputMaybe<Array<Research_Medical_Conditions_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
};

export type Subscription_RootResearch_Medical_Conditions_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Medical_Conditions_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
};

export type Subscription_RootResearch_Medical_Conditions_Clinicial_DosingArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_Clinicial_Dosing_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_Clinicial_Dosing_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_Clinicial_Dosing_StreamArgs =
  {
    batch_size: Scalars['Int'];
    cursor: Array<
      InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Stream_Cursor_Input>
    >;
    where: InputMaybe<Research_Medical_Conditions_Clinicial_Dosing_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_State_Of_ScienceArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_State_Of_Science_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<
      Array<Research_Medical_Conditions_State_Of_Science_Order_By>
    >;
    where: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_State_Of_Science_StreamArgs =
  {
    batch_size: Scalars['Int'];
    cursor: Array<
      InputMaybe<Research_Medical_Conditions_State_Of_Science_Stream_Cursor_Input>
    >;
    where: InputMaybe<Research_Medical_Conditions_State_Of_Science_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Medical_Conditions_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Medical_Conditions_Bool_Exp>;
};

export type Subscription_RootResearch_Medical_Conditions_StudiesArgs = {
  distinct_on: InputMaybe<
    Array<Research_Medical_Conditions_Studies_Select_Column>
  >;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Medical_Conditions_Studies_AggregateArgs =
  {
    distinct_on: InputMaybe<
      Array<Research_Medical_Conditions_Studies_Select_Column>
    >;
    limit: InputMaybe<Scalars['Int']>;
    offset: InputMaybe<Scalars['Int']>;
    order_by: InputMaybe<Array<Research_Medical_Conditions_Studies_Order_By>>;
    where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
  };

export type Subscription_RootResearch_Medical_Conditions_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<
    InputMaybe<Research_Medical_Conditions_Studies_Stream_Cursor_Input>
  >;
  where: InputMaybe<Research_Medical_Conditions_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_SystemsArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_Systems_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_Systems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Organ_Systems_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Organ_Systems_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_Systems_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_Systems_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Organ_Systems_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Organ_Systems_Studies_Order_By>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Organ_Systems_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Organ_Systems_Studies_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Organ_Systems_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_ReceptorsArgs = {
  distinct_on: InputMaybe<Array<Research_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Receptors_Order_By>>;
  where: InputMaybe<Research_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_Receptors_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Receptors_Order_By>>;
  where: InputMaybe<Research_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_Receptors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Receptors_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Order_By>>;
  where: InputMaybe<Research_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_AdministrationArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Administration_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Administration_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Administration_Order_By>>;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Administration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<
    InputMaybe<Research_Studies_Administration_Stream_Cursor_Input>
  >;
  where: InputMaybe<Research_Studies_Administration_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Order_By>>;
  where: InputMaybe<Research_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_ChemotypesArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Chemotypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Chemotypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Chemotypes_Order_By>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Chemotypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Studies_Chemotypes_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Studies_Chemotypes_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_LigandsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Ligands_Order_By>>;
  where: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Ligands_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Ligands_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Ligands_Order_By>>;
  where: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Ligands_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Studies_Ligands_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Studies_Ligands_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_LocationsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Locations_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Locations_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Locations_Order_By>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Studies_Locations_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Studies_Locations_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_ReceptorsArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Receptors_Order_By>>;
  where: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Receptors_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Studies_Receptors_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Studies_Receptors_Order_By>>;
  where: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_Receptors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Studies_Receptors_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Studies_Receptors_Bool_Exp>;
};

export type Subscription_RootResearch_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Studies_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_TerpenesArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Order_By>>;
  where: InputMaybe<Research_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch_Terpenes_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Order_By>>;
  where: InputMaybe<Research_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch_Terpenes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Terpenes_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Terpenes_Bool_Exp>;
};

export type Subscription_RootResearch_Terpenes_StudiesArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Studies_Order_By>>;
  where: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Terpenes_Studies_AggregateArgs = {
  distinct_on: InputMaybe<Array<Research_Terpenes_Studies_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Research_Terpenes_Studies_Order_By>>;
  where: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
};

export type Subscription_RootResearch_Terpenes_Studies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Research_Terpenes_Studies_Stream_Cursor_Input>>;
  where: InputMaybe<Research_Terpenes_Studies_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq: InputMaybe<Scalars['timestamp']>;
  _gt: InputMaybe<Scalars['timestamp']>;
  _gte: InputMaybe<Scalars['timestamp']>;
  _in: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['timestamp']>;
  _lte: InputMaybe<Scalars['timestamp']>;
  _neq: InputMaybe<Scalars['timestamp']>;
  _nin: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq: InputMaybe<Scalars['timestamptz']>;
  _gt: InputMaybe<Scalars['timestamptz']>;
  _gte: InputMaybe<Scalars['timestamptz']>;
  _in: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null: InputMaybe<Scalars['Boolean']>;
  _lt: InputMaybe<Scalars['timestamptz']>;
  _lte: InputMaybe<Scalars['timestamptz']>;
  _neq: InputMaybe<Scalars['timestamptz']>;
  _nin: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type CannabinoidsStudiesQueryVariables = Exact<{
  cannabinoidIds?: InputMaybe<Float8_Comparison_Exp>;
  studyIds?: InputMaybe<Float8_Comparison_Exp>;
}>;

export type CannabinoidsStudiesQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'research_cannabinoids';
    category: string | null;
    id: any | null;
    name: string | null;
    studies: Array<{
      __typename?: 'research_cannabinoids_studies';
      id: any | null;
    }>;
  }>;
};

export type ChemotypesByIdQueryVariables = Exact<{
  ids: InputMaybe<Array<Scalars['float8']> | Scalars['float8']>;
}>;

export type ChemotypesByIdQuery = {
  __typename?: 'query_root';
  research_chemotypes: Array<{
    __typename?: 'research_chemotypes';
    chemotype: string | null;
    id: any | null;
  }>;
};

export type ConditionsStudiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  conditionIds?: InputMaybe<Float8_Comparison_Exp>;
  studyIds?: InputMaybe<Float8_Comparison_Exp>;
}>;

export type ConditionsStudiesQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_medical_conditions_aggregate';
    aggregate: {
      __typename?: 'research_medical_conditions_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_medical_conditions';
    id: any | null;
    name: string | null;
    studies: {
      __typename?: 'research_medical_conditions_studies_aggregate';
      aggregate: {
        __typename?: 'research_medical_conditions_studies_aggregate_fields';
        count: number;
      } | null;
    };
  }>;
};

export type ConditionStudiesQueryVariables = Exact<{
  conditionId: Scalars['float8'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type ConditionStudiesQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_studies';
    id: any | null;
    link: string | null;
    result: string | null;
    title: string | null;
    typeofstudy: string | null;
  }>;
};

export type ConditionStudyTypesQueryVariables = Exact<{
  conditionId: InputMaybe<Scalars['float8']>;
}>;

export type ConditionStudyTypesQuery = {
  __typename?: 'query_root';
  research_studies: Array<{
    __typename?: 'research_studies';
    typeofstudy: string | null;
  }>;
};

export type CountConditionStudiesByTypeQueryVariables = Exact<{
  conditionId: InputMaybe<Scalars['float8']>;
  type: InputMaybe<Scalars['String']>;
}>;

export type CountConditionStudiesByTypeQuery = {
  __typename?: 'query_root';
  research_studies_aggregate: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
};

export type LocationsStudiesQueryVariables = Exact<{
  locationIds?: InputMaybe<Float8_Comparison_Exp>;
  studyIds?: InputMaybe<Float8_Comparison_Exp>;
}>;

export type LocationsStudiesQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'research_locations';
    id: any | null;
    location: string | null;
    studies: {
      __typename?: 'research_studies_locations_aggregate';
      aggregate: {
        __typename?: 'research_studies_locations_aggregate_fields';
        count: number;
      } | null;
    };
  }>;
};

export type OrganSystemsStudiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  systemIds?: InputMaybe<Float8_Comparison_Exp>;
  studyIds?: InputMaybe<Float8_Comparison_Exp>;
}>;

export type OrganSystemsStudiesQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_organ_systems_aggregate';
    aggregate: {
      __typename?: 'research_organ_systems_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_organ_systems';
    id: any | null;
    name: string | null;
    studies: {
      __typename?: 'research_organ_systems_studies_aggregate';
      aggregate: {
        __typename?: 'research_organ_systems_studies_aggregate_fields';
        count: number;
      } | null;
    };
  }>;
};

export type PartnersLocationsQueryVariables = Exact<{ [key: string]: never }>;

export type PartnersLocationsQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'outreach_partners';
    id: any | null;
    name: string | null;
    google_location: {
      __typename?: 'outreach_google_locations';
      lat: any | null;
      lng: any | null;
      formatted_address: string | null;
      opening_hours: string | null;
      rating: any | null;
      address_components: string | null;
    } | null;
  }>;
};

export type PartnersLocationsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<
    Array<Outreach_Partners_Order_By> | Outreach_Partners_Order_By
  >;
}>;

export type PartnersLocationsSearchQuery = {
  __typename?: 'query_root';
  nodes: Array<{ __typename?: 'outreach_partners'; id: any | null }>;
};

export type PartnersNearbyQueryVariables = Exact<{
  fromLat: InputMaybe<Scalars['float8']>;
  toLat: InputMaybe<Scalars['float8']>;
  fromLng: InputMaybe<Scalars['float8']>;
  toLng: InputMaybe<Scalars['float8']>;
  excludeId: InputMaybe<Scalars['float8']>;
}>;

export type PartnersNearbyQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'outreach_partners';
    id: any | null;
    name: string | null;
    google_location: {
      __typename?: 'outreach_google_locations';
      address_components: string | null;
      formatted_address: string | null;
      opening_hours: string | null;
      lat: any | null;
      lng: any | null;
      rating: any | null;
    } | null;
  }>;
};

export type PartnersLocationsByIdsQueryVariables = Exact<{
  ids: InputMaybe<Array<Scalars['float8']> | Scalars['float8']>;
}>;

export type PartnersLocationsByIdsQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'outreach_partners';
    id: any | null;
    google_location: {
      __typename?: 'outreach_google_locations';
      lat: any | null;
      lng: any | null;
      formatted_address: string | null;
      international_phone_number: string | null;
      opening_hours: string | null;
      place_id: string | null;
      rating: any | null;
      reviews: string | null;
      user_ratings_total: any | null;
      address_components: string | null;
    } | null;
  }>;
};

export type PartnersReviewsQueryVariables = Exact<{ [key: string]: never }>;

export type PartnersReviewsQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'outreach_google_locations';
    reviews: string | null;
  }>;
};

export type SingleStudyQueryVariables = Exact<{
  id: InputMaybe<Scalars['float8']>;
}>;

export type SingleStudyQuery = {
  __typename?: 'query_root';
  research_studies: Array<{
    __typename?: 'research_studies';
    id: any | null;
    dosage: string | null;
    keyfindings: string | null;
    samplesize: any | null;
    subratio: string | null;
    source: string | null;
    phytocannabinoidsource: string | null;
    year: string | null;
    administrations: Array<{
      __typename?: 'research_studies_administration';
      administration_id: any | null;
    }>;
    chemotypes: Array<{
      __typename?: 'research_studies_chemotypes';
      chemotype_id: any | null;
    }>;
    cannabinoids: Array<{
      __typename?: 'research_cannabinoids_studies';
      cannabinoid_id: any | null;
    }>;
  }>;
};

export type CountStudiesByFilterQueryVariables = Exact<{
  filters?: InputMaybe<Research_Studies_Bool_Exp>;
}>;

export type CountStudiesByFilterQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
};

export type StudiesByYearQueryVariables = Exact<{
  filters?: InputMaybe<Research_Studies_Bool_Exp>;
}>;

export type StudiesByYearQuery = {
  __typename?: 'query_root';
  nodes: Array<{
    __typename?: 'research_studies';
    id: any | null;
    year: string | null;
  }>;
};

export type StudiesFilterQueryVariables = Exact<{
  filters?: InputMaybe<Research_Studies_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type StudiesFilterQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_studies';
    id: any | null;
    link: string | null;
    title: string | null;
  }>;
};

export type StudyResultsQueryVariables = Exact<{
  filters?: InputMaybe<Research_Studies_Bool_Exp>;
}>;

export type StudyResultsQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_studies';
    id: any | null;
    result: string | null;
  }>;
};

export type StudyTypesQueryVariables = Exact<{ [key: string]: never }>;

export type StudyTypesQuery = {
  __typename?: 'query_root';
  pagination: {
    __typename?: 'research_studies_aggregate';
    aggregate: {
      __typename?: 'research_studies_aggregate_fields';
      count: number;
    } | null;
  };
  nodes: Array<{
    __typename?: 'research_studies';
    id: any | null;
    typeofstudy: string | null;
  }>;
};

export const CannabinoidsStudiesDocument = /*#__PURE__*/ gql`
  query CannabinoidsStudies(
    $cannabinoidIds: float8_comparison_exp = {}
    $studyIds: float8_comparison_exp = {}
  ) {
    nodes: research_cannabinoids(
      where: { id: $cannabinoidIds, studies: { study_id: $studyIds } }
      order_by: { category: asc, name: asc }
    ) {
      category
      id
      name
      studies(where: { study_id: $studyIds }) {
        id: study_id
      }
    }
  }
`;

/**
 * __useCannabinoidsStudiesQuery__
 *
 * To run a query within a React component, call `useCannabinoidsStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCannabinoidsStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCannabinoidsStudiesQuery({
 *   variables: {
 *      cannabinoidIds: // value for 'cannabinoidIds'
 *      studyIds: // value for 'studyIds'
 *   },
 * });
 */
export function useCannabinoidsStudiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CannabinoidsStudiesQuery,
    CannabinoidsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CannabinoidsStudiesQuery,
    CannabinoidsStudiesQueryVariables
  >(CannabinoidsStudiesDocument, options);
}
export function useCannabinoidsStudiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CannabinoidsStudiesQuery,
    CannabinoidsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CannabinoidsStudiesQuery,
    CannabinoidsStudiesQueryVariables
  >(CannabinoidsStudiesDocument, options);
}
export type CannabinoidsStudiesQueryHookResult = ReturnType<
  typeof useCannabinoidsStudiesQuery
>;
export type CannabinoidsStudiesLazyQueryHookResult = ReturnType<
  typeof useCannabinoidsStudiesLazyQuery
>;
export type CannabinoidsStudiesQueryResult = Apollo.QueryResult<
  CannabinoidsStudiesQuery,
  CannabinoidsStudiesQueryVariables
>;
export function refetchCannabinoidsStudiesQuery(
  variables?: CannabinoidsStudiesQueryVariables,
) {
  return { query: CannabinoidsStudiesDocument, variables: variables };
}
export const ChemotypesByIdDocument = /*#__PURE__*/ gql`
  query ChemotypesById($ids: [float8!]) {
    research_chemotypes(where: { id: { _in: $ids } }) {
      chemotype
      id
    }
  }
`;

/**
 * __useChemotypesByIdQuery__
 *
 * To run a query within a React component, call `useChemotypesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useChemotypesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChemotypesByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChemotypesByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChemotypesByIdQuery,
    ChemotypesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChemotypesByIdQuery, ChemotypesByIdQueryVariables>(
    ChemotypesByIdDocument,
    options,
  );
}
export function useChemotypesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChemotypesByIdQuery,
    ChemotypesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChemotypesByIdQuery, ChemotypesByIdQueryVariables>(
    ChemotypesByIdDocument,
    options,
  );
}
export type ChemotypesByIdQueryHookResult = ReturnType<
  typeof useChemotypesByIdQuery
>;
export type ChemotypesByIdLazyQueryHookResult = ReturnType<
  typeof useChemotypesByIdLazyQuery
>;
export type ChemotypesByIdQueryResult = Apollo.QueryResult<
  ChemotypesByIdQuery,
  ChemotypesByIdQueryVariables
>;
export function refetchChemotypesByIdQuery(
  variables?: ChemotypesByIdQueryVariables,
) {
  return { query: ChemotypesByIdDocument, variables: variables };
}
export const ConditionsStudiesDocument = /*#__PURE__*/ gql`
  query ConditionsStudies(
    $limit: Int = 16
    $offset: Int = 0
    $search: String = "%"
    $conditionIds: float8_comparison_exp = {}
    $studyIds: float8_comparison_exp = {}
  ) {
    pagination: research_medical_conditions_aggregate(
      where: {
        name: { _ilike: $search }
        id: $conditionIds
        studies: { study_id: $studyIds }
      }
    ) {
      aggregate {
        count
      }
    }
    nodes: research_medical_conditions(
      limit: $limit
      offset: $offset
      order_by: { name: asc }
      where: {
        name: { _ilike: $search }
        id: $conditionIds
        studies: { study_id: $studyIds }
      }
    ) {
      id
      name
      studies: studies_aggregate(where: { study_id: $studyIds }) {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * __useConditionsStudiesQuery__
 *
 * To run a query within a React component, call `useConditionsStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionsStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionsStudiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      conditionIds: // value for 'conditionIds'
 *      studyIds: // value for 'studyIds'
 *   },
 * });
 */
export function useConditionsStudiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConditionsStudiesQuery,
    ConditionsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConditionsStudiesQuery,
    ConditionsStudiesQueryVariables
  >(ConditionsStudiesDocument, options);
}
export function useConditionsStudiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConditionsStudiesQuery,
    ConditionsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConditionsStudiesQuery,
    ConditionsStudiesQueryVariables
  >(ConditionsStudiesDocument, options);
}
export type ConditionsStudiesQueryHookResult = ReturnType<
  typeof useConditionsStudiesQuery
>;
export type ConditionsStudiesLazyQueryHookResult = ReturnType<
  typeof useConditionsStudiesLazyQuery
>;
export type ConditionsStudiesQueryResult = Apollo.QueryResult<
  ConditionsStudiesQuery,
  ConditionsStudiesQueryVariables
>;
export function refetchConditionsStudiesQuery(
  variables?: ConditionsStudiesQueryVariables,
) {
  return { query: ConditionsStudiesDocument, variables: variables };
}
export const ConditionStudiesDocument = /*#__PURE__*/ gql`
  query ConditionStudies(
    $conditionId: float8!
    $limit: Int = 5
    $offset: Int = 0
  ) {
    pagination: research_studies_aggregate(
      where: { conditions: { medical_condition_id: { _eq: $conditionId } } }
    ) {
      aggregate {
        count
      }
    }
    nodes: research_studies(
      limit: $limit
      order_by: { title: asc }
      offset: $offset
      where: { conditions: { medical_condition_id: { _eq: $conditionId } } }
    ) {
      id
      link
      result
      title
      typeofstudy
    }
  }
`;

/**
 * __useConditionStudiesQuery__
 *
 * To run a query within a React component, call `useConditionStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionStudiesQuery({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useConditionStudiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConditionStudiesQuery,
    ConditionStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConditionStudiesQuery, ConditionStudiesQueryVariables>(
    ConditionStudiesDocument,
    options,
  );
}
export function useConditionStudiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConditionStudiesQuery,
    ConditionStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConditionStudiesQuery,
    ConditionStudiesQueryVariables
  >(ConditionStudiesDocument, options);
}
export type ConditionStudiesQueryHookResult = ReturnType<
  typeof useConditionStudiesQuery
>;
export type ConditionStudiesLazyQueryHookResult = ReturnType<
  typeof useConditionStudiesLazyQuery
>;
export type ConditionStudiesQueryResult = Apollo.QueryResult<
  ConditionStudiesQuery,
  ConditionStudiesQueryVariables
>;
export function refetchConditionStudiesQuery(
  variables: ConditionStudiesQueryVariables,
) {
  return { query: ConditionStudiesDocument, variables: variables };
}
export const ConditionStudyTypesDocument = /*#__PURE__*/ gql`
  query ConditionStudyTypes($conditionId: float8) {
    research_studies(
      distinct_on: typeofstudy
      where: { conditions: { medical_condition_id: { _eq: $conditionId } } }
    ) {
      typeofstudy
    }
  }
`;

/**
 * __useConditionStudyTypesQuery__
 *
 * To run a query within a React component, call `useConditionStudyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionStudyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionStudyTypesQuery({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *   },
 * });
 */
export function useConditionStudyTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConditionStudyTypesQuery,
    ConditionStudyTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConditionStudyTypesQuery,
    ConditionStudyTypesQueryVariables
  >(ConditionStudyTypesDocument, options);
}
export function useConditionStudyTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConditionStudyTypesQuery,
    ConditionStudyTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConditionStudyTypesQuery,
    ConditionStudyTypesQueryVariables
  >(ConditionStudyTypesDocument, options);
}
export type ConditionStudyTypesQueryHookResult = ReturnType<
  typeof useConditionStudyTypesQuery
>;
export type ConditionStudyTypesLazyQueryHookResult = ReturnType<
  typeof useConditionStudyTypesLazyQuery
>;
export type ConditionStudyTypesQueryResult = Apollo.QueryResult<
  ConditionStudyTypesQuery,
  ConditionStudyTypesQueryVariables
>;
export function refetchConditionStudyTypesQuery(
  variables?: ConditionStudyTypesQueryVariables,
) {
  return { query: ConditionStudyTypesDocument, variables: variables };
}
export const CountConditionStudiesByTypeDocument = /*#__PURE__*/ gql`
  query CountConditionStudiesByType($conditionId: float8, $type: String) {
    research_studies_aggregate(
      where: {
        conditions: { medical_condition_id: { _eq: $conditionId } }
        typeofstudy: { _eq: $type }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useCountConditionStudiesByTypeQuery__
 *
 * To run a query within a React component, call `useCountConditionStudiesByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountConditionStudiesByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountConditionStudiesByTypeQuery({
 *   variables: {
 *      conditionId: // value for 'conditionId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCountConditionStudiesByTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountConditionStudiesByTypeQuery,
    CountConditionStudiesByTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CountConditionStudiesByTypeQuery,
    CountConditionStudiesByTypeQueryVariables
  >(CountConditionStudiesByTypeDocument, options);
}
export function useCountConditionStudiesByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountConditionStudiesByTypeQuery,
    CountConditionStudiesByTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CountConditionStudiesByTypeQuery,
    CountConditionStudiesByTypeQueryVariables
  >(CountConditionStudiesByTypeDocument, options);
}
export type CountConditionStudiesByTypeQueryHookResult = ReturnType<
  typeof useCountConditionStudiesByTypeQuery
>;
export type CountConditionStudiesByTypeLazyQueryHookResult = ReturnType<
  typeof useCountConditionStudiesByTypeLazyQuery
>;
export type CountConditionStudiesByTypeQueryResult = Apollo.QueryResult<
  CountConditionStudiesByTypeQuery,
  CountConditionStudiesByTypeQueryVariables
>;
export function refetchCountConditionStudiesByTypeQuery(
  variables?: CountConditionStudiesByTypeQueryVariables,
) {
  return { query: CountConditionStudiesByTypeDocument, variables: variables };
}
export const LocationsStudiesDocument = /*#__PURE__*/ gql`
  query LocationsStudies(
    $locationIds: float8_comparison_exp = {}
    $studyIds: float8_comparison_exp = {}
  ) {
    nodes: research_locations(
      where: { id: $locationIds, studies: { study_id: $studyIds } }
      order_by: { studies_aggregate: { count: desc } }
    ) {
      id
      location
      studies: studies_aggregate(where: { study_id: $studyIds }) {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * __useLocationsStudiesQuery__
 *
 * To run a query within a React component, call `useLocationsStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsStudiesQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      studyIds: // value for 'studyIds'
 *   },
 * });
 */
export function useLocationsStudiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocationsStudiesQuery,
    LocationsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationsStudiesQuery, LocationsStudiesQueryVariables>(
    LocationsStudiesDocument,
    options,
  );
}
export function useLocationsStudiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationsStudiesQuery,
    LocationsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LocationsStudiesQuery,
    LocationsStudiesQueryVariables
  >(LocationsStudiesDocument, options);
}
export type LocationsStudiesQueryHookResult = ReturnType<
  typeof useLocationsStudiesQuery
>;
export type LocationsStudiesLazyQueryHookResult = ReturnType<
  typeof useLocationsStudiesLazyQuery
>;
export type LocationsStudiesQueryResult = Apollo.QueryResult<
  LocationsStudiesQuery,
  LocationsStudiesQueryVariables
>;
export function refetchLocationsStudiesQuery(
  variables?: LocationsStudiesQueryVariables,
) {
  return { query: LocationsStudiesDocument, variables: variables };
}
export const OrganSystemsStudiesDocument = /*#__PURE__*/ gql`
  query OrganSystemsStudies(
    $limit: Int = 6
    $offset: Int = 0
    $search: String = "%"
    $systemIds: float8_comparison_exp = {}
    $studyIds: float8_comparison_exp = {}
  ) {
    pagination: research_organ_systems_aggregate(
      where: {
        name: { _ilike: $search }
        id: $systemIds
        studies: { study_id: $studyIds }
      }
    ) {
      aggregate {
        count
      }
    }
    nodes: research_organ_systems(
      limit: $limit
      offset: $offset
      order_by: { name: asc }
      where: {
        name: { _ilike: $search }
        id: $systemIds
        studies: { study_id: $studyIds }
      }
    ) {
      id
      name
      studies: studies_aggregate(where: { study_id: $studyIds }) {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * __useOrganSystemsStudiesQuery__
 *
 * To run a query within a React component, call `useOrganSystemsStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganSystemsStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganSystemsStudiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      systemIds: // value for 'systemIds'
 *      studyIds: // value for 'studyIds'
 *   },
 * });
 */
export function useOrganSystemsStudiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganSystemsStudiesQuery,
    OrganSystemsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganSystemsStudiesQuery,
    OrganSystemsStudiesQueryVariables
  >(OrganSystemsStudiesDocument, options);
}
export function useOrganSystemsStudiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganSystemsStudiesQuery,
    OrganSystemsStudiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganSystemsStudiesQuery,
    OrganSystemsStudiesQueryVariables
  >(OrganSystemsStudiesDocument, options);
}
export type OrganSystemsStudiesQueryHookResult = ReturnType<
  typeof useOrganSystemsStudiesQuery
>;
export type OrganSystemsStudiesLazyQueryHookResult = ReturnType<
  typeof useOrganSystemsStudiesLazyQuery
>;
export type OrganSystemsStudiesQueryResult = Apollo.QueryResult<
  OrganSystemsStudiesQuery,
  OrganSystemsStudiesQueryVariables
>;
export function refetchOrganSystemsStudiesQuery(
  variables?: OrganSystemsStudiesQueryVariables,
) {
  return { query: OrganSystemsStudiesDocument, variables: variables };
}
export const PartnersLocationsDocument = /*#__PURE__*/ gql`
  query PartnersLocations {
    nodes: outreach_partners(
      where: {
        google_location: { lat: { _is_null: false }, lng: { _is_null: false } }
      }
    ) {
      id
      name
      google_location {
        lat
        lng
        formatted_address
        opening_hours
        rating
        address_components
      }
    }
  }
`;

/**
 * __usePartnersLocationsQuery__
 *
 * To run a query within a React component, call `usePartnersLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnersLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersLocationsQuery,
    PartnersLocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PartnersLocationsQuery,
    PartnersLocationsQueryVariables
  >(PartnersLocationsDocument, options);
}
export function usePartnersLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersLocationsQuery,
    PartnersLocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PartnersLocationsQuery,
    PartnersLocationsQueryVariables
  >(PartnersLocationsDocument, options);
}
export type PartnersLocationsQueryHookResult = ReturnType<
  typeof usePartnersLocationsQuery
>;
export type PartnersLocationsLazyQueryHookResult = ReturnType<
  typeof usePartnersLocationsLazyQuery
>;
export type PartnersLocationsQueryResult = Apollo.QueryResult<
  PartnersLocationsQuery,
  PartnersLocationsQueryVariables
>;
export function refetchPartnersLocationsQuery(
  variables?: PartnersLocationsQueryVariables,
) {
  return { query: PartnersLocationsDocument, variables: variables };
}
export const PartnersLocationsSearchDocument = /*#__PURE__*/ gql`
  query PartnersLocationsSearch(
    $search: String = "%"
    $sort: [outreach_partners_order_by!] = { name: asc }
  ) {
    nodes: outreach_partners(
      where: {
        google_location: { lat: { _is_null: false }, lng: { _is_null: false } }
        _or: [
          { name: { _like: $search } }
          { google_location: { formatted_address: { _ilike: $search } } }
        ]
      }
      order_by: $sort
    ) {
      id
    }
  }
`;

/**
 * __usePartnersLocationsSearchQuery__
 *
 * To run a query within a React component, call `usePartnersLocationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersLocationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersLocationsSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePartnersLocationsSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersLocationsSearchQuery,
    PartnersLocationsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PartnersLocationsSearchQuery,
    PartnersLocationsSearchQueryVariables
  >(PartnersLocationsSearchDocument, options);
}
export function usePartnersLocationsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersLocationsSearchQuery,
    PartnersLocationsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PartnersLocationsSearchQuery,
    PartnersLocationsSearchQueryVariables
  >(PartnersLocationsSearchDocument, options);
}
export type PartnersLocationsSearchQueryHookResult = ReturnType<
  typeof usePartnersLocationsSearchQuery
>;
export type PartnersLocationsSearchLazyQueryHookResult = ReturnType<
  typeof usePartnersLocationsSearchLazyQuery
>;
export type PartnersLocationsSearchQueryResult = Apollo.QueryResult<
  PartnersLocationsSearchQuery,
  PartnersLocationsSearchQueryVariables
>;
export function refetchPartnersLocationsSearchQuery(
  variables?: PartnersLocationsSearchQueryVariables,
) {
  return { query: PartnersLocationsSearchDocument, variables: variables };
}
export const PartnersNearbyDocument = /*#__PURE__*/ gql`
  query PartnersNearby(
    $fromLat: float8
    $toLat: float8
    $fromLng: float8
    $toLng: float8
    $excludeId: float8
  ) {
    nodes: outreach_partners(
      where: {
        id: { _neq: $excludeId }
        google_location: {
          lat: { _gte: $fromLat, _lte: $toLat }
          lng: { _gte: $fromLng, _lte: $toLng }
        }
      }
    ) {
      id
      name
      google_location {
        address_components
        formatted_address
        opening_hours
        lat
        lng
        rating
      }
    }
  }
`;

/**
 * __usePartnersNearbyQuery__
 *
 * To run a query within a React component, call `usePartnersNearbyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersNearbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersNearbyQuery({
 *   variables: {
 *      fromLat: // value for 'fromLat'
 *      toLat: // value for 'toLat'
 *      fromLng: // value for 'fromLng'
 *      toLng: // value for 'toLng'
 *      excludeId: // value for 'excludeId'
 *   },
 * });
 */
export function usePartnersNearbyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersNearbyQuery,
    PartnersNearbyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PartnersNearbyQuery, PartnersNearbyQueryVariables>(
    PartnersNearbyDocument,
    options,
  );
}
export function usePartnersNearbyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersNearbyQuery,
    PartnersNearbyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PartnersNearbyQuery, PartnersNearbyQueryVariables>(
    PartnersNearbyDocument,
    options,
  );
}
export type PartnersNearbyQueryHookResult = ReturnType<
  typeof usePartnersNearbyQuery
>;
export type PartnersNearbyLazyQueryHookResult = ReturnType<
  typeof usePartnersNearbyLazyQuery
>;
export type PartnersNearbyQueryResult = Apollo.QueryResult<
  PartnersNearbyQuery,
  PartnersNearbyQueryVariables
>;
export function refetchPartnersNearbyQuery(
  variables?: PartnersNearbyQueryVariables,
) {
  return { query: PartnersNearbyDocument, variables: variables };
}
export const PartnersLocationsByIdsDocument = /*#__PURE__*/ gql`
  query PartnersLocationsByIds($ids: [float8!]) {
    nodes: outreach_partners(
      where: {
        google_location: { lat: { _is_null: false }, lng: { _is_null: false } }
        id: { _in: $ids }
      }
    ) {
      id
      google_location {
        lat
        lng
        formatted_address
        international_phone_number
        opening_hours
        place_id
        rating
        reviews
        user_ratings_total
        address_components
      }
    }
  }
`;

/**
 * __usePartnersLocationsByIdsQuery__
 *
 * To run a query within a React component, call `usePartnersLocationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersLocationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersLocationsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePartnersLocationsByIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersLocationsByIdsQuery,
    PartnersLocationsByIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PartnersLocationsByIdsQuery,
    PartnersLocationsByIdsQueryVariables
  >(PartnersLocationsByIdsDocument, options);
}
export function usePartnersLocationsByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersLocationsByIdsQuery,
    PartnersLocationsByIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PartnersLocationsByIdsQuery,
    PartnersLocationsByIdsQueryVariables
  >(PartnersLocationsByIdsDocument, options);
}
export type PartnersLocationsByIdsQueryHookResult = ReturnType<
  typeof usePartnersLocationsByIdsQuery
>;
export type PartnersLocationsByIdsLazyQueryHookResult = ReturnType<
  typeof usePartnersLocationsByIdsLazyQuery
>;
export type PartnersLocationsByIdsQueryResult = Apollo.QueryResult<
  PartnersLocationsByIdsQuery,
  PartnersLocationsByIdsQueryVariables
>;
export function refetchPartnersLocationsByIdsQuery(
  variables?: PartnersLocationsByIdsQueryVariables,
) {
  return { query: PartnersLocationsByIdsDocument, variables: variables };
}
export const PartnersReviewsDocument = /*#__PURE__*/ gql`
  query PartnersReviews {
    nodes: outreach_google_locations(
      where: {
        lat: { _is_null: false }
        lng: { _is_null: false }
        rating: { _gte: "4" }
      }
      order_by: { created_at: desc }
      limit: 8
    ) {
      reviews
    }
  }
`;

/**
 * __usePartnersReviewsQuery__
 *
 * To run a query within a React component, call `usePartnersReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnersReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnersReviewsQuery,
    PartnersReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PartnersReviewsQuery, PartnersReviewsQueryVariables>(
    PartnersReviewsDocument,
    options,
  );
}
export function usePartnersReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnersReviewsQuery,
    PartnersReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PartnersReviewsQuery,
    PartnersReviewsQueryVariables
  >(PartnersReviewsDocument, options);
}
export type PartnersReviewsQueryHookResult = ReturnType<
  typeof usePartnersReviewsQuery
>;
export type PartnersReviewsLazyQueryHookResult = ReturnType<
  typeof usePartnersReviewsLazyQuery
>;
export type PartnersReviewsQueryResult = Apollo.QueryResult<
  PartnersReviewsQuery,
  PartnersReviewsQueryVariables
>;
export function refetchPartnersReviewsQuery(
  variables?: PartnersReviewsQueryVariables,
) {
  return { query: PartnersReviewsDocument, variables: variables };
}
export const SingleStudyDocument = /*#__PURE__*/ gql`
  query SingleStudy($id: float8) {
    research_studies(where: { id: { _eq: $id } }) {
      id
      dosage
      keyfindings
      samplesize
      subratio
      source
      phytocannabinoidsource
      year
      administrations {
        administration_id
      }
      chemotypes {
        chemotype_id
      }
      cannabinoids {
        cannabinoid_id
      }
    }
  }
`;

/**
 * __useSingleStudyQuery__
 *
 * To run a query within a React component, call `useSingleStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleStudyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SingleStudyQuery,
    SingleStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SingleStudyQuery, SingleStudyQueryVariables>(
    SingleStudyDocument,
    options,
  );
}
export function useSingleStudyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleStudyQuery,
    SingleStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SingleStudyQuery, SingleStudyQueryVariables>(
    SingleStudyDocument,
    options,
  );
}
export type SingleStudyQueryHookResult = ReturnType<typeof useSingleStudyQuery>;
export type SingleStudyLazyQueryHookResult = ReturnType<
  typeof useSingleStudyLazyQuery
>;
export type SingleStudyQueryResult = Apollo.QueryResult<
  SingleStudyQuery,
  SingleStudyQueryVariables
>;
export function refetchSingleStudyQuery(variables?: SingleStudyQueryVariables) {
  return { query: SingleStudyDocument, variables: variables };
}
export const CountStudiesByFilterDocument = /*#__PURE__*/ gql`
  query CountStudiesByFilter($filters: research_studies_bool_exp = {}) {
    pagination: research_studies_aggregate(where: $filters) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useCountStudiesByFilterQuery__
 *
 * To run a query within a React component, call `useCountStudiesByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountStudiesByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountStudiesByFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCountStudiesByFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountStudiesByFilterQuery,
    CountStudiesByFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CountStudiesByFilterQuery,
    CountStudiesByFilterQueryVariables
  >(CountStudiesByFilterDocument, options);
}
export function useCountStudiesByFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountStudiesByFilterQuery,
    CountStudiesByFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CountStudiesByFilterQuery,
    CountStudiesByFilterQueryVariables
  >(CountStudiesByFilterDocument, options);
}
export type CountStudiesByFilterQueryHookResult = ReturnType<
  typeof useCountStudiesByFilterQuery
>;
export type CountStudiesByFilterLazyQueryHookResult = ReturnType<
  typeof useCountStudiesByFilterLazyQuery
>;
export type CountStudiesByFilterQueryResult = Apollo.QueryResult<
  CountStudiesByFilterQuery,
  CountStudiesByFilterQueryVariables
>;
export function refetchCountStudiesByFilterQuery(
  variables?: CountStudiesByFilterQueryVariables,
) {
  return { query: CountStudiesByFilterDocument, variables: variables };
}
export const StudiesByYearDocument = /*#__PURE__*/ gql`
  query StudiesByYear($filters: research_studies_bool_exp = {}) {
    nodes: research_studies(where: $filters, order_by: { year: asc }) {
      id
      year
    }
  }
`;

/**
 * __useStudiesByYearQuery__
 *
 * To run a query within a React component, call `useStudiesByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudiesByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudiesByYearQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStudiesByYearQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StudiesByYearQuery,
    StudiesByYearQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudiesByYearQuery, StudiesByYearQueryVariables>(
    StudiesByYearDocument,
    options,
  );
}
export function useStudiesByYearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudiesByYearQuery,
    StudiesByYearQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudiesByYearQuery, StudiesByYearQueryVariables>(
    StudiesByYearDocument,
    options,
  );
}
export type StudiesByYearQueryHookResult = ReturnType<
  typeof useStudiesByYearQuery
>;
export type StudiesByYearLazyQueryHookResult = ReturnType<
  typeof useStudiesByYearLazyQuery
>;
export type StudiesByYearQueryResult = Apollo.QueryResult<
  StudiesByYearQuery,
  StudiesByYearQueryVariables
>;
export function refetchStudiesByYearQuery(
  variables?: StudiesByYearQueryVariables,
) {
  return { query: StudiesByYearDocument, variables: variables };
}
export const StudiesFilterDocument = /*#__PURE__*/ gql`
  query StudiesFilter(
    $filters: research_studies_bool_exp = {}
    $limit: Int = 10
    $offset: Int = 0
  ) {
    pagination: research_studies_aggregate(where: $filters) {
      aggregate {
        count
      }
    }
    nodes: research_studies(
      limit: $limit
      order_by: { id: desc }
      offset: $offset
      where: $filters
    ) {
      id
      link
      title
    }
  }
`;

/**
 * __useStudiesFilterQuery__
 *
 * To run a query within a React component, call `useStudiesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudiesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudiesFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useStudiesFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StudiesFilterQuery,
    StudiesFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudiesFilterQuery, StudiesFilterQueryVariables>(
    StudiesFilterDocument,
    options,
  );
}
export function useStudiesFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudiesFilterQuery,
    StudiesFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudiesFilterQuery, StudiesFilterQueryVariables>(
    StudiesFilterDocument,
    options,
  );
}
export type StudiesFilterQueryHookResult = ReturnType<
  typeof useStudiesFilterQuery
>;
export type StudiesFilterLazyQueryHookResult = ReturnType<
  typeof useStudiesFilterLazyQuery
>;
export type StudiesFilterQueryResult = Apollo.QueryResult<
  StudiesFilterQuery,
  StudiesFilterQueryVariables
>;
export function refetchStudiesFilterQuery(
  variables?: StudiesFilterQueryVariables,
) {
  return { query: StudiesFilterDocument, variables: variables };
}
export const StudyResultsDocument = /*#__PURE__*/ gql`
  query StudyResults($filters: research_studies_bool_exp = {}) {
    pagination: research_studies_aggregate(
      distinct_on: result
      where: $filters
    ) {
      aggregate {
        count
      }
    }
    nodes: research_studies(
      distinct_on: result
      where: $filters
      order_by: { result: asc }
    ) {
      id
      result
    }
  }
`;

/**
 * __useStudyResultsQuery__
 *
 * To run a query within a React component, call `useStudyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyResultsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStudyResultsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StudyResultsQuery,
    StudyResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyResultsQuery, StudyResultsQueryVariables>(
    StudyResultsDocument,
    options,
  );
}
export function useStudyResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudyResultsQuery,
    StudyResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyResultsQuery, StudyResultsQueryVariables>(
    StudyResultsDocument,
    options,
  );
}
export type StudyResultsQueryHookResult = ReturnType<
  typeof useStudyResultsQuery
>;
export type StudyResultsLazyQueryHookResult = ReturnType<
  typeof useStudyResultsLazyQuery
>;
export type StudyResultsQueryResult = Apollo.QueryResult<
  StudyResultsQuery,
  StudyResultsQueryVariables
>;
export function refetchStudyResultsQuery(
  variables?: StudyResultsQueryVariables,
) {
  return { query: StudyResultsDocument, variables: variables };
}
export const StudyTypesDocument = /*#__PURE__*/ gql`
  query StudyTypes {
    pagination: research_studies_aggregate(distinct_on: typeofstudy) {
      aggregate {
        count
      }
    }
    nodes: research_studies(
      distinct_on: typeofstudy
      order_by: { typeofstudy: asc }
    ) {
      id
      typeofstudy
    }
  }
`;

/**
 * __useStudyTypesQuery__
 *
 * To run a query within a React component, call `useStudyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudyTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StudyTypesQuery,
    StudyTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyTypesQuery, StudyTypesQueryVariables>(
    StudyTypesDocument,
    options,
  );
}
export function useStudyTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudyTypesQuery,
    StudyTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyTypesQuery, StudyTypesQueryVariables>(
    StudyTypesDocument,
    options,
  );
}
export type StudyTypesQueryHookResult = ReturnType<typeof useStudyTypesQuery>;
export type StudyTypesLazyQueryHookResult = ReturnType<
  typeof useStudyTypesLazyQuery
>;
export type StudyTypesQueryResult = Apollo.QueryResult<
  StudyTypesQuery,
  StudyTypesQueryVariables
>;
export function refetchStudyTypesQuery(variables?: StudyTypesQueryVariables) {
  return { query: StudyTypesDocument, variables: variables };
}
